import { jsx as e, jsxs as s, Fragment as he } from "react/jsx-runtime";
import { useMemo as Sn, useState as x, useRef as q, useEffect as V, useCallback as P } from "react";
import { createPortal as Ut } from "react-dom";
function $o(t) {
  var n;
  return ((n = t.userType) == null ? void 0 : n.startsWith("client_")) ?? !1;
}
const gt = "https://app.theonestack.com", Uo = [
  // Core MSP Operations
  { id: "psa", name: "PSA", url: "https://app.theonestack.com/psa", icon: "briefcase", color: "#8b5cf6", launch_status: "ga" },
  { id: "crm", name: "CRM", url: "https://app.theonestack.com/crm", icon: "target", color: "#8b5cf6", launch_status: "ga" },
  { id: "books", name: "Books", url: "https://app.theonestack.com/books", icon: "book-open", color: "#10b981", launch_status: "ga" },
  { id: "voice", name: "Voice", url: "https://app.theonestack.com/voice", icon: "phone", color: "#06b6d4", launch_status: "ga" },
  { id: "projects", name: "Projects", url: "https://app.theonestack.com/projects", icon: "folder-kanban", color: "#8b5cf6", launch_status: "ga" },
  { id: "oncall", name: "On-Call", url: "https://app.theonestack.com/oncall", icon: "bell-ring", color: "#F43F5E", launch_status: "ga" },
  { id: "cmdb", name: "CMDB", url: "https://app.theonestack.com/cmdb", icon: "database", color: "#06B6D4", launch_status: "ga" },
  { id: "canvas", name: "Canvas", url: "https://app.theonestack.com/canvas", icon: "pen-tool", color: "#f59e0b", launch_status: "ga" },
  // Endpoint & Security
  { id: "connect", name: "Connect", url: "https://app.theonestack.com/connect", icon: "monitor-smartphone", color: "#3b82f6", launch_status: "ga" },
  { id: "rmm", name: "RMM", url: "https://app.theonestack.com/rmm", icon: "monitor", color: "#06b6d4", launch_status: "ga" },
  { id: "defend", name: "Defend", url: "https://app.theonestack.com/defend", icon: "shield-alert", color: "#E63946", launch_status: "ga" },
  { id: "security", name: "Security", url: "https://app.theonestack.com/security", icon: "shield-check", color: "#ef4444", launch_status: "ga" },
  { id: "backups", name: "Backups", url: "https://app.theonestack.com/backups", icon: "hard-drive", color: "#10b981", launch_status: "ga" },
  { id: "protect", name: "Protect", url: "https://app.theonestack.com/protect", icon: "shield", color: "#8b5cf6", launch_status: "ga" },
  { id: "compliance", name: "Compliance", url: "https://app.theonestack.com/compliance", icon: "shield", color: "#f59e0b", launch_status: "ga" },
  { id: "soc", name: "SOC", url: "https://app.theonestack.com/soc", icon: "shield-check", color: "#ef4444", launch_status: "ga" },
  // AI & Intelligence
  { id: "theo", name: "THEO", url: "https://app.theonestack.com/theo", icon: "bot", color: "#8b5cf6", launch_status: "ga" },
  { id: "ai", name: "THEO", url: "https://app.theonestack.com/theo", icon: "bot", color: "#818cf8", launch_status: "ga" },
  { id: "agents", name: "Agents", url: "https://app.theonestack.com/agents", icon: "bot", color: "#7c3aed", launch_status: "ga" },
  { id: "ai-studio", name: "AI Studio", url: "https://app.theonestack.com/studio", icon: "sparkles", color: "#6366f1", launch_status: "ga" },
  // People & Field
  { id: "people", name: "People", url: "https://app.theonestack.com/people", icon: "users", color: "#F59E0B", launch_status: "ga" },
  { id: "fleet", name: "Fleet", url: "https://app.theonestack.com/fleet", icon: "truck", color: "#10B981", launch_status: "ga" },
  { id: "visitor", name: "Visitor", url: "https://app.theonestack.com/visitor", icon: "door-open", color: "#0EA5E9", launch_status: "ga" },
  { id: "onsite", name: "Onsite", url: "https://app.theonestack.com/onsite", icon: "map-pin", color: "#f97316", launch_status: "ga" },
  { id: "legal", name: "Legal", url: "https://app.theonestack.com/legal", icon: "scale", color: "#2563eb", launch_status: "ga" },
  // Infrastructure & Integration
  { id: "relay", name: "Relay", url: "https://app.theonestack.com/relay", icon: "mail", color: "#6366f1", launch_status: "ga" },
  { id: "bridge", name: "Bridge", url: "https://app.theonestack.com/bridge", icon: "arrow-left-right", color: "#64748b", launch_status: "ga" },
  { id: "status", name: "Status", url: "https://app.theonestack.com/status", icon: "activity", color: "#2dd4bf", launch_status: "ga" },
  { id: "code", name: "Code", url: "https://app.theonestack.com/code", icon: "shield-check", color: "#06b6d4", launch_status: "ga" },
  { id: "migrate", name: "Migrate", url: "https://app.theonestack.com/migrate", icon: "arrow-right-left", color: "#0891b2", launch_status: "ga" },
  { id: "esign", name: "eSign", url: "https://app.theonestack.com/esign", icon: "file-signature", color: "#10b981", launch_status: "ga" },
  // Content & Media
  { id: "podcast", name: "Podcast", url: "https://app.theonestack.com/podcast", icon: "mic", color: "#8b5cf6", launch_status: "ga" },
  // Community & Giveback
  // collective — REMOVED 2026-04-16: standalone at mspcollective.io; linked in Hub footer
  // mission — REMOVED 2026-04-15: standalone app at app.theonemission.app
  // Vertical SaaS
  // ams — REMOVED 2026-04-15: standalone app at app.theoneams.app
  // build — REMOVED 2026-04-16: standalone app at app.theonebuild.app; linked in Hub footer
  { id: "govwin", name: "GovWin", url: "https://app.theonestack.com/govwin", icon: "award", color: "#1d4ed8", launch_status: "ga" },
  // Streaming & Events
  { id: "livekit", name: "LiveKit", url: "https://app.theonestack.com/livekit", icon: "video", color: "#ec4899", launch_status: "ga" },
  { id: "gather", name: "Gather", url: "https://app.theonestack.com/gather", icon: "users-round", color: "#6366f1", launch_status: "ga" },
  // Hub & Platform
  { id: "hub", name: "Hub", url: "https://app.theonestack.com", icon: "layout-grid", color: "#8b5cf6", launch_status: "ga" },
  { id: "portal", name: "Portal", url: "https://app.theonestack.com/portal", icon: "globe", color: "#ec4899", launch_status: "ga" },
  { id: "ops-center", name: "Ops Center", url: "https://app.theonestack.com/ops", icon: "activity", color: "#818cf8", launch_status: "ga" },
  { id: "workflows", name: "Workflows", url: "https://app.theonestack.com/workflows", icon: "git-branch", color: "#10b981", launch_status: "ga" },
  { id: "clarity", name: "Clarity", url: "https://app.theonestack.com/clarity", icon: "bar-chart-2", color: "#6366f1", launch_status: "ga" },
  { id: "brand", name: "Brand", url: "https://app.theonestack.com/brand", icon: "palette", color: "#e11d48", launch_status: "ga" }
], Tn = {
  info: "#60a5fa",
  success: "#34d399",
  warning: "#fbbf24",
  error: "#f87171"
}, Wo = 48, Fo = `
  .hb-root {
    all: initial;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #f1f5f9;
    box-sizing: border-box;
  }
  .hb-root *, .hb-root *::before, .hb-root *::after {
    box-sizing: inherit;
  }
  .hb-bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 48px;
    background: #09090b;
    border-bottom: 1px solid rgba(255,255,255,0.06);
    display: flex;
    align-items: center;
    padding: 0 12px;
    gap: 8px;
    z-index: 9999;
    -webkit-font-smoothing: antialiased;
  }
  .hb-logo {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 8px;
    flex-shrink: 0;
    text-decoration: none;
    color: #f1f5f9;
  }
  .hb-logo-bird {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    color: #f97316;
  }
  .hb-logo-name {
    font-weight: 600;
    font-size: 13px;
    color: #f1f5f9;
    white-space: nowrap;
  }
  .hb-divider {
    width: 1px;
    height: 24px;
    background: rgba(255,255,255,0.06);
    flex-shrink: 0;
  }

  /* Waffle Button */
  .hb-waffle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s;
    flex-shrink: 0;
    padding: 0;
  }
  .hb-waffle-btn:hover { background: rgba(255,255,255,0.04); }
  .hb-waffle-btn.open { background: rgba(255,255,255,0.06); }

  /* Waffle Grid Panel */
  .hb-waffle-panel {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    width: 380px;
    max-height: 80vh;
    overflow-y: auto;
    background: #09090b;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 12px;
    box-shadow: 0 16px 48px rgba(0,0,0,0.6);
    z-index: 10000;
    padding: 16px;
    animation: hb-panel-slide 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);
  }
  .hb-waffle-header {
    font-size: 13px;
    font-weight: 600;
    color: #8c8c8c;
    margin-bottom: 12px;
  }
  .hb-waffle-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 4px;
  }
  .hb-waffle-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 12px 4px;
    border-radius: 10px;
    cursor: pointer;
    text-decoration: none;
    color: inherit;
    transition: background 0.12s;
  }
  .hb-waffle-tile:hover { background: rgba(255,255,255,0.04); }
  .hb-waffle-tile.inactive { opacity: 0.35; }
  .hb-waffle-tile-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
  }
  .hb-waffle-tile:hover .hb-waffle-tile-icon {
    transform: scale(1.08);
    box-shadow: 0 0 16px currentColor;
  }
  .hb-waffle-tile-icon.current {
    box-shadow: 0 0 0 2px currentColor;
    animation: hb-tile-pulse 2s ease-in-out infinite;
  }
  .hb-waffle-tile-name {
    font-size: 11px;
    font-weight: 500;
    color: #e8eaec;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 72px;
  }
  .hb-waffle-sep {
    height: 1px;
    background: rgba(255,255,255,0.06);
    margin: 12px 0;
    grid-column: 1 / -1;
  }
  .hb-waffle-section-label {
    font-size: 11px;
    font-weight: 600;
    color: #8c8c8c;
    margin-bottom: 8px;
    grid-column: 1 / -1;
  }
  .hb-waffle-explore {
    display: block;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    color: #f97316;
    text-decoration: none;
    padding: 12px 0 4px;
    transition: opacity 0.15s;
  }
  .hb-waffle-explore:hover { opacity: 0.7; }

  /* Product Switcher (legacy text dropdown - now hidden, waffle replaces it) */
  .hb-switcher {
    position: relative;
    flex-shrink: 0;
  }
  .hb-switcher-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background: transparent;
    border: none;
    border-radius: 6px;
    color: #f1f5f9;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s;
    white-space: nowrap;
  }
  .hb-switcher-btn:hover { background: rgba(255,255,255,0.04); }
  .hb-chevron {
    width: 14px;
    height: 14px;
    opacity: 0.6;
    transition: transform 0.2s;
    flex-shrink: 0;
  }
  .hb-chevron.open { transform: rotate(180deg); }
  .hb-product-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  /* Chat button */
  .hb-chat-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    border-radius: 8px;
    color: #94a3b8;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
  }
  .hb-chat-btn:hover { background: rgba(255,255,255,0.04); color: #f1f5f9; }

  /* Search */
  .hb-search-wrap {
    flex: 1;
    max-width: 480px;
    margin: 0 auto;
    position: relative;
  }
  .hb-search-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 7px 12px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 8px;
    color: #64748b;
    font-size: 13px;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
  }
  .hb-search-trigger:hover {
    border-color: rgba(255,255,255,0.1);
    background: rgba(255,255,255,0.06);
  }
  .hb-search-trigger-text { flex: 1; text-align: left; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .hb-kbd {
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
  }
  .hb-kbd kbd {
    display: inline-block;
    padding: 1px 5px;
    background: rgba(255,255,255,0.06);
    border-radius: 4px;
    font-size: 11px;
    font-family: inherit;
    color: #94a3b8;
    border: 1px solid rgba(255,255,255,0.1);
  }

  /* Search Overlay */
  .hb-search-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.6);
    z-index: 10001;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 80px;
    animation: hb-fade-in 0.1s ease;
  }
  .hb-search-modal {
    width: 600px;
    max-width: calc(100vw - 32px);
    background: #09090b;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 12px;
    box-shadow: 0 24px 64px rgba(0,0,0,0.7);
    overflow: hidden;
  }
  .hb-search-input-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 16px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }
  .hb-search-input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: #f1f5f9;
    font-size: 16px;
    font-family: inherit;
    caret-color: #f97316;
  }
  .hb-search-input::placeholder { color: #475569; }
  .hb-search-results {
    max-height: 400px;
    overflow-y: auto;
    padding: 8px;
  }
  .hb-search-results:empty::after {
    content: 'No results';
    display: block;
    text-align: center;
    color: #475569;
    padding: 24px;
    font-size: 13px;
  }
  .hb-search-group-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #475569;
    padding: 8px 8px 4px;
  }
  .hb-search-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 10px;
    border-radius: 7px;
    cursor: pointer;
    transition: background 0.1s;
    text-decoration: none;
    color: inherit;
  }
  .hb-search-item:hover, .hb-search-item.focused {
    background: rgba(255,255,255,0.04);
  }
  .hb-search-item-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: rgba(255,255,255,0.04);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 14px;
  }
  .hb-search-item-body { flex: 1; min-width: 0; }
  .hb-search-item-title {
    font-size: 14px;
    font-weight: 500;
    color: #f1f5f9;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hb-search-item-sub {
    font-size: 12px;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hb-source-badge {
    font-size: 10px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
    background: rgba(255,255,255,0.04);
    color: #94a3b8;
    flex-shrink: 0;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .hb-search-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    color: #475569;
    font-size: 13px;
    gap: 8px;
  }
  .hb-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255,255,255,0.06);
    border-top-color: #f97316;
    border-radius: 50%;
    animation: hb-spin 0.6s linear infinite;
  }
  .hb-search-empty {
    text-align: center;
    padding: 32px 16px;
    color: #475569;
    font-size: 13px;
  }
  .hb-search-empty-hint {
    font-size: 12px;
    color: #334155;
    margin-top: 4px;
  }

  /* Notifications */
  .hb-notif {
    position: relative;
    flex-shrink: 0;
  }
  .hb-notif-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    border-radius: 8px;
    color: #94a3b8;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    position: relative;
  }
  .hb-notif-btn:hover { background: rgba(255,255,255,0.04); color: #f1f5f9; }
  .hb-badge {
    position: absolute;
    top: 4px;
    right: 4px;
    min-width: 16px;
    height: 16px;
    background: #ef4444;
    border-radius: 8px;
    font-size: 10px;
    font-weight: 700;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 3px;
    pointer-events: none;
  }
  .hb-notif-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    width: 360px;
    background: #09090b;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 10px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.5);
    z-index: 10000;
    animation: hb-fade-in 0.12s ease;
    overflow: hidden;
  }
  .hb-notif-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }
  .hb-notif-title {
    font-size: 13px;
    font-weight: 600;
    color: #f1f5f9;
  }
  .hb-notif-mark-read {
    font-size: 12px;
    color: #f97316;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: opacity 0.15s;
  }
  .hb-notif-mark-read:hover { opacity: 0.7; }
  .hb-notif-list {
    max-height: 360px;
    overflow-y: auto;
  }
  .hb-notif-item {
    display: flex;
    align-items: flex-start;
    gap: 0;
    padding: 0;
    position: relative;
    border-bottom: 1px solid rgba(255,255,255,0.03);
    transition: background 0.1s;
  }
  .hb-notif-item:hover { background: rgba(255,255,255,0.04); }
  .hb-notif-item.unread { background: rgba(249,115,22,0.04); }
  .hb-notif-item.unread:hover { background: rgba(249,115,22,0.07); }
  .hb-notif-item-link {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 11px 14px;
    padding-right: 32px;
    flex: 1;
    min-width: 0;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }
  .hb-notif-icon {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-top: 6px;
  }
  .hb-notif-body { flex: 1; min-width: 0; }
  .hb-notif-body-title {
    font-size: 13px;
    font-weight: 500;
    color: #e2e8f0;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .hb-notif-body-text {
    font-size: 12px;
    color: #94a3b8;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hb-notif-group-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    border-radius: 9px;
    background: rgba(249,115,22,0.15);
    color: #fb923c;
    font-size: 10px;
    font-weight: 700;
    padding: 0 4px;
    flex-shrink: 0;
  }
  .hb-notif-meta {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 2px;
  }
  .hb-notif-time {
    font-size: 11px;
    color: #475569;
  }
  .hb-notif-dismiss {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    border-radius: 4px;
    color: #475569;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.15s, background 0.15s, color 0.15s;
  }
  .hb-notif-item:hover .hb-notif-dismiss { opacity: 1; }
  .hb-notif-dismiss:hover { background: rgba(255,255,255,0.06); color: #94a3b8; }
  .hb-notif-empty {
    text-align: center;
    padding: 32px 16px;
    color: #475569;
    font-size: 13px;
  }
  .hb-notif-footer {
    padding: 8px 14px;
    border-top: 1px solid rgba(255,255,255,0.06);
  }
  .hb-notif-footer-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  .hb-notif-mute-group {
    display: flex;
    gap: 6px;
  }
  .hb-notif-mute-btn {
    font-size: 11px;
    color: #64748b;
    background: none;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 4px;
    padding: 3px 8px;
    cursor: pointer;
    transition: color 0.15s, border-color 0.15s;
    font-family: inherit;
  }
  .hb-notif-mute-btn:hover { color: #94a3b8; border-color: rgba(255,255,255,0.12); }
  .hb-notif-settings-link {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #64748b;
    text-decoration: none;
    transition: color 0.15s;
  }
  .hb-notif-settings-link:hover { color: #94a3b8; }

  /* Toast Notifications */
  .hb-toast-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    display: flex;
    flex-direction: column-reverse;
    gap: 8px;
    z-index: 10002;
    pointer-events: none;
  }
  .hb-toast {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    background: #09090b;
    border: 1px solid rgba(255,255,255,0.08);
    border-left: 3px solid #60a5fa;
    border-radius: 10px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.5);
    min-width: 320px;
    max-width: 420px;
    animation: hb-toast-enter 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
    pointer-events: auto;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    color: #e2e8f0;
  }
  .hb-toast-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-top: 4px;
  }
  .hb-toast-body {
    flex: 1;
    min-width: 0;
  }
  .hb-toast-title {
    font-size: 13px;
    font-weight: 600;
    color: #f1f5f9;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hb-toast-text {
    font-size: 12px;
    color: #94a3b8;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hb-toast-link {
    display: inline-block;
    margin-top: 4px;
    font-size: 12px;
    font-weight: 600;
    color: #f97316;
    text-decoration: none;
    transition: opacity 0.15s;
  }
  .hb-toast-link:hover { opacity: 0.7; }
  .hb-toast-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: none;
    border: none;
    border-radius: 4px;
    color: #475569;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s, color 0.15s;
  }
  .hb-toast-close:hover { background: rgba(255,255,255,0.06); color: #94a3b8; }
  @keyframes hb-toast-enter {
    from { opacity: 0; transform: translateY(12px) scale(0.95); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }
  @media (max-width: 480px) {
    .hb-toast-container { left: 8px; right: 8px; }
    .hb-toast { min-width: 0; max-width: 100%; }
  }

  /* Org name chip — shown in bar to left of user menu */
  .hb-org-chip {
    display: flex;
    align-items: center;
    padding: 3px 10px;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    color: rgba(241,245,249,0.6);
    cursor: pointer;
    white-space: nowrap;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: background 0.15s, color 0.15s;
    flex-shrink: 0;
  }
  .hb-org-chip:hover {
    background: rgba(255,255,255,0.09);
    color: rgba(241,245,249,0.9);
  }

  /* User Menu */
  .hb-user {
    position: relative;
    flex-shrink: 0;
  }
  .hb-user-btn {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 4px 8px 4px 4px;
    background: transparent;
    border: none;
    border-radius: 8px;
    color: #f1f5f9;
    cursor: pointer;
    transition: background 0.15s;
  }
  .hb-user-btn:hover { background: rgba(255,255,255,0.04); }
  .hb-avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
  }
  .hb-user-name {
    font-size: 13px;
    font-weight: 500;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hb-user-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    width: 220px;
    background: #09090b;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 10px;
    padding: 6px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.5);
    z-index: 10000;
    animation: hb-fade-in 0.12s ease;
  }
  .hb-user-info {
    padding: 8px 10px 10px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
    margin-bottom: 4px;
  }
  .hb-user-email {
    font-size: 12px;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hb-user-tenant {
    font-size: 11px;
    color: #475569;
    margin-top: 2px;
  }
  .hb-menu-item {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 8px 10px;
    border-radius: 6px;
    color: #94a3b8;
    font-size: 13px;
    cursor: pointer;
    transition: background 0.12s, color 0.12s;
    text-decoration: none;
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    font-family: inherit;
  }
  .hb-menu-item:hover { background: rgba(255,255,255,0.04); color: #f1f5f9; }
  .hb-menu-item.danger { color: #f87171; }
  .hb-menu-item.danger:hover { background: #2d1515; color: #fca5a5; }
  .hb-menu-sep {
    height: 1px;
    background: rgba(255,255,255,0.06);
    margin: 4px 0;
  }
  .hb-add-product {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 8px;
    border-radius: 6px;
    color: #f97316;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.12s;
    text-decoration: none;
  }
  .hb-add-product:hover { background: rgba(255,255,255,0.04); }

  /* Reduce motion */
  @media (prefers-reduced-motion: reduce) {
    .hb-waffle-tile,
    .hb-waffle-panel,
    .hb-notif-dropdown,
    .hb-user-dropdown,
    .hb-sp-panel,
    .hb-jv-panel {
      animation: none !important;
      opacity: 1 !important;
    }
    .hb-waffle-tile-icon { transition: none !important; }
    .hb-waffle-tile-icon.current { animation: none !important; }
  }

  /* Responsive */
  @media (max-width: 900px) {
    .hb-kbd { display: none; }
  }
  @media (max-width: 640px) {
    .hb-search-wrap { display: none; }
    .hb-logo-name { display: none; }
    .hb-user-name { display: none; }
    .hb-org-chip { display: none; }
    .hb-waffle-panel { width: 100vw; border-radius: 0; }
  }

  /* Animations */
  /* Tile stagger animation */
  .hb-waffle-tile {
    opacity: 0;
    animation: hb-tile-enter 0.2s ease forwards;
  }
  .hb-waffle-tile:nth-child(1) { animation-delay: 0ms; }
  .hb-waffle-tile:nth-child(2) { animation-delay: 30ms; }
  .hb-waffle-tile:nth-child(3) { animation-delay: 60ms; }
  .hb-waffle-tile:nth-child(4) { animation-delay: 90ms; }
  .hb-waffle-tile:nth-child(5) { animation-delay: 120ms; }
  .hb-waffle-tile:nth-child(6) { animation-delay: 150ms; }
  .hb-waffle-tile:nth-child(7) { animation-delay: 180ms; }
  .hb-waffle-tile:nth-child(8) { animation-delay: 210ms; }
  .hb-waffle-tile:nth-child(9) { animation-delay: 240ms; }
  .hb-waffle-tile:nth-child(10) { animation-delay: 270ms; }
  .hb-waffle-tile:nth-child(11) { animation-delay: 300ms; }
  .hb-waffle-tile:nth-child(12) { animation-delay: 330ms; }
  .hb-waffle-tile:nth-child(n+13) { animation-delay: 360ms; }

  @keyframes hb-tile-enter {
    from { opacity: 0; transform: scale(0.9); }
    to   { opacity: 1; transform: scale(1); }
  }
  @keyframes hb-tile-pulse {
    0%, 100% { box-shadow: 0 0 0 2px currentColor; }
    50% { box-shadow: 0 0 12px currentColor, 0 0 0 2px currentColor; }
  }
  @keyframes hb-panel-slide {
    from { opacity: 0; transform: translateY(-8px) scale(0.97); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes hb-fade-in {
    from { opacity: 0; transform: translateY(-4px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes hb-spin {
    to { transform: rotate(360deg); }
  }
  @keyframes hb-sp-slide-in {
    from { transform: translateX(100%); opacity: 0; }
    to   { transform: translateX(0); opacity: 1; }
  }

  /* ── Support Panel ─────────────────────────────────────────────────── */

  /* Overlay */
  .hb-sp-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    z-index: 10010;
    animation: hb-fade-in 0.15s ease;
  }

  /* Panel */
  .hb-sp-panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 420px;
    max-width: 100vw;
    background: #0f0f11;
    border-left: 1px solid rgba(255,255,255,0.07);
    box-shadow: -16px 0 48px rgba(0,0,0,0.6);
    display: flex;
    flex-direction: column;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #e2e8f0;
    -webkit-font-smoothing: antialiased;
    z-index: 10011;
    animation: hb-sp-slide-in 0.2s ease;
  }
  .hb-sp-panel *, .hb-sp-panel *::before, .hb-sp-panel *::after {
    box-sizing: border-box;
  }

  /* Header */
  .hb-sp-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 14px;
    height: 52px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    flex-shrink: 0;
  }
  .hb-sp-header-title {
    font-size: 15px;
    font-weight: 600;
    color: #f1f5f9;
    flex: 1;
  }
  .hb-sp-back-btn {
    background: none;
    border: none;
    color: #f97316;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    padding: 4px 8px 4px 0;
    font-family: inherit;
    flex-shrink: 0;
    transition: opacity 0.15s;
  }
  .hb-sp-back-btn:hover { opacity: 0.7; }
  .hb-sp-close-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: none;
    border: none;
    border-radius: 6px;
    color: #64748b;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    flex-shrink: 0;
    margin-left: auto;
  }
  .hb-sp-close-btn:hover { background: rgba(255,255,255,0.06); color: #f1f5f9; }

  /* Scrollable content area */
  .hb-sp-content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .hb-sp-content::-webkit-scrollbar { width: 4px; }
  .hb-sp-content::-webkit-scrollbar-track { background: transparent; }
  .hb-sp-content::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 2px; }

  /* Hub page */
  .hb-sp-hub { padding: 20px 16px; }
  .hb-sp-hub-header { margin-bottom: 20px; }
  .hb-sp-hub-title {
    font-size: 20px;
    font-weight: 700;
    color: #f1f5f9;
    margin-bottom: 4px;
  }
  .hb-sp-hub-sub { font-size: 13px; color: #64748b; }
  .hb-sp-hub-grid {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 20px;
  }
  .hb-sp-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
    padding: 14px 16px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 10px;
    cursor: pointer;
    text-align: left;
    transition: background 0.15s, border-color 0.15s;
    font-family: inherit;
    width: 100%;
  }
  .hb-sp-card:hover { background: rgba(249,115,22,0.06); border-color: rgba(249,115,22,0.25); }
  .hb-sp-card-label { font-size: 14px; font-weight: 600; color: #f1f5f9; }
  .hb-sp-card-desc { font-size: 12px; color: #64748b; }
  .hb-sp-hub-links { display: flex; flex-direction: column; }
  .hb-sp-link-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 4px;
    border-bottom: 1px solid rgba(255,255,255,0.05);
    cursor: pointer;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    color: #94a3b8;
    font-size: 13px;
    font-weight: 500;
    font-family: inherit;
    text-align: left;
    width: 100%;
    transition: color 0.15s;
  }
  .hb-sp-link-item:last-child { border-bottom: none; }
  .hb-sp-link-item:hover { color: #f1f5f9; }
  .hb-sp-chevron { font-size: 18px; color: #475569; }
  .hb-sp-section-label {
    font-size: 11px; font-weight: 600; text-transform: uppercase;
    letter-spacing: 0.05em; color: #475569; padding: 4px 0 6px;
  }

  /* Forms */
  .hb-sp-form-page { padding: 16px; display: flex; flex-direction: column; gap: 14px; }
  .hb-sp-field { display: flex; flex-direction: column; gap: 6px; }
  .hb-sp-label { font-size: 12px; font-weight: 600; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.04em; }
  .hb-sp-input {
    width: 100%;
    padding: 8px 10px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 8px;
    color: #f1f5f9;
    font-size: 14px;
    font-family: inherit;
    outline: none;
    transition: border-color 0.15s;
  }
  .hb-sp-input:focus { border-color: #f97316; }
  .hb-sp-input::placeholder { color: #475569; }
  .hb-sp-textarea {
    width: 100%;
    padding: 8px 10px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 8px;
    color: #f1f5f9;
    font-size: 14px;
    font-family: inherit;
    outline: none;
    resize: vertical;
    min-height: 80px;
    transition: border-color 0.15s;
  }
  .hb-sp-textarea:focus { border-color: #f97316; }
  .hb-sp-textarea::placeholder { color: #475569; }
  .hb-sp-char-count { font-size: 11px; color: #475569; text-align: right; }
  .hb-sp-type-row { display: flex; gap: 6px; flex-wrap: wrap; }
  .hb-sp-type-btn {
    padding: 5px 12px;
    border-radius: 6px;
    border: 1px solid rgba(255,255,255,0.1);
    background: transparent;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s;
  }
  .hb-sp-type-btn:hover { border-color: rgba(255,255,255,0.2); color: #f1f5f9; }
  .hb-sp-type-btn.active { background: #f97316; border-color: #f97316; color: #fff; }
  .hb-sp-chip-row { display: flex; gap: 6px; flex-wrap: wrap; }
  .hb-sp-chip {
    padding: 4px 10px;
    border-radius: 20px;
    border: 1px solid rgba(255,255,255,0.1);
    background: transparent;
    color: #94a3b8;
    font-size: 12px;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s;
  }
  .hb-sp-chip:hover { border-color: rgba(255,255,255,0.2); color: #f1f5f9; }
  .hb-sp-chip.active { background: rgba(249,115,22,0.15); border-color: #f97316; color: #fb923c; }
  .hb-sp-error { font-size: 13px; color: #f87171; padding: 8px 12px; background: rgba(239,68,68,0.08); border-radius: 8px; border: 1px solid rgba(239,68,68,0.2); }

  /* Buttons */
  .hb-sp-btn {
    padding: 9px 18px;
    border-radius: 8px;
    border: none;
    font-size: 14px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: opacity 0.15s, background 0.15s;
    width: 100%;
  }
  .hb-sp-btn:disabled { opacity: 0.4; cursor: not-allowed; }
  .hb-sp-btn-primary { background: #f97316; color: #fff; }
  .hb-sp-btn-primary:hover:not(:disabled) { background: #ea6c0c; }
  .hb-sp-btn-secondary { background: rgba(255,255,255,0.06); color: #f1f5f9; }
  .hb-sp-btn-secondary:hover:not(:disabled) { background: rgba(255,255,255,0.09); }
  .hb-sp-btn-ghost { background: none; color: #64748b; }
  .hb-sp-btn-ghost:hover:not(:disabled) { color: #94a3b8; }

  /* Success state */
  .hb-sp-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 40px 24px;
    text-align: center;
  }
  .hb-sp-success-icon {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: rgba(34,197,94,0.12);
    border: 2px solid #22c55e;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #22c55e;
  }
  .hb-sp-success-title { font-size: 18px; font-weight: 700; color: #f1f5f9; }
  .hb-sp-success-num { font-size: 13px; color: #64748b; }
  .hb-sp-success-actions { display: flex; flex-direction: column; gap: 8px; width: 100%; margin-top: 8px; }

  /* List pages */
  .hb-sp-list-page { padding: 12px 0; }
  .hb-sp-filter-row { display: flex; gap: 6px; padding: 4px 16px 12px; flex-wrap: wrap; }
  .hb-sp-filter-btn {
    padding: 4px 12px;
    border-radius: 20px;
    border: 1px solid rgba(255,255,255,0.1);
    background: transparent;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s;
  }
  .hb-sp-filter-btn:hover { border-color: rgba(255,255,255,0.2); color: #f1f5f9; }
  .hb-sp-filter-btn.active { background: rgba(249,115,22,0.12); border-color: #f97316; color: #fb923c; }
  .hb-sp-filter-btn-new { color: #f97316; border-color: rgba(249,115,22,0.3); margin-left: auto; }
  .hb-sp-filter-btn-new:hover { background: rgba(249,115,22,0.08); }
  .hb-sp-list { display: flex; flex-direction: column; }
  .hb-sp-list-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 13px 16px;
    cursor: pointer;
    background: none;
    border: none;
    border-bottom: 1px solid rgba(255,255,255,0.04);
    text-align: left;
    font-family: inherit;
    transition: background 0.1s;
    width: 100%;
  }
  .hb-sp-list-item:hover { background: rgba(255,255,255,0.03); }

  /* Ticket list */
  .hb-sp-ticket-top { display: flex; align-items: center; justify-content: space-between; }
  .hb-sp-ticket-num { font-size: 11px; font-weight: 700; color: #64748b; font-family: monospace; }
  .hb-sp-ticket-title { font-size: 14px; color: #e2e8f0; font-weight: 500; }
  .hb-sp-ticket-meta { font-size: 11px; color: #475569; }
  .hb-sp-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    background: rgba(255,255,255,0.06);
    color: #94a3b8;
  }

  /* Ticket detail */
  .hb-sp-detail-page { padding: 16px; display: flex; flex-direction: column; gap: 12px; }
  .hb-sp-detail-header { display: flex; align-items: center; gap: 8px; }
  .hb-sp-detail-title { font-size: 17px; font-weight: 700; color: #f1f5f9; }
  .hb-sp-detail-desc { font-size: 13px; color: #94a3b8; white-space: pre-wrap; }
  .hb-sp-activity { display: flex; flex-direction: column; gap: 0; }
  .hb-sp-activity-title { font-size: 12px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 8px; }
  .hb-sp-activity-item {
    padding: 10px 0;
    border-top: 1px solid rgba(255,255,255,0.05);
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  .hb-sp-activity-actor { font-size: 12px; font-weight: 600; color: #94a3b8; }
  .hb-sp-activity-content { font-size: 13px; color: #e2e8f0; white-space: pre-wrap; }
  .hb-sp-activity-time { font-size: 11px; color: #475569; }
  .hb-sp-reply { display: flex; flex-direction: column; gap: 8px; padding-top: 8px; border-top: 1px solid rgba(255,255,255,0.07); }

  /* Changelog */
  .hb-sp-release { padding: 16px; border-bottom: 1px solid rgba(255,255,255,0.05); }
  .hb-sp-release-header { display: flex; align-items: center; gap: 8px; margin-bottom: 4px; }
  .hb-sp-release-ver { font-size: 12px; font-weight: 700; color: #f97316; font-family: monospace; }
  .hb-sp-release-date { font-size: 11px; color: #475569; }
  .hb-sp-release-title { font-size: 15px; font-weight: 600; color: #f1f5f9; margin-bottom: 6px; }
  .hb-sp-release-notes { font-size: 13px; color: #94a3b8; white-space: pre-wrap; }

  /* Features */
  .hb-sp-feature-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    border-bottom: 1px solid rgba(255,255,255,0.04);
  }
  .hb-sp-feature-body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
  .hb-sp-feature-title { font-size: 14px; font-weight: 600; color: #e2e8f0; }
  .hb-sp-feature-desc { font-size: 12px; color: #64748b; }
  .hb-sp-vote-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 6px 10px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.1);
    background: transparent;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s;
    flex-shrink: 0;
  }
  .hb-sp-vote-btn:hover { border-color: #f97316; color: #f97316; }
  .hb-sp-vote-btn.voted { background: rgba(249,115,22,0.1); border-color: #f97316; color: #fb923c; }
  .hb-sp-vote-btn:disabled { opacity: 0.5; cursor: not-allowed; }

  /* KB */
  .hb-sp-search-row { padding: 12px 16px 8px; }
  .hb-sp-kb-cats { display: flex; flex-direction: column; }
  .hb-sp-kb-cat {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 16px;
    border-bottom: 1px solid rgba(255,255,255,0.04);
    cursor: pointer;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    color: #e2e8f0;
    font-size: 14px;
    font-weight: 500;
    font-family: inherit;
    text-align: left;
    width: 100%;
    transition: background 0.1s;
  }
  .hb-sp-kb-cat:hover { background: rgba(255,255,255,0.03); }
  .hb-sp-kb-cat-count {
    font-size: 12px;
    color: #475569;
    background: rgba(255,255,255,0.04);
    padding: 2px 8px;
    border-radius: 12px;
  }

  /* KB article content */
  .hb-sp-article-content { font-size: 14px; color: #cbd5e1; line-height: 1.7; }
  .hb-sp-article-content h1,
  .hb-sp-article-content h2,
  .hb-sp-article-content h3 { color: #f1f5f9; margin: 16px 0 8px; font-weight: 600; }
  .hb-sp-article-content h1 { font-size: 20px; }
  .hb-sp-article-content h2 { font-size: 17px; }
  .hb-sp-article-content h3 { font-size: 15px; }
  .hb-sp-article-content p { margin: 0 0 12px; }
  .hb-sp-article-content ul,
  .hb-sp-article-content ol { padding-left: 20px; margin: 0 0 12px; }
  .hb-sp-article-content li { margin-bottom: 4px; }
  .hb-sp-article-content code {
    background: rgba(255,255,255,0.06);
    padding: 1px 5px;
    border-radius: 4px;
    font-size: 12px;
    font-family: 'Fira Code', 'Cascadia Code', monospace;
  }
  .hb-sp-article-content pre {
    background: rgba(0,0,0,0.4);
    padding: 12px;
    border-radius: 8px;
    overflow-x: auto;
    margin: 0 0 12px;
    font-size: 12px;
  }
  .hb-sp-article-content a { color: #f97316; text-decoration: none; }
  .hb-sp-article-content a:hover { text-decoration: underline; }
  .hb-sp-article-content blockquote {
    border-left: 3px solid rgba(249,115,22,0.4);
    margin: 0 0 12px;
    padding: 8px 12px;
    color: #94a3b8;
  }

  /* Loading / empty / skeleton */
  .hb-sp-loading { padding: 32px 16px; text-align: center; font-size: 13px; color: #475569; }
  .hb-sp-empty { padding: 40px 16px; display: flex; flex-direction: column; align-items: center; gap: 12px; }
  .hb-sp-empty-text { font-size: 14px; color: #475569; text-align: center; }
  .hb-sp-skeleton {
    height: 68px;
    background: linear-gradient(90deg, rgba(255,255,255,0.03) 25%, rgba(255,255,255,0.06) 50%, rgba(255,255,255,0.03) 75%);
    background-size: 200% 100%;
    animation: hb-sp-shimmer 1.4s infinite;
    border-radius: 8px;
    margin: 6px 16px;
  }
  @keyframes hb-sp-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  /* Responsive */
  @media (max-width: 480px) {
    .hb-sp-panel { width: 100vw; }
  }

  /* ── Jarvis AI Assistant ────────────────────────────────────────────────── */

  /* Trigger button */
  .hb-jv-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    border-radius: 8px;
    color: #94a3b8;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    position: relative;
  }
  .hb-jv-btn:hover { background: rgba(255,255,255,0.04); color: #f97316; }
  .hb-jv-btn.active { color: #f97316; background: rgba(249,115,22,0.08); }
  .hb-jv-btn.pulse::after {
    content: '';
    position: absolute;
    top: 4px;
    right: 4px;
    width: 8px;
    height: 8px;
    background: #f97316;
    border-radius: 50%;
    animation: hb-jv-pulse 2s ease-in-out infinite;
  }
  @keyframes hb-jv-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.5; transform: scale(1.3); }
  }

  /* Overlay */
  .hb-jv-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    z-index: 10010;
    animation: hb-fade-in 0.15s ease;
  }

  /* Panel */
  .hb-jv-panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 400px;
    max-width: 100vw;
    background: #0f0f11;
    border-left: 1px solid rgba(255,255,255,0.07);
    box-shadow: -16px 0 48px rgba(0,0,0,0.6);
    display: flex;
    flex-direction: column;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #e2e8f0;
    -webkit-font-smoothing: antialiased;
    z-index: 10011;
    animation: hb-sp-slide-in 0.2s ease;
  }
  .hb-jv-panel *, .hb-jv-panel *::before, .hb-jv-panel *::after {
    box-sizing: border-box;
  }

  /* Header */
  .hb-jv-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;
    height: 52px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    flex-shrink: 0;
  }
  .hb-jv-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .hb-jv-header-title {
    font-size: 15px;
    font-weight: 600;
    color: #f1f5f9;
  }
  .hb-jv-model-badge {
    font-size: 10px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
    background: rgba(249,115,22,0.1);
    color: #fb923c;
    letter-spacing: 0.02em;
  }
  .hb-jv-header-right {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .hb-jv-clear-btn {
    font-size: 12px;
    color: #64748b;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    font-family: inherit;
    transition: color 0.15s, background 0.15s;
  }
  .hb-jv-clear-btn:hover { color: #94a3b8; background: rgba(255,255,255,0.04); }
  .hb-jv-close-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: none;
    border: none;
    border-radius: 6px;
    color: #64748b;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
  }
  .hb-jv-close-btn:hover { background: rgba(255,255,255,0.06); color: #f1f5f9; }

  /* Messages area */
  .hb-jv-messages {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 16px 14px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .hb-jv-messages::-webkit-scrollbar { width: 4px; }
  .hb-jv-messages::-webkit-scrollbar-track { background: transparent; }
  .hb-jv-messages::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 2px; }

  /* Welcome state */
  .hb-jv-welcome {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 40px 16px 20px;
    gap: 12px;
  }
  .hb-jv-welcome-icon {
    width: 56px;
    height: 56px;
    border-radius: 16px;
    background: rgba(249,115,22,0.08);
    border: 1px solid rgba(249,115,22,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hb-jv-welcome-title {
    font-size: 18px;
    font-weight: 700;
    color: #f1f5f9;
  }
  .hb-jv-welcome-sub {
    font-size: 13px;
    color: #64748b;
    max-width: 280px;
    line-height: 1.5;
  }
  .hb-jv-welcome-context {
    font-size: 11px;
    color: #475569;
    padding: 4px 10px;
    background: rgba(255,255,255,0.03);
    border-radius: 6px;
    margin-top: 4px;
  }
  .hb-jv-welcome-context strong { color: #94a3b8; }

  /* Message layout */
  .hb-jv-msg { display: flex; gap: 8px; }
  .hb-jv-msg-user { justify-content: flex-end; }
  .hb-jv-msg-assistant { justify-content: flex-start; align-items: flex-start; }

  .hb-jv-avatar {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: rgba(249,115,22,0.08);
    border: 1px solid rgba(249,115,22,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .hb-jv-bubble-wrap {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: calc(100% - 40px);
    min-width: 0;
  }

  /* Bubbles */
  .hb-jv-bubble {
    padding: 10px 14px;
    border-radius: 12px;
    font-size: 13px;
    line-height: 1.6;
    word-break: break-word;
  }
  .hb-jv-bubble-user {
    background: #f97316;
    color: #fff;
    border-bottom-right-radius: 4px;
    max-width: 280px;
  }
  .hb-jv-bubble-assistant {
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.06);
    color: #e2e8f0;
    border-bottom-left-radius: 4px;
  }
  .hb-jv-bubble-assistant.error {
    border-color: rgba(248,113,113,0.2);
    background: rgba(248,113,113,0.06);
    color: #fca5a5;
  }

  /* Markdown content in assistant bubbles */
  .hb-jv-bubble-assistant strong { color: #f1f5f9; }
  .hb-jv-bubble-assistant em { font-style: italic; color: #cbd5e1; }
  .hb-jv-inline-code {
    background: rgba(255,255,255,0.06);
    padding: 1px 5px;
    border-radius: 4px;
    font-size: 12px;
    font-family: 'Fira Code', 'Cascadia Code', monospace;
  }
  .hb-jv-code-block {
    background: rgba(0,0,0,0.4);
    padding: 10px 12px;
    border-radius: 6px;
    overflow-x: auto;
    margin: 6px 0;
    font-size: 12px;
    font-family: 'Fira Code', 'Cascadia Code', monospace;
    line-height: 1.5;
  }
  .hb-jv-code-block code { background: none; padding: 0; }
  .hb-jv-link { color: #f97316; text-decoration: none; }
  .hb-jv-link:hover { text-decoration: underline; }
  .hb-jv-list {
    padding-left: 16px;
    margin: 4px 0;
    list-style-type: disc;
  }
  .hb-jv-list li { margin-bottom: 2px; }

  /* Tool calls */
  .hb-jv-tool-calls {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .hb-jv-tool-call {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    background: rgba(255,255,255,0.02);
    border: 1px solid rgba(255,255,255,0.05);
    border-radius: 8px;
    font-size: 12px;
    color: #94a3b8;
  }
  .hb-jv-tool-call.running { border-color: rgba(249,115,22,0.15); }
  .hb-jv-tool-call.error { border-color: rgba(248,113,113,0.15); }
  .hb-jv-tool-icon {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 11px;
  }
  .hb-jv-tool-spinner {
    width: 12px;
    height: 12px;
    border: 2px solid rgba(249,115,22,0.2);
    border-top-color: #f97316;
    border-radius: 50%;
    animation: hb-spin 0.6s linear infinite;
  }
  .hb-jv-tool-label { font-weight: 500; }
  .hb-jv-tool-summary { color: #64748b; margin-left: auto; }

  /* Typing indicator */
  .hb-jv-typing {
    display: inline-flex;
    gap: 4px;
    padding: 4px 0;
  }
  .hb-jv-typing span {
    width: 6px;
    height: 6px;
    background: #64748b;
    border-radius: 50%;
    animation: hb-jv-typing-bounce 1.4s ease-in-out infinite;
  }
  .hb-jv-typing span:nth-child(2) { animation-delay: 0.16s; }
  .hb-jv-typing span:nth-child(3) { animation-delay: 0.32s; }
  @keyframes hb-jv-typing-bounce {
    0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
    40% { transform: scale(1); opacity: 1; }
  }

  /* Quick actions */
  .hb-jv-quick-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 0 14px 12px;
    flex-shrink: 0;
  }
  .hb-jv-quick-chip {
    padding: 6px 12px;
    border-radius: 20px;
    border: 1px solid rgba(255,255,255,0.08);
    background: transparent;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s;
    white-space: nowrap;
  }
  .hb-jv-quick-chip:hover {
    border-color: rgba(249,115,22,0.3);
    color: #fb923c;
    background: rgba(249,115,22,0.06);
  }
  .hb-jv-quick-chip:disabled { opacity: 0.4; cursor: not-allowed; }

  /* Input area */
  .hb-jv-input-area {
    border-top: 1px solid rgba(255,255,255,0.07);
    padding: 12px 14px;
    flex-shrink: 0;
  }
  .hb-jv-input-row {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 12px;
    padding: 8px 8px 8px 14px;
    transition: border-color 0.15s;
  }
  .hb-jv-input-row:focus-within {
    border-color: rgba(249,115,22,0.4);
  }
  .hb-jv-input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: #f1f5f9;
    font-size: 13px;
    font-family: inherit;
    resize: none;
    max-height: 120px;
    line-height: 1.5;
    caret-color: #f97316;
  }
  .hb-jv-input::placeholder { color: #475569; }
  .hb-jv-input:disabled { opacity: 0.5; }
  .hb-jv-send-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: #f97316;
    border: none;
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s, opacity 0.15s;
  }
  .hb-jv-send-btn:hover { background: #ea6c0c; }
  .hb-jv-send-btn:disabled { opacity: 0.3; cursor: not-allowed; }
  .hb-jv-stop-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: rgba(248,113,113,0.12);
    border: 1px solid rgba(248,113,113,0.3);
    border-radius: 8px;
    color: #f87171;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s;
  }
  .hb-jv-stop-btn:hover { background: rgba(248,113,113,0.2); }
  .hb-jv-stop-icon {
    display: block;
    width: 10px;
    height: 10px;
    background: #f87171;
    border-radius: 2px;
  }

  /* Input hint */
  .hb-jv-input-hint {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 2px 0;
  }
  .hb-jv-kbd-hint {
    display: flex;
    align-items: center;
    gap: 2px;
    font-size: 11px;
    color: #334155;
  }
  .hb-jv-kbd-hint kbd {
    display: inline-block;
    padding: 0px 4px;
    background: rgba(255,255,255,0.04);
    border-radius: 3px;
    font-size: 10px;
    font-family: inherit;
    color: #475569;
    border: 1px solid rgba(255,255,255,0.06);
  }
  .hb-jv-powered {
    font-size: 11px;
    color: #334155;
  }

  /* ── Voice Chat ─────────────────────────────────────────────────────────── */

  /* Mic button — sits left of send button in input row */
  .hb-jv-mic-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: transparent;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 8px;
    color: #94a3b8;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s, color 0.15s, border-color 0.15s, box-shadow 0.15s;
    position: relative;
  }
  .hb-jv-mic-btn:hover:not(.disabled):not(:disabled) {
    background: rgba(255,255,255,0.04);
    color: #f1f5f9;
    border-color: rgba(255,255,255,0.15);
  }
  .hb-jv-mic-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
  .hb-jv-mic-btn.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  .hb-jv-mic-btn.disabled:hover {
    background: transparent;
    color: #94a3b8;
  }

  /* Recording state — pulsing red ring */
  .hb-jv-mic-btn.recording {
    color: #f87171;
    border-color: #f87171;
    background: rgba(248,113,113,0.1);
    box-shadow: 0 0 0 0 rgba(248,113,113,0.4);
    animation: hb-mic-pulse 1.5s ease-in-out infinite;
  }

  /* Processing state — spinner overlay */
  .hb-jv-mic-btn.processing {
    color: #f97316;
    border-color: rgba(249,115,22,0.3);
    background: rgba(249,115,22,0.08);
    animation: hb-mic-spin-border 1s linear infinite;
  }

  /* Playing state — gentle glow */
  .hb-jv-mic-btn.playing {
    color: #34d399;
    border-color: rgba(52,211,153,0.3);
    background: rgba(52,211,153,0.08);
    animation: hb-mic-glow 2s ease-in-out infinite;
  }

  @keyframes hb-mic-pulse {
    0% { box-shadow: 0 0 0 0 rgba(248,113,113,0.4); }
    70% { box-shadow: 0 0 0 6px rgba(248,113,113,0); }
    100% { box-shadow: 0 0 0 0 rgba(248,113,113,0); }
  }

  @keyframes hb-mic-spin-border {
    0% { border-color: rgba(249,115,22,0.3); }
    50% { border-color: rgba(249,115,22,0.7); }
    100% { border-color: rgba(249,115,22,0.3); }
  }

  @keyframes hb-mic-glow {
    0%, 100% { box-shadow: 0 0 4px rgba(52,211,153,0.2); }
    50% { box-shadow: 0 0 8px rgba(52,211,153,0.4); }
  }

  /* Voice session indicator bar */
  .hb-jv-voice-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    margin-bottom: 8px;
    background: rgba(249,115,22,0.06);
    border: 1px solid rgba(249,115,22,0.12);
    border-radius: 8px;
    font-size: 12px;
    color: #94a3b8;
  }
  .hb-jv-voice-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #f97316;
    animation: hb-mic-pulse 1.5s ease-in-out infinite;
    flex-shrink: 0;
  }
  .hb-jv-voice-end {
    margin-left: auto;
    padding: 2px 8px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 4px;
    color: #94a3b8;
    font-size: 11px;
    cursor: pointer;
    transition: background 0.15s;
  }
  .hb-jv-voice-end:hover {
    background: rgba(255,255,255,0.1);
    color: #f1f5f9;
  }

  /* Voice error toast */
  .hb-jv-voice-toast {
    margin: 0 14px 8px;
    padding: 8px 12px;
    background: rgba(248,113,113,0.1);
    border: 1px solid rgba(248,113,113,0.2);
    border-radius: 8px;
    font-size: 12px;
    color: #f87171;
  }

  /* Jarvis responsive */
  @media (max-width: 480px) {
    .hb-jv-panel { width: 100vw; }
  }

  /* Reduce motion for Jarvis */
  @media (prefers-reduced-motion: reduce) {
    .hb-jv-panel { animation: none !important; }
    .hb-jv-typing span { animation: none !important; opacity: 0.6; }
    .hb-jv-tool-spinner { animation: none !important; }
    .hb-jv-btn.pulse::after { animation: none !important; }
    .hb-jv-mic-btn.recording { animation: none !important; box-shadow: 0 0 0 2px rgba(248,113,113,0.4); }
    .hb-jv-mic-btn.processing { animation: none !important; }
    .hb-jv-mic-btn.playing { animation: none !important; }
    .hb-jv-voice-dot { animation: none !important; }
  }

  /* ── Hub Global Tasks Panel ───────────────────────────────────────────────── */
  .hb-tasks-btn {
    position: relative; display: flex; align-items: center; justify-content: center;
    width: 32px; height: 32px; border-radius: 6px; border: none; cursor: pointer;
    background: transparent; color: #94a3b8; transition: background 0.15s, color 0.15s;
    flex-shrink: 0;
  }
  .hb-tasks-btn:hover, .hb-tasks-btn.active { background: rgba(255,255,255,0.06); color: #f1f5f9; }
  .hb-tasks-badge {
    position: absolute; top: 2px; right: 2px;
    min-width: 16px; height: 16px; padding: 0 4px; border-radius: 8px;
    background: #ef4444; color: #fff; font-size: 10px; font-weight: 700;
    display: flex; align-items: center; justify-content: center; pointer-events: none;
  }
  .hb-tasks-panel { width: 560px; display: flex; flex-direction: column; padding: 0; }
  .hb-task-header-badge {
    display: inline-flex; align-items: center; justify-content: center;
    min-width: 18px; height: 18px; padding: 0 5px; border-radius: 9px;
    background: #ef4444; color: #fff; font-size: 11px; font-weight: 700; margin-left: 8px;
  }
  .hb-task-full-link { font-size: 12px; color: #64748b; text-decoration: none; white-space: nowrap; }
  .hb-task-full-link:hover { color: #94a3b8; }
  .hb-task-quickadd {
    padding: 8px 16px; border-bottom: 1px solid rgba(255,255,255,0.06);
    display: flex; flex-direction: column; gap: 6px;
  }
  .hb-task-quickadd-row { display: flex; align-items: center; gap: 8px; }
  .hb-task-quickadd-input {
    flex: 1; background: transparent; border: none; outline: none;
    color: #f1f5f9; font-size: 13px; font-family: inherit;
  }
  .hb-task-quickadd-input::placeholder { color: #475569; }
  .hb-task-quickadd-btn {
    padding: 2px 10px; border-radius: 4px; border: none; cursor: pointer;
    background: rgba(249,115,22,0.15); color: #f97316; font-size: 12px; font-weight: 500;
  }
  .hb-task-quickadd-btn:hover { background: rgba(249,115,22,0.25); }
  .hb-task-quickadd-area {
    background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
    border-radius: 4px; color: #94a3b8; font-size: 12px; padding: 3px 6px; outline: none; font-family: inherit;
  }
  .hb-tasks-body { flex: 1; display: flex; overflow: hidden; }
  .hb-tasks-sidebar {
    width: 140px; flex-shrink: 0; border-right: 1px solid rgba(255,255,255,0.06);
    padding: 8px 0; overflow-y: auto;
  }
  .hb-tasks-sidebar-section { padding: 0 8px; }
  .hb-tasks-sidebar-divider { height: 1px; background: rgba(255,255,255,0.06); margin: 8px 0; }
  .hb-tasks-sidebar-label {
    font-size: 10px; font-weight: 600; text-transform: uppercase;
    color: #475569; letter-spacing: 0.06em; padding: 4px 8px;
  }
  .hb-tasks-view-btn {
    display: flex; align-items: center; gap: 6px; width: 100%;
    padding: 5px 8px; border-radius: 5px; border: none; cursor: pointer;
    background: transparent; color: #94a3b8; font-size: 12px; text-align: left;
    font-family: inherit; transition: background 0.1s, color 0.1s;
  }
  .hb-tasks-view-btn:hover { background: rgba(255,255,255,0.04); color: #f1f5f9; }
  .hb-tasks-view-btn.active { background: rgba(249,115,22,0.1); color: #f97316; }
  .hb-task-view-count {
    margin-left: auto; min-width: 18px; height: 16px; padding: 0 4px;
    border-radius: 8px; background: #ef444433; color: #ef4444;
    font-size: 10px; font-weight: 700; display: flex; align-items: center; justify-content: center;
  }
  .hb-tasks-area-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
  .hb-tasks-list { flex: 1; overflow-y: auto; padding: 4px 0; }
  .hb-task-row {
    display: flex; align-items: flex-start; gap: 8px;
    padding: 6px 16px; transition: background 0.1s;
  }
  .hb-task-row:hover { background: rgba(255,255,255,0.03); }
  .hb-task-check {
    flex-shrink: 0; padding: 2px; margin-top: 1px;
    background: transparent; border: none; cursor: pointer; color: #475569; border-radius: 3px; transition: color 0.1s;
  }
  .hb-task-check:hover { color: #22c55e; }
  .hb-task-check.done { cursor: default; }
  .hb-task-body { flex: 1; min-width: 0; }
  .hb-task-title {
    display: inline-flex; align-items: center; gap: 3px;
    color: #f1f5f9; font-size: 13px; text-decoration: none; line-height: 1.4; word-break: break-word;
  }
  .hb-task-title:hover { color: #fff; text-decoration: underline; }
  .hb-task-title.done { color: #64748b; text-decoration: line-through; }
  .hb-task-external { flex-shrink: 0; color: #475569; }
  .hb-task-meta { display: flex; align-items: center; gap: 6px; margin-top: 3px; }
  .hb-task-product-badge { font-size: 10px; font-weight: 600; padding: 1px 5px; border-radius: 3px; letter-spacing: 0.04em; }
  .hb-task-priority-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
  .hb-task-due { font-size: 11px; color: #64748b; }
  .hb-task-due.overdue { color: #ef4444; font-weight: 600; }
  .hb-task-group { margin-bottom: 4px; }
  .hb-task-group-label {
    display: flex; align-items: center; gap: 6px;
    font-size: 11px; font-weight: 600; text-transform: uppercase;
    letter-spacing: 0.05em; padding: 6px 16px 2px; color: #64748b;
  }
  .hb-task-empty { padding: 32px 16px; text-align: center; color: #475569; font-size: 13px; }

  @media (max-width: 640px) {
    .hb-tasks-panel { width: 100vw; }
    .hb-tasks-sidebar { width: 110px; }
  }

  /* ── Product Switcher — launch gate states ──────────────────────────────── */
  .hb-waffle-section-label {
    font-size: 10px; font-weight: 600; text-transform: uppercase;
    letter-spacing: 0.06em; color: #475569; padding: 4px 12px 2px;
  }
  .hb-waffle-sep { height: 1px; background: rgba(255,255,255,0.06); margin: 6px 0; }
  .hb-waffle-badge {
    font-size: 9px; font-weight: 700; text-transform: uppercase;
    letter-spacing: 0.06em; padding: 1px 5px; border-radius: 3px;
    line-height: 1.4; flex-shrink: 0;
  }
  .beta-badge { background: rgba(139,92,246,0.2); color: #a78bfa; }
  .coming-soon-badge { background: rgba(100,116,139,0.2); color: #64748b; }

  .hb-waffle-tile.inactive { opacity: 0.7; }
  .hb-waffle-tile.inactive:hover { opacity: 1; }

  .hb-waffle-tile.beta-locked {
    background: transparent; border: none; cursor: pointer;
    display: flex; flex-direction: column; align-items: center;
    gap: 4px; padding: 6px 4px; border-radius: 8px;
    transition: background 0.15s; text-align: center;
    font-family: inherit; color: inherit; width: 100%;
  }
  .hb-waffle-tile.beta-locked:hover { background: rgba(255,255,255,0.05); }

  .hb-waffle-tile.coming-soon {
    opacity: 0.45; cursor: default;
    display: flex; flex-direction: column; align-items: center;
    gap: 4px; padding: 6px 4px; border-radius: 8px; text-align: center;
  }
  .hb-waffle-lock-overlay {
    position: absolute; bottom: -2px; right: -2px;
    font-size: 9px; line-height: 1;
  }

  /* ── Waitlist Modal ─────────────────────────────────────────────────────── */
  .hb-waitlist-overlay {
    position: fixed; inset: 0; z-index: 10001;
    background: rgba(0,0,0,0.6); backdrop-filter: blur(4px);
    display: flex; align-items: center; justify-content: center;
    padding: 16px;
  }
  .hb-waitlist-modal {
    background: #18181b; border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px; padding: 24px; width: 100%; max-width: 380px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.6);
    position: relative; color: #f1f5f9;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 14px; line-height: 1.5;
  }
  .hb-waitlist-close {
    position: absolute; top: 12px; right: 12px;
    background: transparent; border: none; cursor: pointer;
    color: #64748b; font-size: 14px; line-height: 1;
    padding: 4px 6px; border-radius: 4px; transition: color 0.1s;
  }
  .hb-waitlist-close:hover { color: #f1f5f9; }
  .hb-waitlist-header {
    display: flex; align-items: center; gap: 12px; margin-bottom: 16px;
  }
  .hb-waitlist-icon {
    width: 40px; height: 40px; border-radius: 10px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
  }
  .hb-waitlist-title { font-size: 16px; font-weight: 600; color: #f1f5f9; }
  .hb-waitlist-desc { color: #94a3b8; font-size: 13px; margin: 0 0 12px; }
  .hb-waitlist-body { color: #94a3b8; font-size: 13px; margin: 0 0 16px; }
  .hb-waitlist-success {
    background: rgba(34,197,94,0.1); color: #86efac;
    border: 1px solid rgba(34,197,94,0.2); border-radius: 6px;
    padding: 10px 12px; font-size: 13px; margin-bottom: 12px;
  }
  .hb-waitlist-error {
    background: rgba(239,68,68,0.1); color: #fca5a5;
    border: 1px solid rgba(239,68,68,0.2); border-radius: 6px;
    padding: 10px 12px; font-size: 13px; margin-bottom: 12px;
  }
  .hb-waitlist-btn {
    width: 100%; padding: 10px 16px; border-radius: 8px;
    background: #7c3aed; border: none; cursor: pointer;
    color: #fff; font-size: 13px; font-weight: 600;
    font-family: inherit; transition: background 0.15s;
  }
  .hb-waitlist-btn:hover:not(:disabled) { background: #6d28d9; }
  .hb-waitlist-btn:disabled { opacity: 0.6; cursor: default; }

  /* ── THEO Onboarding ──────────────────────────────────────────────────────── */
  .theo-onboarding {
    position: absolute;
    inset: 0;
    background: rgba(10, 10, 20, 0.95);
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px;
    border-radius: 12px;
  }
  .theo-onboarding-step {
    max-width: 380px;
    text-align: center;
  }
  .onboarding-prompts {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 16px 0;
    width: 100%;
  }
  .prompt-chip {
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(99, 102, 241, 0.4);
    border-radius: 8px;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 13px;
    text-align: left;
    color: #e2e8f0;
    transition: background 0.15s;
    font-family: inherit;
  }
  .prompt-chip:hover {
    background: rgba(99, 102, 241, 0.3);
  }
  .onboarding-step-dots {
    display: flex;
    gap: 6px;
    margin-bottom: 24px;
  }
  .step-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
  }
  .step-dot.active {
    background: #6366f1;
  }

  /* ── THEO Feedback ────────────────────────────────────────────────────────── */
  @keyframes theo-slide-down {
    from { opacity: 0; transform: translateY(-4px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes theo-fade-in {
    from { opacity: 0; transform: translateX(-50%) translateY(4px); }
    to   { opacity: 1; transform: translateX(-50%) translateY(0); }
  }
`;
function vo(t, n, o) {
  if (n && o)
    return (n[0] + o[0]).toUpperCase();
  if (n)
    return n.slice(0, 2).toUpperCase();
  const r = t.split("@")[0].split(/[._-]/);
  return r.length >= 2 ? (r[0][0] + r[1][0]).toUpperCase() : t.slice(0, 2).toUpperCase();
}
function Vo() {
  var t;
  if (typeof document > "u") return null;
  try {
    const n = document.cookie.match(/(?:^|;\s*)hub_identity=([^;]+)/);
    if (!(n != null && n[1])) return null;
    const o = atob(n[1].replace(/-/g, "+").replace(/_/g, "/")), r = JSON.parse(o), i = r.sub ?? "";
    if (!i) return null;
    const a = (r.name ?? "").trim().split(/\s+/), d = a[0] ?? "", c = a.length > 1 ? a.slice(1).join(" ") : "", p = ((t = r.roles) == null ? void 0 : t[0]) ?? "member";
    return {
      userId: i,
      tenantId: r.org ?? "",
      firstName: d || void 0,
      lastName: c || void 0,
      role: p,
      initials: vo(i, d || void 0, c || void 0)
    };
  } catch {
    return null;
  }
}
function Go(t) {
  const n = t.id || "", o = t.email || "";
  if (!n || !o) return null;
  const r = t.firstName || void 0, i = t.lastName || void 0, a = t.tenantId || "", d = t.tenantSlug || "", c = t.tenantName || d, p = t.orgRole || "member", u = t.orgRole, y = t.user_type, m = t.entitlements, S = t.is_platform_owner || !1;
  return {
    userId: n,
    tenantId: a,
    tenantSlug: d,
    tenantName: c,
    email: o,
    role: p,
    orgRole: u,
    userType: y,
    entitlements: m,
    isPlatformOwner: S,
    firstName: r,
    lastName: i,
    initials: vo(o, r, i)
  };
}
let lt = null, Tt = null;
async function Yo(t) {
  return lt || Tt || (Tt = (async () => {
    try {
      const n = t || `${gt}`, o = await fetch(`${n}/api/portal/auth/me`, {
        credentials: "include",
        headers: { Accept: "application/json" }
      });
      if (!o.ok) return null;
      const r = await o.json();
      if (!r.data) return null;
      const i = Go(r.data);
      return i && (lt = i), i;
    } catch {
      return null;
    } finally {
      Tt = null;
    }
  })(), Tt);
}
function Ko(t, n) {
  const o = Sn(() => {
    if (t || lt) return null;
    const c = Vo();
    return c ? {
      userId: c.userId,
      tenantId: c.tenantId,
      tenantSlug: "",
      tenantName: "",
      email: "",
      role: c.role,
      firstName: c.firstName,
      lastName: c.lastName,
      initials: c.initials
    } : null;
  }, []), [r, i] = x(t ?? lt ?? o), a = q(!1), d = Sn(() => t, [t]);
  return V(() => {
    if (d) {
      i(d);
      return;
    }
    if (lt) {
      i(lt);
      return;
    }
    if (a.current) return;
    a.current = !0, Yo(n || gt).then((p) => {
      i(p);
    });
  }, [d, n]), r;
}
const On = [
  { id: "theo", name: "THEO", description: "AI built for MSPs. Proactive, integrated, yours.", icon: "Sparkles", color: "#7c3aed", url: "https://app.theonestack.com/theo", default_launch_status: "ga" },
  { id: "coo", name: "COO THEO", description: "Your AI Chief Operating Officer — knows your business, executes on your behalf.", icon: "BriefcaseBusiness", color: "#f97316", url: "https://hub.theonestack.com/coo", default_launch_status: "ga" },
  // collective — REMOVED 2026-04-16: standalone site at mspcollective.io; linked in Hub footer
  { id: "psa", name: "The One PSA", description: "Service desk with full client context on every ticket.", icon: "Layers", color: "#6366f1", url: "https://app.theonestack.com/psa", default_launch_status: "ga" },
  { id: "clarity", name: "The One Clarity", description: "AI-native MSP analytics — true profitability, SLA trends, and client health in one view.", icon: "BarChart2", color: "#6366f1", url: "https://app.theonestack.com/clarity", default_launch_status: "ga" },
  { id: "crm", name: "The One CRM", description: "Sales pipeline, marketing automation, and AI-powered QBR builder.", icon: "Users", color: "#8b5cf6", url: "https://app.theonestack.com/crm", default_launch_status: "ga" },
  { id: "cmdb", name: "The One CMDB", description: "Documentation, password vault, and knowledge base that builds itself.", icon: "Database", color: "#0ea5e9", url: "https://app.theonestack.com/cmdb", default_launch_status: "ga" },
  { id: "books", name: "The One Books", description: "Full double-entry accounting with per-client profitability.", icon: "BookOpen", color: "#10b981", url: "https://app.theonebooks.app", default_launch_status: "ga" },
  { id: "projects", name: "The One Projects", description: "Project management with Gantt charts and budgets that flow to invoicing.", icon: "FolderKanban", color: "#f59e0b", url: "https://app.theonestack.com/projects", default_launch_status: "ga" },
  { id: "oncall", name: "The One On-Call", description: "Rotation scheduling, multi-tier escalation, and auto-billed on-call hours.", icon: "BellRing", color: "#f97316", url: "https://app.theonestack.com/oncall", default_launch_status: "ga" },
  { id: "canvas", name: "The One Canvas", description: "Intelligent diagramming with auto-generated topology.", icon: "PenTool", color: "#64748b", url: "https://app.theonestack.com/canvas", default_launch_status: "ga" },
  { id: "legal", name: "The One Legal", description: "Matter management, encrypted document vault, and on-demand attorney services.", icon: "Scale", color: "#6366f1", url: "https://app.theonestack.com/legal", default_launch_status: "ga" },
  { id: "rmm", name: "The One RMM", description: "Monitor, patch, and automate every endpoint.", icon: "Cpu", color: "#10b981", url: "https://app.theonestack.com/rmm", default_launch_status: "ga" },
  { id: "defend", name: "The One Defend", description: "231 MITRE ATT&CK rules, attack chain visualization, and automated response.", icon: "Shield", color: "#ef4444", url: "https://app.theonestack.com/defend", default_launch_status: "ga" },
  { id: "backups", name: "The One Backups", description: "Endpoint and SaaS backup with ransomware-aware recovery.", icon: "HardDrive", color: "#3b82f6", url: "https://app.theonestack.com/backups", default_launch_status: "ga" },
  { id: "soc", name: "The One SOC", description: "Autonomous detection, correlation, and response.", icon: "ShieldAlert", color: "#dc2626", url: "https://app.theonestack.com/soc", default_launch_status: "ga" },
  { id: "compliance", name: "The One Compliance", description: "Seven frameworks, auto-collected evidence, and cross-framework control mapping.", icon: "ClipboardCheck", color: "#7c3aed", url: "https://app.theonestack.com/compliance", default_launch_status: "ga" },
  { id: "protect", name: "The One Protect", description: "Dark web monitoring, phishing simulation, DMARC, and breach response.", icon: "UserShield", color: "#db2777", url: "https://app.theonestack.com/protect", default_launch_status: "ga" },
  { id: "voice", name: "The One Voice", description: "Full PBX with caller context, AI call scoring, and wholesale resale.", icon: "Phone", color: "#06b6d4", url: "https://app.theonestack.com/voice", default_launch_status: "ga" },
  { id: "relay", name: "The One Relay", description: "Transactional email delivery, inbound routing, and deliverability management.", icon: "Mail", color: "#0891b2", url: "https://app.theonestack.com/relay", default_launch_status: "ga" },
  { id: "portal", name: "The One Portal", description: "White-label client portal with self-service and health dashboards.", icon: "Monitor", color: "#64748b", url: "https://app.theoneportal.app", default_launch_status: "coming_soon" },
  { id: "people", name: "The One People", description: "HR management with cross-product onboarding and one-click offboarding.", icon: "UserCircle", color: "#ec4899", url: "https://app.theonestack.com/people", default_launch_status: "ga" },
  { id: "fleet", name: "The One Fleet", description: "GPS tracking, predictive maintenance, and automatic mileage billing.", icon: "Truck", color: "#f59e0b", url: "https://app.theonestack.com/fleet", default_launch_status: "ga" },
  { id: "visitor", name: "The One Visitor", description: "Kiosk check-in, badge printing, NDA signing, and instant host notifications.", icon: "DoorOpen", color: "#14b8a6", url: "https://app.theonestack.com/visitor", default_launch_status: "ga" },
  // mission — REMOVED 2026-04-15: standalone app at app.theonemission.app; no longer in Hub Bar nav
  // ams — REMOVED 2026-04-15: standalone app at app.theoneams.app; no longer in Hub Bar nav
  { id: "code", name: "The One Code", description: "DevSecOps with GitHub backup, AI documentation, and vulnerability scanning.", icon: "Code2", color: "#06b6d4", url: "https://app.theonestack.com/code", default_launch_status: "ga" },
  { id: "ai-platform", name: "THEO Platform", description: "AI gateway with smart routing, governance, and a unified knowledge graph.", icon: "Sparkles", color: "#7c3aed", url: "https://app.theonestack.com/theo", default_launch_status: "ga" },
  { id: "agents", name: "The One Agents", description: "Describe automations in plain English and the AI agent builds the workflow.", icon: "Bot", color: "#f97316", url: "https://app.theonestack.com/agents", default_launch_status: "ga" },
  { id: "bridge", name: "The One Bridge", description: "Data migration with AI-assisted field mapping.", icon: "ArrowLeftRight", color: "#0ea5e9", url: "https://app.theonestack.com/bridge", default_launch_status: "ga" },
  { id: "status", name: "The One Status", description: "Branded status pages, uptime monitoring, and automatic incident management.", icon: "Activity", color: "#22c55e", url: "https://app.theonestack.com/status", default_launch_status: "coming_soon" },
  { id: "storage", name: "The One Storage", description: "Azure-backed cloud storage with a full web file manager.", icon: "HardDrive", color: "#0ea5e9", url: "https://app.theonestorage.app", default_launch_status: "ga" },
  { id: "remote", name: "The One Remote", description: "Remote desktop with in-session diagnostics and auto-logged billing.", icon: "MonitorSmartphone", color: "#3b82f6", url: "https://app.theoneremote.app", default_launch_status: "ga" },
  { id: "gather", name: "The One Gather", description: "Virtual office with proximity video — walk up to teammates and talk.", icon: "UsersRound", color: "#6366f1", url: "https://gather.theonestack.com", default_launch_status: "ga" }
  // sanctuary — REMOVED 2026-04-15: standalone app at app.theonesanctuary.app; no longer in Hub Bar nav
  // space — REMOVED 2026-04-16: standalone app at app.theonespace.app; linked in Hub footer
  // build — REMOVED 2026-04-16: standalone app at app.theonebuild.app; linked in Hub footer
];
function ko(t, n, o) {
  const [r, i] = x([]), [a, d] = x(!1), [c, p] = x(null);
  return V(() => {
    if (!n) {
      i([]);
      return;
    }
    d(!0), p(null);
    const u = new AbortController(), y = o ? Promise.resolve({ activeProductIds: On.map((m) => m.id) }) : fetch(`${t}/api/bus/products?tenant_id=${encodeURIComponent(n)}`, {
      credentials: "include",
      signal: u.signal
    }).then((m) => m.ok ? m.json() : { activeProductIds: [] }).catch(() => ({ activeProductIds: [] }));
    return Promise.all([
      // Hub-side endpoint — reads product launch status overrides
      fetch(`${t}/api/hub/product-launch/statuses`, {
        credentials: "include",
        signal: u.signal
      }).then((m) => m.ok ? m.json() : { statuses: {} }).catch(() => ({ statuses: {} })),
      y
    ]).then(([m, S]) => {
      const b = new Set(S.activeProductIds);
      i(
        On.map((w) => ({
          id: w.id,
          name: w.name,
          description: w.description,
          icon: w.icon,
          color: w.color,
          url: w.url,
          active: b.has(w.id),
          launch_status: m.statuses[w.id] ?? w.default_launch_status
        }))
      ), d(!1);
    }).catch((m) => {
      m.name !== "AbortError" && (i([]), p(m.message), d(!1));
    }), () => u.abort();
  }, [t, n, o]), { products: r, loading: a, error: c };
}
function qo(t, n, o, r) {
  const [i, a] = x([]), [d, c] = x([]), [p, u] = x(!1), y = q(null), m = q(null);
  V(() => {
    if (!o || !r) return;
    const A = new AbortController();
    return fetch(`${t}/api/bus/notifications?user_id=${encodeURIComponent(r)}&limit=20`, {
      credentials: "include",
      signal: A.signal
    }).then((g) => g.ok ? g.json() : Promise.resolve({ notifications: [] })).then((g) => {
      a(g.notifications ?? []);
    }).catch(() => {
    }), () => A.abort();
  }, [t, o, r]), V(() => {
    if (!n || !o) return;
    let A = !1;
    return (async () => {
      try {
        const { HubConnectionBuilder: g, LogLevel: z } = await import("./index-CrDahL0u.js"), L = new g().withUrl(`${n}?tenantId=${encodeURIComponent(o)}`).withAutomaticReconnect().configureLogging(z.Warning).build();
        L.on("notification", (T) => {
          a((H) => [T, ...H.slice(0, 49)]), y.current || (c((H) => [...H, T]), setTimeout(() => {
            c((H) => H.filter((j) => j.id !== T.id));
          }, 5e3));
        }), L.on("notificationsRead", (T) => {
          const H = new Set(T);
          a(
            (j) => j.map((B) => H.has(B.id) ? { ...B, read: !0 } : B)
          );
        }), L.on("busEvent", (T) => {
          const H = {
            id: T.event_id,
            productId: T.source,
            productName: T.source.toUpperCase(),
            title: T.title,
            body: T.detail,
            severity: T.severity === "critical" ? "error" : T.severity,
            read: !1,
            deepLink: T.entity_url || "",
            createdAt: T.timestamp
          };
          a((j) => [H, ...j.slice(0, 49)]), y.current || (c((j) => [...j, H]), setTimeout(() => {
            c((j) => j.filter((B) => B.id !== H.id));
          }, 5e3));
        }), A || (await L.start(), m.current = L);
      } catch {
      }
    })(), () => {
      var g;
      A = !0, (g = m.current) == null || g.stop(), m.current = null;
    };
  }, [n, o]), V(() => {
    if (!t || !o || !r || n) return;
    let A = 5e3, g;
    const z = () => {
      fetch(`${t}/api/bus/notifications?user_id=${encodeURIComponent(r)}&limit=20&since=latest`, {
        credentials: "include"
      }).then((L) => {
        if (!L.ok) {
          A = Math.min(A * 2, 6e4);
          return;
        }
        return L.json().then((T) => {
          var H;
          (H = T.notifications) != null && H.length && a((j) => {
            const B = new Set(j.map((W) => W.id)), U = T.notifications.filter((W) => !B.has(W.id));
            return U.length ? [...U, ...j].slice(0, 50) : j;
          }), A = 5e3;
        });
      }).catch(() => {
        A = Math.min(A * 2, 6e4);
      }).finally(() => {
        g = setTimeout(z, A);
      });
    };
    return g = setTimeout(z, A), () => clearTimeout(g);
  }, [t, o, r, n]);
  const S = P((A) => {
    a(
      (g) => g.map((z) => z.id === A ? { ...z, read: !0 } : z)
    ), fetch(`${t}/api/bus/notifications/${encodeURIComponent(A)}/read`, {
      method: "POST",
      credentials: "include"
    }).catch(() => {
    });
  }, [t]), b = P(() => {
    a((A) => A.map((g) => ({ ...g, read: !0 }))), fetch(`${t}/api/bus/notifications/mark-all-read`, {
      method: "POST",
      credentials: "include"
    }).catch(() => {
    });
  }, [t]), w = P((A) => {
    a((g) => g.filter((z) => z.id !== A)), fetch(`${t}/api/bus/notifications/${encodeURIComponent(A)}/dismiss`, {
      method: "POST",
      credentials: "include"
    }).catch(() => {
    });
  }, [t]), f = P((A) => {
    u(!0), y.current && clearTimeout(y.current), y.current = setTimeout(() => {
      u(!1), y.current = null;
    }, A);
  }, []), C = P(() => {
    u(!1), y.current && (clearTimeout(y.current), y.current = null);
  }, []), I = P((A) => {
    c((g) => g.filter((z) => z.id !== A));
  }, []), _ = i.filter((A) => !A.read).length;
  return { notifications: i, unreadCount: _, markAllRead: b, markRead: S, dismiss: w, muted: p, muteUntil: f, unmute: C, toastQueue: d, dismissToast: I };
}
function In() {
  if (typeof document > "u") return null;
  const t = document.cookie.match(/(?:^|;\s*)hub_session=([^;]+)/);
  return t ? t[1] : null;
}
function Bo(t, n) {
  const [o, r] = x([]);
  V(() => {
    if (!n) return;
    const a = new AbortController(), d = In();
    return fetch(`${t}/api/hub/user/orgs`, {
      credentials: "include",
      headers: d ? { Authorization: `Bearer ${d}` } : void 0,
      signal: a.signal
    }).then((c) => c.ok ? c.json() : Promise.resolve({ orgs: [] })).then((c) => {
      c.orgs && c.orgs.length > 1 && r(c.orgs);
    }).catch(() => {
    }), () => a.abort();
  }, [t, n]);
  async function i(a) {
    const d = In();
    (await fetch(`${t}/api/hub/auth/switch-org`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...d ? { Authorization: `Bearer ${d}` } : {}
      },
      body: JSON.stringify({ target_org_id: a })
    })).ok && window.location.reload();
  }
  return { orgs: o, switchOrg: i };
}
const M = (t) => function({ size: o = 16, className: r, color: i = "currentColor" }) {
  const a = Array.isArray(t) ? t : [t];
  return /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: o,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: r,
      children: a.map((d, c) => /* @__PURE__ */ e("path", { d }, c))
    }
  );
}, Jo = M("M20 6 9 17l-5-5"), mt = M("M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"), Xo = M([
  "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9",
  "M13.73 21a2 2 0 0 1-3.46 0"
]), Qo = M("M12 5v14M5 12h14"), Ke = M("M18 6 6 18M6 6l12 12"), Zo = M(["M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2", "M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"]), wo = M([
  "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
  "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
]), er = M([
  "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
  "M16 17l5-5-5-5",
  "M21 12H9"
]), tr = M([
  "M7 16V4m0 0L3 8m4-4 4 4",
  "M17 8v12m0 0 4-4m-4 4-4-4"
]), nr = M([
  "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z",
  "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  "M4.93 4.93l4.24 4.24",
  "M14.83 14.83l4.24 4.24",
  "M14.83 9.17l4.24-4.24",
  "M14.83 9.17l3.53-3.53",
  "M4.93 19.07l4.24-4.24"
]), or = M(["M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", "M2 10a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10H2z"]), rr = M(["M22 12h-4", "M6 12H2", "M12 6V2", "M12 22v-4", "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"]), qt = M(["M2 3h20v14H2z", "M8 21h8", "M12 17v4"]), Bt = M(["M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z", "M9 12l2 2 4-4"]), Jt = M(["M22 12H2", "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z", "M6 16h.01", "M10 16h.01"]), Xt = M(["M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z", "M8 10v4", "M12 10v2", "M16 10v6"]), Qt = M(["M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z", "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"]), ct = M("M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"), Ye = M(["M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z", "M20 3v4", "M22 5h-4"]), Ot = M(["M23 7l-7 5 7 5V7z", "M14 5H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z"]), Dn = M(["M18 22V8l-6-6-6 6v14", "M2 22h20", "M10 22v-4a2 2 0 0 1 4 0v4", "M12 7v5", "M10 9h4"]), Zt = M(["M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18", "M6 12H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2", "M18 12h2a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2", "M10 6h4", "M10 10h4", "M10 14h4", "M10 18h4"]), en = M(["M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h1", "M15 18h6a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14", "M7 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4z", "M17 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"]), tn = M(["M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", "M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z", "M22 21v-2a4 4 0 0 0-3-3.87", "M16 3.13a4 4 0 0 1 0 7.75"]), nn = M(["M12 2a9 3 0 1 0 0 6 9 3 0 0 0 0-6z", "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3", "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"]), on = M(["M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9", "M13.73 21a2 2 0 0 1-3.46 0", "M2 8c0-2.2.7-4.3 2-6", "M22 8a10 10 0 0 0-2-6"]), rn = M(["M13 4h3a2 2 0 0 1 2 2v14", "M2 20h3", "M13 20h9", "M10 12v.01", "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4.243-1.06A2 2 0 0 1 13 4.561z"]), an = M(["M16 2l5 5-14 14L2 16z", "M12 8l-2-2", "M8 12l-2-2"]), sn = M(["M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z", "M2 12h20", "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"]), ln = M(["M3 3h7v7H3z", "M14 3h7v7h-7z", "M14 14h7v7h-7z", "M3 14h7v7H3z"]), cn = M("M22 12h-4l-3 9L9 3l-3 9H2"), dn = M(["M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1", "M12 10v4h4", "M12 14c1.5-2 3.5-3 6-3", "M20 18v-4h-4", "M20 14c-1.5 2-3.5 3-6 3"]), So = M(["M9 11l3 3L22 4", "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 0-2-2V5a2 2 0 0 1 2-2h11"]), ir = M("M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z"), ar = M(["M7 17 17 7", "M7 7h10v10"]), Ln = M([
  "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  "M12 8v4",
  "M12 16h.01"
]), Ht = M([
  "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z",
  "M19 10v2a7 7 0 0 1-14 0v-2",
  "M12 19v3",
  "M8 22h8"
]), sr = M([
  "M2 2l20 20",
  "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2",
  "M5 10v2a7 7 0 0 0 12 5",
  "M15 9.34V5a3 3 0 0 0-5.68-1.33",
  "M9 9v3a3 3 0 0 0 5.12 2.12",
  "M12 19v3",
  "M8 22h8"
]), pn = M(["M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z", "M22 6l-10 7L2 6"]), hn = M(["M12 8V4H8", "M3 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z", "M9 13h.01", "M15 13h.01"]), jn = M(["M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z", "M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"]), Pn = M(["M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z", "M12 2a10 10 0 0 1 7.743 16.33", "M6.5 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z", "M17.5 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z", "M9.5 15.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"]), Hn = M(["M15 12l-8.5 8.5a2.12 2.12 0 0 1-3-3L12 9", "M17.64 15 22 10.64", "M20.91 11.7l-1.25-1.25c-.6-.6-.93-1.4-.93-2.25v-.86L16.01 4.6a5.56 5.56 0 0 0-3.94-1.64H9l.92.82A6.18 6.18 0 0 1 12 8.4v1.56l2 2h2.47l2.26 1.91z"]), $n = M("M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"), Un = M(["M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0-6 0", "M5 8V5h3", "M5 16v3h3", "M19 8V5h-3", "M19 16v3h-3", "M2 12h3", "M19 12h3", "M12 2v3", "M12 19v3"]), Wn = M(["M4 17l6-6-6-6", "M12 19h8"]), Fn = M(["M12 2 2 7l10 5 10-5-10-5z", "M2 17l10 5 10-5", "M2 12l10 5 10-5"]), Vn = M(["M3 3h7v7H3z", "M14 3h7v7h-7z", "M14 14h7v7h-7z", "M3 14h7v7H3z"]), Gn = M(["M18 8h4v12H2v-7", "M10 8V3H2v12h8V8z"]), Yn = M(["M8 3 4 7l4 4", "M4 7h16", "M16 21l4-4-4-4", "M20 17H4"]), Kn = M("M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"), qn = M(["M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", "M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2 2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2z", "M9 14l2 2 4-4"]), Bn = M(["M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", "M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z", "M20 13s2-1 2-3l-2-5-2 5c0 2 2 3 2 3z"]), Jn = M(["M12 19l7-7 3 3-7 7-3-3z", "M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z", "M2 2l7.586 7.586", "M11 11a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"]), Xn = M(["M18.364 17.364A9 9 0 1 0 5.636 5.636a9 9 0 0 0 12.728 11.728z", "M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0z", "M6.168 18.849A4 4 0 0 1 10 16h4a4 4 0 0 1 3.834 2.855"]), Et = M(["M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"]), Qn = M(["M13 2 3 14h9l-1 8 10-12h-9l1-8z"]), zn = M([
  "M16 2v6h6",
  "M21 3l-7 7",
  "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
]), To = M([
  "M23 7V1h-6",
  "M16 8l7-7",
  "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
]), lr = M([
  "M23 1l-6 6",
  "M17 1l6 6",
  "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
]), _o = M([
  "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.51 19.51 0 0 1-3.51-3.48",
  "M5 2a2 2 0 0 0-2 2v3a2 2 0 0 0 1.72 2 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 9 11.45L7.73 12.72",
  "M1 1l22 22"
]), cr = M([
  "M19 1l4 4-4 4",
  "M15 5h8",
  "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
]), dr = M([
  "M6 4h4v16H6z",
  "M14 4h4v16h-4z"
]), pr = M("M5 3l14 9-14 9V3z"), hr = M([
  "M4 9h16",
  "M4 15h16",
  "M10 3L8 21",
  "M16 3l-2 18"
]), ur = M([
  "M3 3h18v18H3z",
  "M9 17V7h4a3 3 0 0 1 0 6H9"
]), fr = M([
  "M22 2L11 13",
  "M22 2l-7 20-4-9-9-4 20-7z"
]), Mo = M([
  "M19 12H5",
  "M12 19l-7-7 7-7"
]), br = M([
  "M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z",
  "M18 9l-6 6",
  "M12 9l6 6"
]), Zn = M(["M18 20V10", "M12 20V4", "M6 20v-6"]), eo = M([
  "M12 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14z",
  "M8.21 13.89 7 23l5-3 5 3-1.21-9.11"
]), to = M([
  "M12 20h9",
  "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"
]), no = M([
  "M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z",
  "M7 11V7a5 5 0 0 1 10 0v4"
]), oo = M([
  "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
  "M12 22V12",
  "M3.29 7 12 12l8.71-5"
]), ro = M([
  "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9z"
]), Co = {
  // Generic Lucide keys (kebab-case)
  briefcase: or,
  target: rr,
  monitor: qt,
  "shield-check": Bt,
  "hard-drive": Jt,
  "folder-kanban": Xt,
  "book-open": Qt,
  phone: ct,
  sparkles: Ye,
  video: Ot,
  church: Dn,
  "building-2": Zt,
  truck: en,
  users: tn,
  database: nn,
  "bell-ring": on,
  "door-open": rn,
  scale: an,
  globe: sn,
  search: mt,
  "layout-grid": ln,
  activity: cn,
  "folder-sync": dn,
  // PascalCase aliases — covers all strings used in hub-constants catalogs
  Activity: cn,
  ArrowLeftRight: Yn,
  Award: eo,
  BarChart2: Zn,
  BellRing: on,
  BookOpen: Qt,
  Bot: hn,
  Building2: Zt,
  ClipboardCheck: qn,
  Cloud: ro,
  Code2: Wn,
  Cpu: Un,
  Database: nn,
  DoorOpen: rn,
  FileSignature: to,
  Flame: Kn,
  FolderKanban: Xt,
  FolderSync: dn,
  Globe: sn,
  HardDrive: Jt,
  Hammer: Hn,
  Layers: Fn,
  LayoutDashboard: Vn,
  LayoutGrid: ln,
  Lock: no,
  Mail: pn,
  MapPin: jn,
  MessageSquare: Et,
  Mic: Ht,
  Monitor: qt,
  MonitorSmartphone: Gn,
  Package: oo,
  Palette: Pn,
  PenTool: Jn,
  Phone: ct,
  Scale: an,
  Search: mt,
  Shield: $n,
  ShieldAlert: Ln,
  ShieldCheck: Bt,
  Sparkles: Ye,
  Truck: en,
  UserCircle: Xn,
  UserShield: Bn,
  Users: tn,
  Video: Ot,
  Zap: Qn,
  mail: pn,
  shield: $n,
  bot: hn,
  // Product-specific icon keys — one unique icon per product
  // Operations
  psa: Fn,
  // layered service desk
  crm: tn,
  // people/relationships
  books: Qt,
  // accounting books
  projects: Xt,
  clarity: Zn,
  // analytics/BI charts
  oncall: on,
  // Endpoint & Infrastructure
  rmm: Un,
  // hardware monitoring
  cmdb: nn,
  // config database
  defend: Bt,
  // endpoint EDR — shield with checkmark
  backups: Jt,
  // backup drive
  storage: ro,
  // cloud file storage (distinct from backups)
  status: cn,
  // uptime pulse
  connect: Gn,
  // Security pillar — four distinct icons, no duplicates
  soc: Ln,
  // SIEM & SOC — alerted shield
  compliance: qn,
  // GRC checklists
  protect: Bn,
  // user/dark-web protection
  security: no,
  // security operations — padlock
  // Communications
  voice: ct,
  relay: pn,
  messaging: Et,
  // AI & Automation
  aiplatform: Ye,
  ai: Ye,
  theo: Ye,
  // THEO AI
  agents: hn,
  // AI agents
  studio: oo,
  // white-label AI delivery — packaged product
  workflows: Qn,
  // automation/lightning
  code: Wn,
  // DevSecOps / app lifecycle
  // Data & Integration
  migrate: dn,
  bridge: Yn,
  // Field & Vertical
  onsite: jn,
  fleet: en,
  visitor: rn,
  build: Hn,
  // construction
  govwin: eo,
  // government contracts
  ams: Zt,
  // association management
  mission: Kn,
  // church/mission
  chms: Dn,
  // Creative & Productivity
  canvas: Jn,
  brand: Pn,
  esign: to,
  // e-signature
  livekit: Ot,
  podcast: Ht,
  signal: Ot,
  // AI avatar video (distinct product, same metaphor)
  // Platform
  legal: an,
  people: Xn,
  collective: sn,
  portal: qt,
  hub: Vn,
  gather: ln
  // hybrid office spaces/layout
};
function mr({ icon: t, size: n = 20 }) {
  const o = Co[t];
  return o ? /* @__PURE__ */ e(o, { size: n, color: "#fff" }) : /* @__PURE__ */ e("span", { style: { color: "#fff", fontSize: 14, fontWeight: 700 }, children: t.charAt(0).toUpperCase() });
}
function gr({ product: t, apiBase: n, onClose: o }) {
  const [r, i] = x("idle");
  async function a() {
    i("loading");
    try {
      const d = await fetch(`${n}/api/v1/product-launch/${t.id}/waitlist`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" }
      });
      d.status === 409 ? i("already") : d.ok ? i("joined") : i("error");
    } catch {
      i("error");
    }
  }
  return /* @__PURE__ */ e("div", { className: "hb-waitlist-overlay", onClick: (d) => {
    d.target === d.currentTarget && o();
  }, children: /* @__PURE__ */ s("div", { className: "hb-waitlist-modal", role: "dialog", "aria-modal": "true", children: [
    /* @__PURE__ */ e("button", { className: "hb-waitlist-close", onClick: o, "aria-label": "Close", children: "✕" }),
    /* @__PURE__ */ s("div", { className: "hb-waitlist-header", children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: "hb-waitlist-icon",
          style: { background: t.color, filter: "saturate(0.5)" },
          children: /* @__PURE__ */ e(mr, { icon: t.icon, size: 22 })
        }
      ),
      /* @__PURE__ */ s("div", { children: [
        /* @__PURE__ */ e("div", { className: "hb-waitlist-title", children: t.name }),
        /* @__PURE__ */ e("span", { className: "hb-waffle-badge beta-badge", children: "Beta" })
      ] })
    ] }),
    t.description && /* @__PURE__ */ e("p", { className: "hb-waitlist-desc", children: t.description }),
    /* @__PURE__ */ e("p", { className: "hb-waitlist-body", children: "This product is in private beta. Join the waitlist and we'll reach out when access is available for your organization." }),
    r === "joined" && /* @__PURE__ */ e("div", { className: "hb-waitlist-success", children: "You're on the waitlist ✓" }),
    r === "already" && /* @__PURE__ */ e("div", { className: "hb-waitlist-success", children: "You're already on the waitlist ✓" }),
    r === "error" && /* @__PURE__ */ e("div", { className: "hb-waitlist-error", children: "Something went wrong. Please try again." }),
    r !== "joined" && r !== "already" && /* @__PURE__ */ e(
      "button",
      {
        className: "hb-waitlist-btn",
        onClick: a,
        disabled: r === "loading",
        children: r === "loading" ? "Requesting…" : "Request Beta Access"
      }
    )
  ] }) });
}
function xr() {
  const t = [];
  for (let n = 0; n < 3; n++)
    for (let o = 0; o < 3; o++)
      t.push([6 + o * 7, 6 + n * 7]);
  return /* @__PURE__ */ e("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: t.map(([n, o], r) => /* @__PURE__ */ e("circle", { cx: n, cy: o, r: "2", fill: "#94a3b8" }, r)) });
}
function _t({ icon: t, size: n = 20 }) {
  const o = Co[t];
  return o ? /* @__PURE__ */ e(o, { size: n, color: "#fff" }) : /* @__PURE__ */ e("span", { style: { color: "#fff", fontSize: 14, fontWeight: 700 }, children: t.charAt(0).toUpperCase() });
}
function No({
  currentProduct: t,
  products: n,
  open: o,
  onToggle: r,
  onClose: i,
  hubUrl: a,
  apiBase: d = ""
}) {
  const c = q(null), [p, u] = x(null), y = n.filter((f) => f.launch_status === "ga" && f.active), m = n.filter((f) => f.launch_status === "ga" && !f.active), S = n.filter((f) => f.launch_status === "beta_invite" && (f.active || f.has_beta_access)), b = n.filter((f) => f.launch_status === "beta_invite" && !f.active && !f.has_beta_access), w = n.filter((f) => f.launch_status === "coming_soon");
  return V(() => {
    if (!o) return;
    function f(I) {
      c.current && !c.current.contains(I.target) && i();
    }
    function C(I) {
      I.key === "Escape" && i();
    }
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", C), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", C);
    };
  }, [o, i]), /* @__PURE__ */ s("div", { className: "hb-switcher", ref: c, style: { position: "relative" }, "data-tour": "product-switcher", children: [
    /* @__PURE__ */ e(
      "button",
      {
        className: `hb-waffle-btn${o ? " open" : ""}`,
        onClick: r,
        "aria-expanded": o,
        "aria-label": "App launcher",
        children: /* @__PURE__ */ e(xr, {})
      }
    ),
    o && /* @__PURE__ */ s("div", { className: "hb-waffle-panel", role: "menu", children: [
      /* @__PURE__ */ e("div", { className: "hb-waffle-header", children: "Apps" }),
      y.length > 0 && /* @__PURE__ */ s("div", { className: "hb-waffle-grid", children: [
        y.map((f) => /* @__PURE__ */ s(
          "a",
          {
            href: f.url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "hb-waffle-tile",
            onClick: i,
            role: "menuitem",
            children: [
              /* @__PURE__ */ e(
                "div",
                {
                  className: `hb-waffle-tile-icon${f.id === t ? " current" : ""}`,
                  style: { background: f.color },
                  children: /* @__PURE__ */ e(_t, { icon: f.icon })
                }
              ),
              /* @__PURE__ */ e("span", { className: "hb-waffle-tile-name", children: f.name })
            ]
          },
          f.id
        )),
        S.map((f) => /* @__PURE__ */ s(
          "a",
          {
            href: f.url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "hb-waffle-tile",
            onClick: i,
            role: "menuitem",
            children: [
              /* @__PURE__ */ e(
                "div",
                {
                  className: "hb-waffle-tile-icon",
                  style: { background: f.color },
                  children: /* @__PURE__ */ e(_t, { icon: f.icon })
                }
              ),
              /* @__PURE__ */ e("span", { className: "hb-waffle-tile-name", children: f.name }),
              /* @__PURE__ */ e("span", { className: "hb-waffle-badge beta-badge", children: "Beta" })
            ]
          },
          f.id
        ))
      ] }),
      m.length > 0 && /* @__PURE__ */ s(he, { children: [
        /* @__PURE__ */ e("div", { className: "hb-waffle-sep" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-section-label", children: "Available" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-grid", children: m.map((f) => /* @__PURE__ */ s(
          "a",
          {
            href: `${a}/products/${f.id}`,
            className: "hb-waffle-tile inactive",
            onClick: i,
            role: "menuitem",
            children: [
              /* @__PURE__ */ e("div", { className: "hb-waffle-tile-icon", style: { background: f.color }, children: /* @__PURE__ */ e(_t, { icon: f.icon }) }),
              /* @__PURE__ */ e("span", { className: "hb-waffle-tile-name", children: f.name })
            ]
          },
          f.id
        )) })
      ] }),
      b.length > 0 && /* @__PURE__ */ s(he, { children: [
        /* @__PURE__ */ e("div", { className: "hb-waffle-sep" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-section-label", children: "Beta" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-grid", children: b.map((f) => /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            className: "hb-waffle-tile beta-locked",
            onClick: () => {
              u(f), i();
            },
            role: "menuitem",
            title: `${f.name} — Private Beta`,
            children: [
              /* @__PURE__ */ e(
                "div",
                {
                  className: "hb-waffle-tile-icon",
                  style: { background: f.color, filter: "saturate(0.5)" },
                  children: /* @__PURE__ */ e(_t, { icon: f.icon })
                }
              ),
              /* @__PURE__ */ e("span", { className: "hb-waffle-tile-name", children: f.name }),
              /* @__PURE__ */ e("span", { className: "hb-waffle-badge beta-badge", children: "Beta" })
            ]
          },
          f.id
        )) })
      ] }),
      w.length > 0 && /* @__PURE__ */ s(he, { children: [
        /* @__PURE__ */ e("div", { className: "hb-waffle-sep" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-section-label", children: "Coming Soon" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-grid", children: w.map((f) => /* @__PURE__ */ s(
          "div",
          {
            className: "hb-waffle-tile coming-soon",
            title: `${f.name} — Coming Soon`,
            role: "menuitem",
            children: [
              /* @__PURE__ */ s(
                "div",
                {
                  className: "hb-waffle-tile-icon",
                  style: { position: "relative", background: "#334155" },
                  children: [
                    /* @__PURE__ */ e(_t, { icon: f.icon }),
                    /* @__PURE__ */ e("div", { className: "hb-waffle-lock-overlay", children: "🔒" })
                  ]
                }
              ),
              /* @__PURE__ */ e("span", { className: "hb-waffle-tile-name", children: f.name }),
              /* @__PURE__ */ e("span", { className: "hb-waffle-badge coming-soon-badge", children: "Soon" })
            ]
          },
          f.id
        )) })
      ] }),
      /* @__PURE__ */ e(
        "a",
        {
          href: `${a}/hub/discover`,
          className: "hb-waffle-explore",
          onClick: i,
          children: "+ Discover more products"
        }
      )
    ] }),
    p && /* @__PURE__ */ e(
      gr,
      {
        product: p,
        apiBase: d,
        onClose: () => u(null)
      }
    )
  ] });
}
function yr(t, n, o, r = 200) {
  const [i, a] = x([]), [d, c] = x(!1), p = q(null);
  return V(() => {
    p.current && clearTimeout(p.current);
    const u = o.trim();
    if (!u || !n) {
      a([]), c(!1);
      return;
    }
    c(!0);
    const y = new AbortController();
    return p.current = setTimeout(() => {
      fetch(
        `${t}/api/bus/search?q=${encodeURIComponent(u)}&tenant_id=${encodeURIComponent(n)}`,
        { credentials: "include", signal: y.signal }
      ).then((m) => m.ok ? m.json() : Promise.resolve({ groups: [] })).then((m) => {
        a(m.groups ?? []), c(!1);
      }).catch((m) => {
        m.name !== "AbortError" && (a([]), c(!1));
      });
    }, r), () => {
      y.abort(), p.current && clearTimeout(p.current);
    };
  }, [t, n, o, r]), { results: i, loading: d };
}
function vr({ apiBase: t, tenantId: n }) {
  const [o, r] = x(!1), [i, a] = x(""), [d, c] = x(-1), p = q(null), { results: u, loading: y } = yr(t, n, i), m = u.flatMap((C) => C.results), S = P(() => {
    r(!0), a(""), c(-1), setTimeout(() => {
      var C;
      return (C = p.current) == null ? void 0 : C.focus();
    }, 0);
  }, []), b = P(() => {
    r(!1), a(""), c(-1);
  }, []);
  V(() => {
    function C(I) {
      (I.metaKey || I.ctrlKey) && I.key === "k" && (I.preventDefault(), o ? b() : S()), I.key === "Escape" && o && b();
    }
    return document.addEventListener("keydown", C), () => document.removeEventListener("keydown", C);
  }, [o, S, b]);
  function w(C) {
    if (C.key === "ArrowDown")
      C.preventDefault(), c((I) => Math.min(I + 1, m.length - 1));
    else if (C.key === "ArrowUp")
      C.preventDefault(), c((I) => Math.max(I - 1, -1));
    else if (C.key === "Enter" && d >= 0) {
      const I = m[d];
      I && (window.location.href = I.deepLink, b());
    }
  }
  const f = typeof navigator < "u" && /Mac/i.test(navigator.platform);
  return /* @__PURE__ */ s(he, { children: [
    /* @__PURE__ */ e("div", { className: "hb-search-wrap", "data-tour": "unified-search", children: /* @__PURE__ */ s("button", { className: "hb-search-trigger", onClick: S, "aria-label": "Search (Cmd+K)", children: [
      /* @__PURE__ */ e(mt, { size: 14 }),
      /* @__PURE__ */ e("span", { className: "hb-search-trigger-text", children: "Search everything..." }),
      /* @__PURE__ */ s("span", { className: "hb-kbd", children: [
        /* @__PURE__ */ e("kbd", { children: f ? "⌘" : "Ctrl" }),
        /* @__PURE__ */ e("kbd", { children: "K" })
      ] })
    ] }) }),
    o && /* @__PURE__ */ e(
      "div",
      {
        className: "hb-search-overlay",
        onMouseDown: (C) => {
          C.target === C.currentTarget && b();
        },
        role: "dialog",
        "aria-label": "Search",
        "aria-modal": "true",
        children: /* @__PURE__ */ s("div", { className: "hb-search-modal", children: [
          /* @__PURE__ */ s("div", { className: "hb-search-input-row", children: [
            /* @__PURE__ */ e(mt, { size: 18, color: "#f97316" }),
            /* @__PURE__ */ e(
              "input",
              {
                ref: p,
                className: "hb-search-input",
                placeholder: "Search everything...",
                value: i,
                onChange: (C) => {
                  a(C.target.value), c(-1);
                },
                onKeyDown: w,
                autoComplete: "off",
                spellCheck: !1
              }
            ),
            i && /* @__PURE__ */ e(
              "button",
              {
                style: { background: "none", border: "none", cursor: "pointer", padding: 0, color: "#64748b" },
                onClick: () => a(""),
                "aria-label": "Clear",
                children: /* @__PURE__ */ e(Ke, { size: 16 })
              }
            )
          ] }),
          /* @__PURE__ */ e(
            kr,
            {
              query: i,
              loading: y,
              results: u,
              focusedIndex: d,
              onNavigate: b
            }
          )
        ] })
      }
    )
  ] });
}
function kr({ query: t, loading: n, results: o, focusedIndex: r, onNavigate: i }) {
  if (!t.trim())
    return /* @__PURE__ */ s("div", { className: "hb-search-empty", children: [
      /* @__PURE__ */ e("div", { children: "Type to search across all products" }),
      /* @__PURE__ */ e("div", { className: "hb-search-empty-hint", children: "Contacts, tickets, invoices, devices, and more" })
    ] });
  if (n)
    return /* @__PURE__ */ s("div", { className: "hb-search-loading", children: [
      /* @__PURE__ */ e("div", { className: "hb-spinner" }),
      "Searching..."
    ] });
  if (!o.length)
    return /* @__PURE__ */ s("div", { className: "hb-search-empty", children: [
      "No results for “",
      t,
      "”"
    ] });
  let a = 0;
  return /* @__PURE__ */ e("div", { className: "hb-search-results", children: o.map((d) => /* @__PURE__ */ s("div", { children: [
    /* @__PURE__ */ s("div", { className: "hb-search-group-label", children: [
      d.productName,
      " — ",
      d.results.length,
      " result",
      d.results.length !== 1 ? "s" : ""
    ] }),
    d.results.map((c) => {
      const p = a++;
      return /* @__PURE__ */ s(
        "a",
        {
          href: c.deepLink,
          className: `hb-search-item${r === p ? " focused" : ""}`,
          onClick: i,
          children: [
            /* @__PURE__ */ e("div", { className: "hb-search-item-icon", children: c.icon ?? c.title.slice(0, 1).toUpperCase() }),
            /* @__PURE__ */ s("div", { className: "hb-search-item-body", children: [
              /* @__PURE__ */ e("div", { className: "hb-search-item-title", children: c.title }),
              c.subtitle && /* @__PURE__ */ e("div", { className: "hb-search-item-sub", children: c.subtitle })
            ] }),
            /* @__PURE__ */ e("span", { className: "hb-source-badge", children: d.productName })
          ]
        },
        c.id
      );
    })
  ] }, d.productId)) });
}
function wr(t) {
  const n = Math.floor((Date.now() - new Date(t).getTime()) / 1e3);
  return n < 60 ? "just now" : n < 3600 ? `${Math.floor(n / 60)}m ago` : n < 86400 ? `${Math.floor(n / 3600)}h ago` : `${Math.floor(n / 86400)}d ago`;
}
function Sr({
  notifications: t,
  unreadCount: n,
  open: o,
  onToggle: r,
  onClose: i,
  onMarkAllRead: a,
  onMarkRead: d,
  onDismiss: c,
  muted: p,
  onMute: u,
  onUnmute: y,
  hubUrl: m
}) {
  const S = q(null);
  return V(() => {
    if (!o) return;
    function b(w) {
      S.current && !S.current.contains(w.target) && i();
    }
    return document.addEventListener("mousedown", b), () => document.removeEventListener("mousedown", b);
  }, [o, i]), /* @__PURE__ */ s("div", { className: "hb-notif", ref: S, "data-tour": "notifications", children: [
    /* @__PURE__ */ s(
      "button",
      {
        className: "hb-notif-btn",
        onClick: r,
        "aria-label": `Notifications${n > 0 ? ` (${n} unread)` : ""}`,
        "aria-expanded": o,
        children: [
          /* @__PURE__ */ e(Xo, { size: 18 }),
          n > 0 && /* @__PURE__ */ e("span", { className: "hb-badge", "aria-hidden": "true", children: n > 99 ? "99+" : n })
        ]
      }
    ),
    o && /* @__PURE__ */ s("div", { className: "hb-notif-dropdown", role: "dialog", "aria-label": "Notifications", children: [
      /* @__PURE__ */ s("div", { className: "hb-notif-header", children: [
        /* @__PURE__ */ e("span", { className: "hb-notif-title", children: "Notifications" }),
        n > 0 && /* @__PURE__ */ e("button", { className: "hb-notif-mark-read", onClick: a, children: "Mark all read" })
      ] }),
      /* @__PURE__ */ e("div", { className: "hb-notif-list", role: "list", children: t.length === 0 ? /* @__PURE__ */ e("div", { className: "hb-notif-empty", children: "No notifications" }) : t.slice(0, 20).map((b) => /* @__PURE__ */ s(
        "div",
        {
          className: `hb-notif-item${b.read ? "" : " unread"}`,
          role: "listitem",
          children: [
            /* @__PURE__ */ s(
              "a",
              {
                href: b.deepLink,
                className: "hb-notif-item-link",
                onClick: () => {
                  d(b.id), i();
                },
                children: [
                  /* @__PURE__ */ e(
                    "span",
                    {
                      className: "hb-notif-icon",
                      style: { background: Tn[b.severity] },
                      "aria-hidden": "true"
                    }
                  ),
                  /* @__PURE__ */ s("div", { className: "hb-notif-body", children: [
                    /* @__PURE__ */ s("div", { className: "hb-notif-body-title", children: [
                      b.title,
                      b.groupCount && b.groupCount > 1 && /* @__PURE__ */ e("span", { className: "hb-notif-group-badge", children: b.groupCount })
                    ] }),
                    b.body && /* @__PURE__ */ e("div", { className: "hb-notif-body-text", children: b.body }),
                    /* @__PURE__ */ s("div", { className: "hb-notif-meta", children: [
                      /* @__PURE__ */ e("span", { className: "hb-source-badge", children: b.productName }),
                      /* @__PURE__ */ e("span", { className: "hb-notif-time", children: wr(b.createdAt) })
                    ] })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ e(
              "button",
              {
                className: "hb-notif-dismiss",
                onClick: (w) => {
                  w.stopPropagation(), c(b.id);
                },
                "aria-label": "Dismiss notification",
                children: /* @__PURE__ */ e(Ke, { size: 14 })
              }
            )
          ]
        },
        b.id
      )) }),
      /* @__PURE__ */ e("div", { className: "hb-notif-footer", children: /* @__PURE__ */ s("div", { className: "hb-notif-footer-row", children: [
        p ? /* @__PURE__ */ e("button", { className: "hb-notif-mute-btn", onClick: y, children: "Unmute notifications" }) : /* @__PURE__ */ s("div", { className: "hb-notif-mute-group", children: [
          /* @__PURE__ */ e("button", { className: "hb-notif-mute-btn", onClick: () => u(60 * 60 * 1e3), children: "Mute 1h" }),
          /* @__PURE__ */ e("button", { className: "hb-notif-mute-btn", onClick: () => {
            const b = /* @__PURE__ */ new Date(), w = new Date(b.getFullYear(), b.getMonth(), b.getDate() + 1);
            u(w.getTime() - b.getTime());
          }, children: "Mute today" })
        ] }),
        /* @__PURE__ */ s("a", { href: `${m}/notifications/settings`, onClick: i, className: "hb-notif-settings-link", children: [
          /* @__PURE__ */ e(wo, { size: 14 }),
          "Settings"
        ] })
      ] }) })
    ] })
  ] });
}
function Tr({ toasts: t, onDismiss: n }) {
  return t.length === 0 ? null : /* @__PURE__ */ e("div", { className: "hb-toast-container", role: "status", "aria-live": "polite", children: t.slice(0, 3).map((o) => {
    const r = Uo.find((i) => i.id === o.productId);
    return /* @__PURE__ */ s(
      "div",
      {
        className: "hb-toast",
        style: { borderLeftColor: Tn[o.severity] },
        children: [
          /* @__PURE__ */ e(
            "span",
            {
              className: "hb-toast-dot",
              style: { background: (r == null ? void 0 : r.color) || Tn[o.severity] }
            }
          ),
          /* @__PURE__ */ s("div", { className: "hb-toast-body", children: [
            /* @__PURE__ */ e("div", { className: "hb-toast-title", children: o.title }),
            o.body && /* @__PURE__ */ e("div", { className: "hb-toast-text", children: o.body }),
            o.deepLink && /* @__PURE__ */ e("a", { href: o.deepLink, className: "hb-toast-link", children: "View" })
          ] }),
          /* @__PURE__ */ e(
            "button",
            {
              className: "hb-toast-close",
              onClick: () => n(o.id),
              "aria-label": "Dismiss",
              children: /* @__PURE__ */ e(Ke, { size: 14 })
            }
          )
        ]
      },
      o.id
    );
  }) });
}
function Ao({
  session: t,
  open: n,
  onToggle: o,
  onClose: r,
  onLogout: i,
  hubUrl: a,
  orgs: d = [],
  onSwitchOrg: c
}) {
  const p = q(null);
  V(() => {
    if (!n) return;
    function y(m) {
      p.current && !p.current.contains(m.target) && r();
    }
    return document.addEventListener("mousedown", y), () => document.removeEventListener("mousedown", y);
  }, [n, r]);
  function u() {
    r(), i ? i() : window.location.href = `${a}/logout`;
  }
  return /* @__PURE__ */ s("div", { className: "hb-user", ref: p, "data-tour": "user-menu", children: [
    /* @__PURE__ */ s("button", { className: "hb-user-btn", onClick: o, "aria-expanded": n, "aria-label": "User menu", children: [
      /* @__PURE__ */ e("div", { className: "hb-avatar", children: t.initials }),
      /* @__PURE__ */ e("span", { className: "hb-user-name", children: t.firstName ?? t.email.split("@")[0] }),
      /* @__PURE__ */ e(
        "svg",
        {
          width: "12",
          height: "12",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          style: { opacity: 0.5 },
          children: /* @__PURE__ */ e("path", { d: "m6 9 6 6 6-6" })
        }
      )
    ] }),
    n && /* @__PURE__ */ s("div", { className: "hb-user-dropdown", role: "menu", children: [
      /* @__PURE__ */ s("div", { className: "hb-user-info", children: [
        /* @__PURE__ */ e("div", { style: { fontWeight: 600, fontSize: 13, color: "#f1f5f9" }, children: t.firstName && t.lastName ? `${t.firstName} ${t.lastName}` : t.email.split("@")[0] }),
        /* @__PURE__ */ e("div", { className: "hb-user-email", children: t.email }),
        t.tenantName && /* @__PURE__ */ e("div", { className: "hb-user-tenant", children: t.tenantName })
      ] }),
      /* @__PURE__ */ s(
        "a",
        {
          href: `${a}/profile`,
          className: "hb-menu-item",
          onClick: r,
          role: "menuitem",
          children: [
            /* @__PURE__ */ e(Zo, { size: 14 }),
            "Profile"
          ]
        }
      ),
      /* @__PURE__ */ s(
        "a",
        {
          href: `${a}/settings`,
          className: "hb-menu-item",
          onClick: r,
          role: "menuitem",
          children: [
            /* @__PURE__ */ e(wo, { size: 14 }),
            "Hub Settings"
          ]
        }
      ),
      /* @__PURE__ */ e("div", { className: "hb-menu-sep" }),
      d.length > 1 && c ? /* @__PURE__ */ s(he, { children: [
        /* @__PURE__ */ e("div", { style: { padding: "4px 16px 2px", fontSize: 11, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }, children: "Switch Org" }),
        d.map((y) => /* @__PURE__ */ s(
          "button",
          {
            className: "hb-menu-item",
            onClick: () => {
              c(y.org_id), r();
            },
            role: "menuitem",
            style: { display: "flex", alignItems: "center", gap: 8 },
            children: [
              y.org_id === t.tenantId ? /* @__PURE__ */ e(Jo, { size: 12, color: "#22c55e" }) : /* @__PURE__ */ e("span", { style: { width: 12, display: "inline-block" } }),
              /* @__PURE__ */ e("span", { style: { flex: 1, textAlign: "left" }, children: y.org_name })
            ]
          },
          y.org_id
        ))
      ] }) : /* @__PURE__ */ s(
        "a",
        {
          href: `${a}/switch-tenant`,
          className: "hb-menu-item",
          onClick: r,
          role: "menuitem",
          children: [
            /* @__PURE__ */ e(tr, { size: 14 }),
            "Switch Tenant"
          ]
        }
      ),
      /* @__PURE__ */ e("div", { className: "hb-menu-sep" }),
      /* @__PURE__ */ s(
        "button",
        {
          className: "hb-menu-item danger",
          onClick: u,
          role: "menuitem",
          children: [
            /* @__PURE__ */ e(er, { size: 14 }),
            "Log Out"
          ]
        }
      )
    ] })
  ] });
}
function _r({ config: t, currentProduct: n = "hub", user: o, hubUrl: r = gt }) {
  return /* @__PURE__ */ e(
    "a",
    {
      href: `${r}/support`,
      className: "hb-chat-btn",
      title: "Support",
      "aria-label": "Open support",
      children: /* @__PURE__ */ e(nr, { size: 18 })
    }
  );
}
/*! @license DOMPurify 3.3.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.3/LICENSE */
const {
  entries: zo,
  setPrototypeOf: io,
  isFrozen: Mr,
  getPrototypeOf: Cr,
  getOwnPropertyDescriptor: Nr
} = Object;
let {
  freeze: we,
  seal: Ee,
  create: jt
} = Object, {
  apply: _n,
  construct: Mn
} = typeof Reflect < "u" && Reflect;
we || (we = function(n) {
  return n;
});
Ee || (Ee = function(n) {
  return n;
});
_n || (_n = function(n, o) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return n.apply(o, i);
});
Mn || (Mn = function(n) {
  for (var o = arguments.length, r = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
    r[i - 1] = arguments[i];
  return new n(...r);
});
const It = Se(Array.prototype.forEach), Ar = Se(Array.prototype.lastIndexOf), ao = Se(Array.prototype.pop), Mt = Se(Array.prototype.push), zr = Se(Array.prototype.splice), Pt = Se(String.prototype.toLowerCase), un = Se(String.prototype.toString), fn = Se(String.prototype.match), Ct = Se(String.prototype.replace), Er = Se(String.prototype.indexOf), Rr = Se(String.prototype.trim), Ne = Se(Object.prototype.hasOwnProperty), ke = Se(RegExp.prototype.test), Nt = Or(TypeError);
function Se(t) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var o = arguments.length, r = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
      r[i - 1] = arguments[i];
    return _n(t, n, r);
  };
}
function Or(t) {
  return function() {
    for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++)
      o[r] = arguments[r];
    return Mn(t, o);
  };
}
function Q(t, n) {
  let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Pt;
  io && io(t, null);
  let r = n.length;
  for (; r--; ) {
    let i = n[r];
    if (typeof i == "string") {
      const a = o(i);
      a !== i && (Mr(n) || (n[r] = a), i = a);
    }
    t[i] = !0;
  }
  return t;
}
function Ir(t) {
  for (let n = 0; n < t.length; n++)
    Ne(t, n) || (t[n] = null);
  return t;
}
function We(t) {
  const n = jt(null);
  for (const [o, r] of zo(t))
    Ne(t, o) && (Array.isArray(r) ? n[o] = Ir(r) : r && typeof r == "object" && r.constructor === Object ? n[o] = We(r) : n[o] = r);
  return n;
}
function At(t, n) {
  for (; t !== null; ) {
    const r = Nr(t, n);
    if (r) {
      if (r.get)
        return Se(r.get);
      if (typeof r.value == "function")
        return Se(r.value);
    }
    t = Cr(t);
  }
  function o() {
    return null;
  }
  return o;
}
const so = we(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), bn = we(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), mn = we(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Dr = we(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), gn = we(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Lr = we(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), lo = we(["#text"]), co = we(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), xn = we(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), po = we(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Dt = we(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), jr = Ee(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Pr = Ee(/<%[\w\W]*|[\w\W]*%>/gm), Hr = Ee(/\$\{[\w\W]*/gm), $r = Ee(/^data-[\-\w.\u00B7-\uFFFF]+$/), Ur = Ee(/^aria-[\-\w]+$/), Eo = Ee(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Wr = Ee(/^(?:\w+script|data):/i), Fr = Ee(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Ro = Ee(/^html$/i), Vr = Ee(/^[a-z][.\w]*(-[.\w]+)+$/i);
var ho = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Ur,
  ATTR_WHITESPACE: Fr,
  CUSTOM_ELEMENT: Vr,
  DATA_ATTR: $r,
  DOCTYPE_NAME: Ro,
  ERB_EXPR: Pr,
  IS_ALLOWED_URI: Eo,
  IS_SCRIPT_OR_DATA: Wr,
  MUSTACHE_EXPR: jr,
  TMPLIT_EXPR: Hr
});
const zt = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, Gr = function() {
  return typeof window > "u" ? null : window;
}, Yr = function(n, o) {
  if (typeof n != "object" || typeof n.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  o && o.hasAttribute(i) && (r = o.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return n.createPolicy(a, {
      createHTML(d) {
        return d;
      },
      createScriptURL(d) {
        return d;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, uo = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function Oo() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Gr();
  const n = (D) => Oo(D);
  if (n.version = "3.3.3", n.removed = [], !t || !t.document || t.document.nodeType !== zt.document || !t.Element)
    return n.isSupported = !1, n;
  let {
    document: o
  } = t;
  const r = o, i = r.currentScript, {
    DocumentFragment: a,
    HTMLTemplateElement: d,
    Node: c,
    Element: p,
    NodeFilter: u,
    NamedNodeMap: y = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: m,
    DOMParser: S,
    trustedTypes: b
  } = t, w = p.prototype, f = At(w, "cloneNode"), C = At(w, "remove"), I = At(w, "nextSibling"), _ = At(w, "childNodes"), A = At(w, "parentNode");
  if (typeof d == "function") {
    const D = o.createElement("template");
    D.content && D.content.ownerDocument && (o = D.content.ownerDocument);
  }
  let g, z = "";
  const {
    implementation: L,
    createNodeIterator: T,
    createDocumentFragment: H,
    getElementsByTagName: j
  } = o, {
    importNode: B
  } = r;
  let U = uo();
  n.isSupported = typeof zo == "function" && typeof A == "function" && L && L.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: W,
    ERB_EXPR: J,
    TMPLIT_EXPR: R,
    DATA_ATTR: K,
    ARIA_ATTR: re,
    IS_SCRIPT_OR_DATA: $,
    ATTR_WHITESPACE: ne,
    CUSTOM_ELEMENT: ee
  } = ho;
  let {
    IS_ALLOWED_URI: oe
  } = ho, X = null;
  const De = Q({}, [...so, ...bn, ...mn, ...gn, ...lo]);
  let ie = null;
  const dt = Q({}, [...co, ...xn, ...po, ...Dt]);
  let te = Object.seal(jt(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), N = null, E = null;
  const G = Object.seal(jt(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Re = !0, Te = !0, fe = !1, xt = !0, Ae = !1, ot = !0, ze = !1, qe = !1, pt = !1, Be = !1, rt = !1, Oe = !1, yt = !0, Rt = !1;
  const Ft = "user-content-";
  let Fe = !0, be = !1, Je = {}, me = null;
  const Xe = Q({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let it = null;
  const vt = Q({}, ["audio", "video", "img", "source", "image", "track"]);
  let Ve = null;
  const Qe = Q({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Ze = "http://www.w3.org/1998/Math/MathML", Le = "http://www.w3.org/2000/svg", Ie = "http://www.w3.org/1999/xhtml";
  let et = Ie, kt = !1, tt = null;
  const ht = Q({}, [Ze, Le, Ie], un);
  let at = Q({}, ["mi", "mo", "mn", "ms", "mtext"]), nt = Q({}, ["annotation-xml"]);
  const Vt = Q({}, ["title", "style", "font", "a", "script"]);
  let ye = null;
  const Gt = ["application/xhtml+xml", "text/html"], Yt = "text/html";
  let se = null, h = null;
  const Y = o.createElement("form"), F = function(l) {
    return l instanceof RegExp || l instanceof Function;
  }, le = function() {
    let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(h && h === l)) {
      if ((!l || typeof l != "object") && (l = {}), l = We(l), ye = // eslint-disable-next-line unicorn/prefer-includes
      Gt.indexOf(l.PARSER_MEDIA_TYPE) === -1 ? Yt : l.PARSER_MEDIA_TYPE, se = ye === "application/xhtml+xml" ? un : Pt, X = Ne(l, "ALLOWED_TAGS") ? Q({}, l.ALLOWED_TAGS, se) : De, ie = Ne(l, "ALLOWED_ATTR") ? Q({}, l.ALLOWED_ATTR, se) : dt, tt = Ne(l, "ALLOWED_NAMESPACES") ? Q({}, l.ALLOWED_NAMESPACES, un) : ht, Ve = Ne(l, "ADD_URI_SAFE_ATTR") ? Q(We(Qe), l.ADD_URI_SAFE_ATTR, se) : Qe, it = Ne(l, "ADD_DATA_URI_TAGS") ? Q(We(vt), l.ADD_DATA_URI_TAGS, se) : vt, me = Ne(l, "FORBID_CONTENTS") ? Q({}, l.FORBID_CONTENTS, se) : Xe, N = Ne(l, "FORBID_TAGS") ? Q({}, l.FORBID_TAGS, se) : We({}), E = Ne(l, "FORBID_ATTR") ? Q({}, l.FORBID_ATTR, se) : We({}), Je = Ne(l, "USE_PROFILES") ? l.USE_PROFILES : !1, Re = l.ALLOW_ARIA_ATTR !== !1, Te = l.ALLOW_DATA_ATTR !== !1, fe = l.ALLOW_UNKNOWN_PROTOCOLS || !1, xt = l.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ae = l.SAFE_FOR_TEMPLATES || !1, ot = l.SAFE_FOR_XML !== !1, ze = l.WHOLE_DOCUMENT || !1, Be = l.RETURN_DOM || !1, rt = l.RETURN_DOM_FRAGMENT || !1, Oe = l.RETURN_TRUSTED_TYPE || !1, pt = l.FORCE_BODY || !1, yt = l.SANITIZE_DOM !== !1, Rt = l.SANITIZE_NAMED_PROPS || !1, Fe = l.KEEP_CONTENT !== !1, be = l.IN_PLACE || !1, oe = l.ALLOWED_URI_REGEXP || Eo, et = l.NAMESPACE || Ie, at = l.MATHML_TEXT_INTEGRATION_POINTS || at, nt = l.HTML_INTEGRATION_POINTS || nt, te = l.CUSTOM_ELEMENT_HANDLING || {}, l.CUSTOM_ELEMENT_HANDLING && F(l.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (te.tagNameCheck = l.CUSTOM_ELEMENT_HANDLING.tagNameCheck), l.CUSTOM_ELEMENT_HANDLING && F(l.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (te.attributeNameCheck = l.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), l.CUSTOM_ELEMENT_HANDLING && typeof l.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (te.allowCustomizedBuiltInElements = l.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ae && (Te = !1), rt && (Be = !0), Je && (X = Q({}, lo), ie = jt(null), Je.html === !0 && (Q(X, so), Q(ie, co)), Je.svg === !0 && (Q(X, bn), Q(ie, xn), Q(ie, Dt)), Je.svgFilters === !0 && (Q(X, mn), Q(ie, xn), Q(ie, Dt)), Je.mathMl === !0 && (Q(X, gn), Q(ie, po), Q(ie, Dt))), Ne(l, "ADD_TAGS") || (G.tagCheck = null), Ne(l, "ADD_ATTR") || (G.attributeCheck = null), l.ADD_TAGS && (typeof l.ADD_TAGS == "function" ? G.tagCheck = l.ADD_TAGS : (X === De && (X = We(X)), Q(X, l.ADD_TAGS, se))), l.ADD_ATTR && (typeof l.ADD_ATTR == "function" ? G.attributeCheck = l.ADD_ATTR : (ie === dt && (ie = We(ie)), Q(ie, l.ADD_ATTR, se))), l.ADD_URI_SAFE_ATTR && Q(Ve, l.ADD_URI_SAFE_ATTR, se), l.FORBID_CONTENTS && (me === Xe && (me = We(me)), Q(me, l.FORBID_CONTENTS, se)), l.ADD_FORBID_CONTENTS && (me === Xe && (me = We(me)), Q(me, l.ADD_FORBID_CONTENTS, se)), Fe && (X["#text"] = !0), ze && Q(X, ["html", "head", "body"]), X.table && (Q(X, ["tbody"]), delete N.tbody), l.TRUSTED_TYPES_POLICY) {
        if (typeof l.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Nt('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof l.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Nt('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        g = l.TRUSTED_TYPES_POLICY, z = g.createHTML("");
      } else
        g === void 0 && (g = Yr(b, i)), g !== null && typeof z == "string" && (z = g.createHTML(""));
      we && we(l), h = l;
    }
  }, je = Q({}, [...bn, ...mn, ...Dr]), Ce = Q({}, [...gn, ...Lr]), ge = function(l) {
    let v = A(l);
    (!v || !v.tagName) && (v = {
      namespaceURI: et,
      tagName: "template"
    });
    const O = Pt(l.tagName), ae = Pt(v.tagName);
    return tt[l.namespaceURI] ? l.namespaceURI === Le ? v.namespaceURI === Ie ? O === "svg" : v.namespaceURI === Ze ? O === "svg" && (ae === "annotation-xml" || at[ae]) : !!je[O] : l.namespaceURI === Ze ? v.namespaceURI === Ie ? O === "math" : v.namespaceURI === Le ? O === "math" && nt[ae] : !!Ce[O] : l.namespaceURI === Ie ? v.namespaceURI === Le && !nt[ae] || v.namespaceURI === Ze && !at[ae] ? !1 : !Ce[O] && (Vt[O] || !je[O]) : !!(ye === "application/xhtml+xml" && tt[l.namespaceURI]) : !1;
  }, ue = function(l) {
    Mt(n.removed, {
      element: l
    });
    try {
      A(l).removeChild(l);
    } catch {
      C(l);
    }
  }, Z = function(l, v) {
    try {
      Mt(n.removed, {
        attribute: v.getAttributeNode(l),
        from: v
      });
    } catch {
      Mt(n.removed, {
        attribute: null,
        from: v
      });
    }
    if (v.removeAttribute(l), l === "is")
      if (Be || rt)
        try {
          ue(v);
        } catch {
        }
      else
        try {
          v.setAttribute(l, "");
        } catch {
        }
  }, ce = function(l) {
    let v = null, O = null;
    if (pt)
      l = "<remove></remove>" + l;
    else {
      const pe = fn(l, /^[\r\n\t ]+/);
      O = pe && pe[0];
    }
    ye === "application/xhtml+xml" && et === Ie && (l = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + l + "</body></html>");
    const ae = g ? g.createHTML(l) : l;
    if (et === Ie)
      try {
        v = new S().parseFromString(ae, ye);
      } catch {
      }
    if (!v || !v.documentElement) {
      v = L.createDocument(et, "template", null);
      try {
        v.documentElement.innerHTML = kt ? z : ae;
      } catch {
      }
    }
    const ve = v.body || v.documentElement;
    return l && O && ve.insertBefore(o.createTextNode(O), ve.childNodes[0] || null), et === Ie ? j.call(v, ze ? "html" : "body")[0] : ze ? v.documentElement : ve;
  }, Pe = function(l) {
    return T.call(
      l.ownerDocument || l,
      l,
      // eslint-disable-next-line no-bitwise
      u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT | u.SHOW_PROCESSING_INSTRUCTION | u.SHOW_CDATA_SECTION,
      null
    );
  }, st = function(l) {
    return l instanceof m && (typeof l.nodeName != "string" || typeof l.textContent != "string" || typeof l.removeChild != "function" || !(l.attributes instanceof y) || typeof l.removeAttribute != "function" || typeof l.setAttribute != "function" || typeof l.namespaceURI != "string" || typeof l.insertBefore != "function" || typeof l.hasChildNodes != "function");
  }, ut = function(l) {
    return typeof c == "function" && l instanceof c;
  };
  function de(D, l, v) {
    It(D, (O) => {
      O.call(n, l, v, h);
    });
  }
  const He = function(l) {
    let v = null;
    if (de(U.beforeSanitizeElements, l, null), st(l))
      return ue(l), !0;
    const O = se(l.nodeName);
    if (de(U.uponSanitizeElement, l, {
      tagName: O,
      allowedTags: X
    }), ot && l.hasChildNodes() && !ut(l.firstElementChild) && ke(/<[/\w!]/g, l.innerHTML) && ke(/<[/\w!]/g, l.textContent) || l.nodeType === zt.progressingInstruction || ot && l.nodeType === zt.comment && ke(/<[/\w]/g, l.data))
      return ue(l), !0;
    if (!(G.tagCheck instanceof Function && G.tagCheck(O)) && (!X[O] || N[O])) {
      if (!N[O] && wt(O) && (te.tagNameCheck instanceof RegExp && ke(te.tagNameCheck, O) || te.tagNameCheck instanceof Function && te.tagNameCheck(O)))
        return !1;
      if (Fe && !me[O]) {
        const ae = A(l) || l.parentNode, ve = _(l) || l.childNodes;
        if (ve && ae) {
          const pe = ve.length;
          for (let _e = pe - 1; _e >= 0; --_e) {
            const Ge = f(ve[_e], !0);
            Ge.__removalCount = (l.__removalCount || 0) + 1, ae.insertBefore(Ge, I(l));
          }
        }
      }
      return ue(l), !0;
    }
    return l instanceof p && !ge(l) || (O === "noscript" || O === "noembed" || O === "noframes") && ke(/<\/no(script|embed|frames)/i, l.innerHTML) ? (ue(l), !0) : (Ae && l.nodeType === zt.text && (v = l.textContent, It([W, J, R], (ae) => {
      v = Ct(v, ae, " ");
    }), l.textContent !== v && (Mt(n.removed, {
      element: l.cloneNode()
    }), l.textContent = v)), de(U.afterSanitizeElements, l, null), !1);
  }, $e = function(l, v, O) {
    if (E[v] || yt && (v === "id" || v === "name") && (O in o || O in Y))
      return !1;
    if (!(Te && !E[v] && ke(K, v))) {
      if (!(Re && ke(re, v))) {
        if (!(G.attributeCheck instanceof Function && G.attributeCheck(v, l))) {
          if (!ie[v] || E[v]) {
            if (
              // First condition does a very basic check if a) it's basically a valid custom element tagname AND
              // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
              !(wt(l) && (te.tagNameCheck instanceof RegExp && ke(te.tagNameCheck, l) || te.tagNameCheck instanceof Function && te.tagNameCheck(l)) && (te.attributeNameCheck instanceof RegExp && ke(te.attributeNameCheck, v) || te.attributeNameCheck instanceof Function && te.attributeNameCheck(v, l)) || // Alternative, second condition checks if it's an `is`-attribute, AND
              // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              v === "is" && te.allowCustomizedBuiltInElements && (te.tagNameCheck instanceof RegExp && ke(te.tagNameCheck, O) || te.tagNameCheck instanceof Function && te.tagNameCheck(O)))
            ) return !1;
          } else if (!Ve[v]) {
            if (!ke(oe, Ct(O, ne, ""))) {
              if (!((v === "src" || v === "xlink:href" || v === "href") && l !== "script" && Er(O, "data:") === 0 && it[l])) {
                if (!(fe && !ke($, Ct(O, ne, "")))) {
                  if (O)
                    return !1;
                }
              }
            }
          }
        }
      }
    }
    return !0;
  }, wt = function(l) {
    return l !== "annotation-xml" && fn(l, ee);
  }, St = function(l) {
    de(U.beforeSanitizeAttributes, l, null);
    const {
      attributes: v
    } = l;
    if (!v || st(l))
      return;
    const O = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: ie,
      forceKeepAttr: void 0
    };
    let ae = v.length;
    for (; ae--; ) {
      const ve = v[ae], {
        name: pe,
        namespaceURI: _e,
        value: Ge
      } = ve, ft = se(pe), Kt = Ge;
      let xe = pe === "value" ? Kt : Rr(Kt);
      if (O.attrName = ft, O.attrValue = xe, O.keepAttr = !0, O.forceKeepAttr = void 0, de(U.uponSanitizeAttribute, l, O), xe = O.attrValue, Rt && (ft === "id" || ft === "name") && (Z(pe, l), xe = Ft + xe), ot && ke(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, xe)) {
        Z(pe, l);
        continue;
      }
      if (ft === "attributename" && fn(xe, "href")) {
        Z(pe, l);
        continue;
      }
      if (O.forceKeepAttr)
        continue;
      if (!O.keepAttr) {
        Z(pe, l);
        continue;
      }
      if (!xt && ke(/\/>/i, xe)) {
        Z(pe, l);
        continue;
      }
      Ae && It([W, J, R], (Rn) => {
        xe = Ct(xe, Rn, " ");
      });
      const En = se(l.nodeName);
      if (!$e(En, ft, xe)) {
        Z(pe, l);
        continue;
      }
      if (g && typeof b == "object" && typeof b.getAttributeType == "function" && !_e)
        switch (b.getAttributeType(En, ft)) {
          case "TrustedHTML": {
            xe = g.createHTML(xe);
            break;
          }
          case "TrustedScriptURL": {
            xe = g.createScriptURL(xe);
            break;
          }
        }
      if (xe !== Kt)
        try {
          _e ? l.setAttributeNS(_e, pe, xe) : l.setAttribute(pe, xe), st(l) ? ue(l) : ao(n.removed);
        } catch {
          Z(pe, l);
        }
    }
    de(U.afterSanitizeAttributes, l, null);
  }, Ue = function D(l) {
    let v = null;
    const O = Pe(l);
    for (de(U.beforeSanitizeShadowDOM, l, null); v = O.nextNode(); )
      de(U.uponSanitizeShadowNode, v, null), He(v), St(v), v.content instanceof a && D(v.content);
    de(U.afterSanitizeShadowDOM, l, null);
  };
  return n.sanitize = function(D) {
    let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, v = null, O = null, ae = null, ve = null;
    if (kt = !D, kt && (D = "<!-->"), typeof D != "string" && !ut(D))
      if (typeof D.toString == "function") {
        if (D = D.toString(), typeof D != "string")
          throw Nt("dirty is not a string, aborting");
      } else
        throw Nt("toString is not a function");
    if (!n.isSupported)
      return D;
    if (qe || le(l), n.removed = [], typeof D == "string" && (be = !1), be) {
      if (D.nodeName) {
        const Ge = se(D.nodeName);
        if (!X[Ge] || N[Ge])
          throw Nt("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (D instanceof c)
      v = ce("<!---->"), O = v.ownerDocument.importNode(D, !0), O.nodeType === zt.element && O.nodeName === "BODY" || O.nodeName === "HTML" ? v = O : v.appendChild(O);
    else {
      if (!Be && !Ae && !ze && // eslint-disable-next-line unicorn/prefer-includes
      D.indexOf("<") === -1)
        return g && Oe ? g.createHTML(D) : D;
      if (v = ce(D), !v)
        return Be ? null : Oe ? z : "";
    }
    v && pt && ue(v.firstChild);
    const pe = Pe(be ? D : v);
    for (; ae = pe.nextNode(); )
      He(ae), St(ae), ae.content instanceof a && Ue(ae.content);
    if (be)
      return D;
    if (Be) {
      if (rt)
        for (ve = H.call(v.ownerDocument); v.firstChild; )
          ve.appendChild(v.firstChild);
      else
        ve = v;
      return (ie.shadowroot || ie.shadowrootmode) && (ve = B.call(r, ve, !0)), ve;
    }
    let _e = ze ? v.outerHTML : v.innerHTML;
    return ze && X["!doctype"] && v.ownerDocument && v.ownerDocument.doctype && v.ownerDocument.doctype.name && ke(Ro, v.ownerDocument.doctype.name) && (_e = "<!DOCTYPE " + v.ownerDocument.doctype.name + `>
` + _e), Ae && It([W, J, R], (Ge) => {
      _e = Ct(_e, Ge, " ");
    }), g && Oe ? g.createHTML(_e) : _e;
  }, n.setConfig = function() {
    let D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    le(D), qe = !0;
  }, n.clearConfig = function() {
    h = null, qe = !1;
  }, n.isValidAttribute = function(D, l, v) {
    h || le({});
    const O = se(D), ae = se(l);
    return $e(O, ae, v);
  }, n.addHook = function(D, l) {
    typeof l == "function" && Mt(U[D], l);
  }, n.removeHook = function(D, l) {
    if (l !== void 0) {
      const v = Ar(U[D], l);
      return v === -1 ? void 0 : zr(U[D], v, 1)[0];
    }
    return ao(U[D]);
  }, n.removeHooks = function(D) {
    U[D] = [];
  }, n.removeAllHooks = function() {
    U = uo();
  }, n;
}
var Kr = Oo();
const qr = {
  "theonepsa.com": "psa",
  "theonecrm.app": "crm",
  "theonermm.app": "rmm",
  "theonesecurity.app": "security",
  "theonebackups.app": "backups",
  "theoneprojects.app": "projects",
  "theonebooks.app": "books",
  "voice.theonestack.com": "voice",
  "theonestudio.app": "ai-studio",
  "theonelivekit.app": "livekit",
  // 'theonemission.app' removed 2026-04-15: Mission is now a standalone app at app.theonemission.app (no Hub Bar)
  "theoneams.com": "ams",
  "theonefleet.app": "fleet",
  "theonepeople.app": "people",
  "theonecmdb.app": "cmdb",
  "theoneoncall.app": "oncall",
  "theonevisitor.app": "visitor",
  "theonelegal.app": "legal",
  "mspcollective.io": "collective",
  "theoneportal.app": "portal",
  "theonebridge.app": "bridge",
  "theonecanvas.app": "canvas",
  "theonemigrate.app": "migrate",
  "theonebrand.app": "brand",
  "ops.theonestack.com": "ops-center",
  "theonestack.com": "hub"
};
function Br(t) {
  for (const [n, o] of Object.entries(qr))
    if (t.includes(n)) return o;
  return null;
}
const Jr = [
  [/\/tickets?\/([\w-]+)/, "ticket"],
  [/\/companies?\/([\w-]+)/, "company"],
  [/\/contacts?\/([\w-]+)/, "contact"],
  [/\/devices?\/([\w-]+)/, "device"],
  [/\/invoices?\/([\w-]+)/, "invoice"],
  [/\/opportunities?\/([\w-]+)/, "opportunity"],
  [/\/projects?\/([\w-]+)/, "project"],
  [/\/incidents?\/([\w-]+)/, "incident"],
  [/\/contracts?\/([\w-]+)/, "contract"],
  [/\/employees?\/([\w-]+)/, "employee"],
  [/\/configurations?\/([\w-]+)/, "configuration_item"],
  [/\/alerts?\/([\w-]+)/, "alert"],
  [/\/calls?\/([\w-]+)/, "call"],
  [/\/recordings?\/([\w-]+)/, "call"],
  [/\/recaps?\/([\w-]+)/, "call"]
];
function Xr(t) {
  for (const [n, o] of Jr) {
    const r = t.match(n);
    if (r != null && r[1] && r[1] !== "new" && r[1] !== "list")
      return { entity_type: o, entity_id: r[1] };
  }
  return {};
}
function yn() {
  const t = Br(window.location.hostname), { entity_type: n, entity_id: o } = Xr(window.location.pathname);
  return { product: t, page: window.location.pathname, entity_type: n, entity_id: o };
}
const vn = {
  ticket: [
    { label: "Summarize this ticket", prompt: "Summarize this ticket including its history and current status." },
    { label: "Find similar tickets", prompt: "Search for similar tickets that might be related to this one." },
    { label: "Draft a response", prompt: "Draft a professional response to the client for this ticket." },
    { label: "Check SLA status", prompt: "What is the SLA status for this ticket? Is it at risk of breaching?" }
  ],
  company: [
    { label: "Full company picture", prompt: "Give me a complete picture of this company — tickets, revenue, devices, security posture." },
    { label: "Open tickets", prompt: "What are the open tickets for this company?" },
    { label: "Revenue summary", prompt: "Show me the revenue summary for this company." },
    { label: "Device health", prompt: "What is the device health status for this company?" }
  ],
  device: [
    { label: "What's wrong?", prompt: "What's wrong with this device? Show me recent alerts and issues." },
    { label: "Recent alerts", prompt: "Show me the recent alerts for this device." },
    { label: "Similar issues", prompt: "Are there similar issues on other devices?" }
  ],
  invoice: [
    { label: "Payment status", prompt: "What is the payment status of this invoice?" },
    { label: "Customer history", prompt: "Show me the payment history for this customer." }
  ],
  call: [
    { label: "Call summary", prompt: "Summarize this call — what was discussed, sentiment, and any action items." },
    { label: "Extract action items", prompt: "Extract all action items from this call and suggest ticket creation for each." },
    { label: "Full transcript", prompt: "Show me the full transcript of this call." },
    { label: "Follow up", prompt: "Draft a follow-up message to the caller based on this call." }
  ],
  contact: [
    { label: "Text this contact", prompt: "Help me draft and send an SMS to this contact." },
    { label: "Call this contact", prompt: "Connect me to this contact via phone." },
    { label: "Communication history", prompt: "Show me all recent calls and messages with this contact." },
    { label: "Email this contact", prompt: "Help me draft and send an email to this contact." }
  ],
  dashboard: [
    { label: "What needs attention?", prompt: "What needs my attention today? Show me critical items across all products." },
    { label: "Show overdue items", prompt: "What items are overdue — tickets, invoices, tasks?" },
    { label: "SLA alerts", prompt: "Are there any SLA alerts or at-risk tickets right now?" },
    { label: "Revenue this month", prompt: "What's our revenue looking like this month?" }
  ]
};
function Qr(t) {
  return t.entity_type && vn[t.entity_type] ? vn[t.entity_type] : t.page === "/" || t.page.includes("dashboard") ? vn.dashboard : [
    { label: "What needs attention?", prompt: "What needs my attention today?" },
    { label: "Search tickets", prompt: "Search for recent open tickets." },
    { label: "Company health", prompt: "Show me a summary of company health scores." }
  ];
}
const $t = "jarvis_messages", Io = 50;
function Zr() {
  try {
    const t = sessionStorage.getItem($t);
    return t ? JSON.parse(t).slice(-Io) : [];
  } catch {
    return [];
  }
}
function ei(t) {
  try {
    sessionStorage.setItem($t, JSON.stringify(t.slice(-Io)));
  } catch {
    sessionStorage.removeItem($t);
  }
}
let ti = 0;
function Lt() {
  return `jm_${Date.now()}_${++ti}`;
}
function ni(t, n, o) {
  const [r, i] = x(Zr), [a, d] = x(!1), [c, p] = x(yn), [u, y] = x([]), m = q(null), S = q("");
  V(() => {
    const I = () => {
      const A = yn();
      p(A), y(Qr(A));
    };
    I(), window.addEventListener("popstate", I);
    const _ = new MutationObserver(() => {
      yn().page !== c.page && I();
    });
    return _.observe(document.querySelector("title") || document.head, { childList: !0, subtree: !0 }), () => {
      window.removeEventListener("popstate", I), _.disconnect();
    };
  }, [c.page]), V(() => {
    ei(r);
  }, [r]);
  const b = P(async (I) => {
    if (!I.trim() || a || !n) return;
    const _ = {
      id: Lt(),
      role: "user",
      content: I.trim(),
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    }, A = {
      id: Lt(),
      role: "assistant",
      content: "",
      tool_calls: [],
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    };
    i((z) => [...z, _, A]), d(!0), S.current = "";
    const g = new AbortController();
    m.current = g;
    try {
      const L = {
        model: "gpt-4.1-mini",
        messages: [...r.slice(-18), _].map((W) => ({
          role: W.role,
          content: W.content
        })),
        stream: !0,
        context: {
          product: c.product,
          entity_type: c.entity_type,
          entity_id: c.entity_id,
          page_url: window.location.href
        }
      }, T = await fetch(`${t}/api/ai/chat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-tenant-id": n,
          "x-ai-tier": "jarvis_free"
        },
        credentials: "include",
        body: JSON.stringify(L),
        signal: g.signal
      });
      if (!T.ok) {
        const W = await T.json().catch(() => ({ error: T.statusText }));
        throw new Error(W.error || W.message || `Error ${T.status}`);
      }
      if (!T.body) throw new Error("No response body");
      const H = T.body.getReader(), j = new TextDecoder();
      let B = "";
      const U = [];
      for (; ; ) {
        const { done: W, value: J } = await H.read();
        if (W) break;
        B += j.decode(J, { stream: !0 });
        const R = B.split(`
`);
        B = R.pop() || "";
        for (const K of R) {
          if (!K.startsWith("data: ")) continue;
          const re = K.slice(6).trim();
          if (re === "[DONE]") break;
          try {
            const $ = JSON.parse(re);
            if ($.type === "content_delta" && $.text) {
              S.current += $.text;
              const ne = S.current;
              i((ee) => {
                const oe = [...ee], X = oe[oe.length - 1];
                return X && X.id === A.id && (oe[oe.length - 1] = { ...X, content: ne }), oe;
              });
            } else if ($.type === "tool_use_start" && $.name) {
              U.push({ name: $.name, status: "running" });
              const ne = [...U];
              i((ee) => {
                const oe = [...ee], X = oe[oe.length - 1];
                return X && X.id === A.id && (oe[oe.length - 1] = { ...X, tool_calls: ne }), oe;
              });
            } else if ($.type === "message_stop") {
              U.forEach((ee) => {
                ee.status === "running" && (ee.status = "done");
              });
              const ne = [...U];
              i((ee) => {
                const oe = [...ee], X = oe[oe.length - 1];
                return X && X.id === A.id && (oe[oe.length - 1] = { ...X, tool_calls: ne }), oe;
              });
            } else if ($.type === "error")
              throw new Error($.message || "Stream error");
          } catch ($) {
            if ($ instanceof Error && $.message !== "Stream error") continue;
            throw $;
          }
        }
      }
    } catch (z) {
      if (!(z instanceof DOMException && z.name === "AbortError")) {
        const L = z instanceof Error ? z.message : "Something went wrong. Please try again.";
        i((T) => {
          const H = [...T], j = H[H.length - 1];
          return j && j.id === A.id && (H[H.length - 1] = {
            ...j,
            content: j.content || L,
            error: !0
          }), H;
        });
      }
    } finally {
      d(!1), m.current = null;
    }
  }, [t, n, r, a, c]), w = P(() => {
    m.current && (m.current.abort(), m.current = null);
  }, []), f = P(() => {
    i([]), sessionStorage.removeItem($t);
  }, []), C = P((I, _) => {
    const A = {
      id: Lt(),
      role: "user",
      content: I,
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    }, g = {
      id: Lt(),
      role: "assistant",
      content: _,
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    };
    i((z) => [...z, A, g]);
  }, []);
  return {
    messages: r,
    streaming: a,
    context: c,
    quickActions: u,
    sendMessage: b,
    stopStreaming: w,
    clearMessages: f,
    addMessages: C
  };
}
const oi = 0.01, ri = 800, ii = 100;
function ai(t, n, o) {
  const [r, i] = x("idle"), [a, d] = x(null), [c, p] = x(null), u = q(null), y = q([]), m = q(null), S = q(null), b = q(null), w = q(null), f = q(null), C = q(null), I = q(null), _ = q(!0);
  V(() => (_.current = !0, () => {
    _.current = !1, A();
  }), []);
  const A = P(() => {
    var W;
    C.current && (clearInterval(C.current), C.current = null), ((W = u.current) == null ? void 0 : W.state) === "recording" && u.current.stop(), u.current = null, y.current = [], b.current && (b.current.disconnect(), b.current = null), w.current && (w.current.getTracks().forEach((J) => J.stop()), w.current = null), g();
  }, []), g = P(() => {
    if (I.current) {
      try {
        I.current.stop();
      } catch {
      }
      I.current = null;
    }
  }, []), z = P((W) => {
    m.current || (m.current = new AudioContext());
    const J = m.current, R = J.createAnalyser();
    R.fftSize = 512, S.current = R;
    const K = J.createMediaStreamSource(W);
    K.connect(R), b.current = K;
    const re = new Float32Array(R.fftSize);
    f.current = null, C.current = setInterval(() => {
      R.getFloatTimeDomainData(re);
      let $ = 0;
      for (let ee = 0; ee < re.length; ee++)
        $ += re[ee] * re[ee];
      Math.sqrt($ / re.length) < oi ? f.current ? Date.now() - f.current >= ri && H() : f.current = Date.now() : f.current = null;
    }, ii);
  }, []), L = P(async (W) => {
    if (!(!n || !_.current)) {
      i("processing"), p(null);
      try {
        const J = new FormData();
        J.append("audio", W, "recording.webm");
        const R = await fetch(`${t}/api/v1/theo/voice-chat/stream`, {
          method: "POST",
          headers: {
            "x-tenant-id": n
          },
          credentials: "include",
          body: J
        });
        if (!_.current) return;
        if (R.status === 403) {
          p("Voice mode requires a Pro subscription."), i("idle");
          return;
        }
        if (!R.ok) {
          const re = await R.json().catch(() => ({ error: `Error ${R.status}` }));
          throw new Error(re.error || `Error ${R.status}`);
        }
        const K = await R.json();
        if (!_.current) return;
        if (!K.transcript) {
          i("idle");
          return;
        }
        d({
          transcript: K.transcript,
          response_text: K.response_text
        }), K.audio_base64 ? await T(K.audio_base64, K.content_type) : i("idle");
      } catch (J) {
        if (!_.current) return;
        const R = J instanceof Error ? J.message : "Voice request failed";
        console.error("[useVoiceChat] sendAudio error:", J), p(R), i("idle");
      }
    }
  }, [t, n]), T = P(async (W, J) => {
    if (_.current) {
      i("playing");
      try {
        m.current || (m.current = new AudioContext());
        const R = m.current, K = atob(W), re = new Uint8Array(K.length);
        for (let ee = 0; ee < K.length; ee++)
          re[ee] = K.charCodeAt(ee);
        let $;
        if (J.includes("pcm") || J.includes("raw")) {
          const ee = new Int16Array(re.buffer);
          $ = R.createBuffer(1, ee.length, 16e3);
          const oe = $.getChannelData(0);
          for (let X = 0; X < ee.length; X++)
            oe[X] = ee[X] / 32768;
        } else
          $ = await R.decodeAudioData(re.buffer.slice(0));
        if (!_.current) return;
        const ne = R.createBufferSource();
        ne.buffer = $, ne.connect(R.destination), I.current = ne, ne.onended = () => {
          I.current = null, _.current && i("idle");
        }, ne.start();
      } catch (R) {
        console.error("[useVoiceChat] playAudio error:", R), _.current && i("idle");
      }
    }
  }, []), H = P(() => {
    C.current && (clearInterval(C.current), C.current = null), b.current && (b.current.disconnect(), b.current = null);
    const W = u.current;
    W && W.state === "recording" && W.stop();
  }, []), j = P(async () => {
    if (!o) {
      p("Voice mode requires a Pro subscription.");
      return;
    }
    p(null);
    try {
      const W = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: !0,
          noiseSuppression: !0,
          sampleRate: 16e3
        }
      });
      if (!_.current) {
        W.getTracks().forEach((R) => R.stop());
        return;
      }
      w.current = W, y.current = [];
      const J = new MediaRecorder(W, {
        mimeType: MediaRecorder.isTypeSupported("audio/webm;codecs=opus") ? "audio/webm;codecs=opus" : "audio/webm"
      });
      J.ondataavailable = (R) => {
        R.data.size > 0 && y.current.push(R.data);
      }, J.onstop = () => {
        const R = y.current;
        if (y.current = [], W.getTracks().forEach((K) => K.stop()), w.current = null, R.length > 0) {
          const K = new Blob(R, { type: J.mimeType });
          L(K);
        } else
          _.current && i("idle");
      }, u.current = J, J.start(250), z(W), i("recording");
    } catch (W) {
      console.error("[useVoiceChat] getUserMedia error:", W), W instanceof DOMException && W.name === "NotAllowedError" ? p("Microphone access denied. Please allow microphone access in your browser settings.") : p("Could not access microphone."), i("idle");
    }
  }, [o, L, z]), B = P(() => {
    switch (r) {
      case "idle":
        j();
        break;
      case "recording":
        H();
        break;
      case "playing":
        g(), i("idle"), setTimeout(() => {
          _.current && j();
        }, 100);
        break;
    }
  }, [r, j, H, g]), U = P(() => {
    A(), i("idle"), p(null);
  }, [A]);
  return {
    state: r,
    lastResult: a,
    error: c,
    toggleVoice: B,
    stopVoice: U,
    isActive: r !== "idle"
  };
}
function si(t) {
  return t ? t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/```(\w*)\n?([\s\S]*?)```/g, '<pre class="hb-jv-code-block"><code>$2</code></pre>').replace(/`([^`]+)`/g, '<code class="hb-jv-inline-code">$1</code>').replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/\*(.+?)\*/g, "<em>$1</em>").replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" class="hb-jv-link">$1</a>').replace(/^[•\-\*] (.+)$/gm, "<li>$1</li>").replace(/^\d+\. (.+)$/gm, "<li>$1</li>").replace(/(<li>[\s\S]*?<\/li>)/g, '<ul class="hb-jv-list">$1</ul>').replace(/<\/ul>\s*<ul class="hb-jv-list">/g, "").replace(/\n/g, "<br>") : "";
}
const li = {
  search_tickets: "Searching tickets",
  get_ticket: "Fetching ticket details",
  create_ticket: "Creating ticket",
  update_ticket: "Updating ticket",
  get_company_info: "Looking up company",
  search_companies: "Searching companies",
  search_contacts: "Searching contacts",
  get_deals: "Fetching deals",
  get_invoices: "Fetching invoices",
  get_revenue_summary: "Calculating revenue",
  get_device_status: "Checking device status",
  search_devices: "Searching devices",
  run_device_command: "Running command",
  get_security_alerts: "Checking security alerts",
  send_message: "Sending message",
  get_call_history: "Fetching call history",
  get_company_360: "Building company overview",
  get_health_score: "Calculating health score",
  get_briefing: "Generating daily briefing",
  cross_search: "Searching across products"
};
function ci({ tool: t }) {
  const n = li[t.name] || t.name.replace(/_/g, " "), o = t.status === "running", r = t.status === "error";
  return /* @__PURE__ */ s("div", { className: `hb-jv-tool-call${o ? " running" : ""}${r ? " error" : ""}`, children: [
    /* @__PURE__ */ e("div", { className: "hb-jv-tool-icon", children: o ? /* @__PURE__ */ e("span", { className: "hb-jv-tool-spinner" }) : r ? /* @__PURE__ */ e("span", { style: { color: "#f87171" }, children: "!" }) : /* @__PURE__ */ e("span", { style: { color: "#34d399" }, children: "✓" }) }),
    /* @__PURE__ */ s("span", { className: "hb-jv-tool-label", children: [
      n,
      o ? "…" : ""
    ] }),
    t.summary && /* @__PURE__ */ e("span", { className: "hb-jv-tool-summary", children: t.summary })
  ] });
}
function di({ message: t, isStreaming: n }) {
  if (t.role === "user")
    return /* @__PURE__ */ e("div", { className: "hb-jv-msg hb-jv-msg-user", children: /* @__PURE__ */ e("div", { className: "hb-jv-bubble hb-jv-bubble-user", children: t.content }) });
  const r = t.content.length > 0, i = t.tool_calls && t.tool_calls.length > 0;
  return /* @__PURE__ */ s("div", { className: "hb-jv-msg hb-jv-msg-assistant", children: [
    /* @__PURE__ */ e("div", { className: "hb-jv-avatar", children: /* @__PURE__ */ e(Ye, { size: 14, color: "#f97316" }) }),
    /* @__PURE__ */ s("div", { className: "hb-jv-bubble-wrap", children: [
      i && /* @__PURE__ */ e("div", { className: "hb-jv-tool-calls", children: t.tool_calls.map((a, d) => /* @__PURE__ */ e(ci, { tool: a }, d)) }),
      r && /* @__PURE__ */ e(
        "div",
        {
          className: `hb-jv-bubble hb-jv-bubble-assistant${t.error ? " error" : ""}`,
          dangerouslySetInnerHTML: { __html: Kr.sanitize(si(t.content)) }
        }
      ),
      !r && n && /* @__PURE__ */ e("div", { className: "hb-jv-bubble hb-jv-bubble-assistant", children: /* @__PURE__ */ s("span", { className: "hb-jv-typing", children: [
        /* @__PURE__ */ e("span", {}),
        /* @__PURE__ */ e("span", {}),
        /* @__PURE__ */ e("span", {})
      ] }) })
    ] })
  ] });
}
function pi({ actions: t, onSelect: n, disabled: o }) {
  return t.length === 0 ? null : /* @__PURE__ */ e("div", { className: "hb-jv-quick-actions", children: t.map((r, i) => /* @__PURE__ */ e(
    "button",
    {
      className: "hb-jv-quick-chip",
      onClick: () => n(r.prompt),
      disabled: o,
      children: r.label
    },
    i
  )) });
}
function hi({
  apiBase: t,
  tenantId: n,
  userId: o,
  entitlements: r
}) {
  const [i, a] = x(!1), { messages: d, streaming: c, context: p, quickActions: u, sendMessage: y, stopStreaming: m, clearMessages: S, addMessages: b } = ni(t, n), [w, f] = x(""), C = q(null), I = q(null), [_] = x(!1), A = !!r && (r.includes("theo_pro") || r.includes("theo_team") || r.includes("theo_enterprise") || r.includes("theo_voice")), { state: g, lastResult: z, error: L, toggleVoice: T, stopVoice: H, isActive: j } = ai(t, n, A);
  V(() => {
    const R = (K) => {
      (K.metaKey || K.ctrlKey) && K.key === "j" && (K.preventDefault(), a((re) => !re)), K.key === "Escape" && i && a(!1);
    };
    return document.addEventListener("keydown", R), () => document.removeEventListener("keydown", R);
  }, [i]), V(() => {
    C.current && C.current.scrollIntoView({ behavior: "smooth" });
  }, [d]), V(() => {
    i && I.current && setTimeout(() => {
      var R;
      return (R = I.current) == null ? void 0 : R.focus();
    }, 100);
  }, [i]), V(() => {
    z && b(z.transcript, z.response_text);
  }, [z, b]), V(() => {
    !i && j && H();
  }, [i, j, H]);
  const B = P(() => {
    !w.trim() || c || (y(w.trim()), f(""));
  }, [w, c, y]), U = P((R) => {
    y(R);
  }, [y]), W = P((R) => {
    R.key === "Enter" && !R.shiftKey && (R.preventDefault(), B());
  }, [B]), J = i ? Ut(
    /* @__PURE__ */ e("div", { className: "hb-jv-overlay", onClick: () => a(!1), children: /* @__PURE__ */ s(
      "div",
      {
        className: "hb-jv-panel",
        onClick: (R) => R.stopPropagation(),
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "THEO AI Assistant",
        children: [
          /* @__PURE__ */ s("div", { className: "hb-jv-header", children: [
            /* @__PURE__ */ s("div", { className: "hb-jv-header-left", children: [
              /* @__PURE__ */ e(Ye, { size: 16, color: "#f97316" }),
              /* @__PURE__ */ e("span", { className: "hb-jv-header-title", children: "THEO" }),
              /* @__PURE__ */ e("span", { className: "hb-jv-model-badge", children: "GPT-4.1 mini" })
            ] }),
            /* @__PURE__ */ s("div", { className: "hb-jv-header-right", children: [
              d.length > 0 && /* @__PURE__ */ e(
                "button",
                {
                  className: "hb-jv-clear-btn",
                  onClick: S,
                  title: "Clear conversation",
                  "aria-label": "Clear conversation",
                  children: "Clear"
                }
              ),
              /* @__PURE__ */ e(
                "button",
                {
                  className: "hb-jv-close-btn",
                  onClick: () => a(!1),
                  "aria-label": "Close THEO",
                  children: /* @__PURE__ */ e(Ke, { size: 16 })
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ s("div", { className: "hb-jv-messages", children: [
            d.length === 0 ? /* @__PURE__ */ s("div", { className: "hb-jv-welcome", children: [
              /* @__PURE__ */ e("div", { className: "hb-jv-welcome-icon", children: /* @__PURE__ */ e(Ye, { size: 28, color: "#f97316" }) }),
              /* @__PURE__ */ e("div", { className: "hb-jv-welcome-title", children: "Hey, I'm THEO" }),
              /* @__PURE__ */ e("div", { className: "hb-jv-welcome-sub", children: "Your AI operations assistant for The One Stack. I can help you with tickets, clients, devices, and more." }),
              p.product && /* @__PURE__ */ s("div", { className: "hb-jv-welcome-context", children: [
                "Currently viewing: ",
                /* @__PURE__ */ e("strong", { children: p.product.toUpperCase() }),
                p.entity_type && ` — ${p.entity_type}`,
                p.entity_id && ` ${p.entity_id}`
              ] })
            ] }) : d.map((R, K) => /* @__PURE__ */ e(
              di,
              {
                message: R,
                isStreaming: c && K === d.length - 1 && R.role === "assistant"
              },
              R.id
            )),
            /* @__PURE__ */ e("div", { ref: C })
          ] }),
          d.length === 0 && /* @__PURE__ */ e(
            pi,
            {
              actions: u,
              onSelect: U,
              disabled: c
            }
          ),
          L && /* @__PURE__ */ e("div", { className: "hb-jv-voice-toast", children: L }),
          /* @__PURE__ */ s("div", { className: "hb-jv-input-area", children: [
            j && /* @__PURE__ */ s("div", { className: "hb-jv-voice-indicator", children: [
              /* @__PURE__ */ e("span", { className: "hb-jv-voice-dot" }),
              /* @__PURE__ */ e("span", { children: g === "recording" ? "Listening..." : g === "processing" ? "Thinking..." : g === "playing" ? "Speaking..." : "" }),
              /* @__PURE__ */ e("button", { className: "hb-jv-voice-end", onClick: H, children: "End voice" })
            ] }),
            /* @__PURE__ */ s("div", { className: "hb-jv-input-row", children: [
              /* @__PURE__ */ e(
                "textarea",
                {
                  ref: I,
                  className: "hb-jv-input",
                  placeholder: j ? "Voice mode active — speak or type..." : "Ask THEO anything...",
                  value: w,
                  onChange: (R) => f(R.target.value),
                  onKeyDown: W,
                  rows: 1,
                  disabled: c || g === "processing"
                }
              ),
              /* @__PURE__ */ e(
                "button",
                {
                  className: `hb-jv-mic-btn${g === "recording" ? " recording" : ""}${g === "processing" ? " processing" : ""}${g === "playing" ? " playing" : ""}${A ? "" : " disabled"}`,
                  onClick: A ? T : void 0,
                  title: A ? g === "recording" ? "Stop recording" : g === "playing" ? "Interrupt & speak" : "Start voice mode" : "Voice mode — upgrade to Pro",
                  "aria-label": A ? "Toggle voice mode" : "Voice mode requires Pro subscription",
                  disabled: c || g === "processing",
                  children: /* @__PURE__ */ e(Ht, { size: 16 })
                }
              ),
              c ? /* @__PURE__ */ e(
                "button",
                {
                  className: "hb-jv-stop-btn",
                  onClick: m,
                  title: "Stop generating",
                  "aria-label": "Stop generating",
                  children: /* @__PURE__ */ e("span", { className: "hb-jv-stop-icon" })
                }
              ) : /* @__PURE__ */ e(
                "button",
                {
                  className: "hb-jv-send-btn",
                  onClick: B,
                  disabled: !w.trim(),
                  title: "Send message",
                  "aria-label": "Send message",
                  children: /* @__PURE__ */ s("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [
                    /* @__PURE__ */ e("path", { d: "M22 2L11 13" }),
                    /* @__PURE__ */ e("path", { d: "M22 2L15 22L11 13L2 9L22 2Z" })
                  ] })
                }
              )
            ] }),
            /* @__PURE__ */ s("div", { className: "hb-jv-input-hint", children: [
              /* @__PURE__ */ s("span", { className: "hb-jv-kbd-hint", children: [
                /* @__PURE__ */ e("kbd", { children: "⌘" }),
                /* @__PURE__ */ e("kbd", { children: "J" }),
                " to toggle"
              ] }),
              /* @__PURE__ */ e("span", { className: "hb-jv-powered", children: "Powered by THEO" })
            ] })
          ] })
        ]
      }
    ) }),
    document.body
  ) : null;
  return /* @__PURE__ */ s(he, { children: [
    /* @__PURE__ */ e(
      "button",
      {
        className: `hb-jv-btn${i ? " active" : ""}${_ ? " pulse" : ""}`,
        title: "THEO (⌘J)",
        "aria-label": "Open THEO",
        "aria-expanded": i,
        onClick: () => a((R) => !R),
        children: /* @__PURE__ */ e(Ye, { size: 18 })
      }
    ),
    J
  ] });
}
function ui({ apiBase: t, tenantId: n, userId: o }) {
  const [r, i] = x([]), [a, d] = x([]), [c, p] = x({ overdue: 0, due_today: 0, total: 0 }), [u, y] = x(!1), [m, S] = x("my-day"), b = q(null), w = P(async (L = m) => {
    if (!(!n || !o)) {
      y(!0);
      try {
        const T = await fetch(`${t}/api/hub/tasks?view=${L}&limit=50`, {
          credentials: "include"
        });
        if (!T.ok) return;
        const H = await T.json();
        i(H.data || []);
      } catch {
      } finally {
        y(!1);
      }
    }
  }, [t, n, o, m]), f = P(async () => {
    if (!(!n || !o))
      try {
        const L = await fetch(`${t}/api/hub/tasks/areas`, { credentials: "include" });
        if (!L.ok) return;
        const T = await L.json();
        d(T.data || []);
      } catch {
      }
  }, [t, n, o]), C = P(async () => {
    if (!(!n || !o))
      try {
        const L = await fetch(`${t}/api/hub/tasks/count`, { credentials: "include" });
        if (!L.ok) return;
        const T = await L.json();
        p({ overdue: T.overdue || 0, due_today: T.due_today || 0, total: T.total || 0 });
      } catch {
      }
  }, [t, n, o]);
  V(() => {
    !n || !o || (w("my-day"), f(), C());
  }, [n, o]), V(() => {
    if (!(!n || !o))
      return b.current = setInterval(C, 6e4), () => {
        b.current && clearInterval(b.current);
      };
  }, [n, o, C]);
  const I = P((L) => {
    S(L), w(L);
  }, [w]), _ = P(async (L) => {
    try {
      if (!(await fetch(`${t}/api/hub/tasks/${L}/complete`, {
        method: "POST",
        credentials: "include"
      })).ok) return;
      i((H) => H.filter((j) => j.id !== L)), C();
    } catch {
    }
  }, [t, C]), A = P(async (L) => {
    try {
      const T = await fetch(`${t}/api/hub/tasks`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...L, origin: "manual" })
      });
      if (!T.ok) return null;
      const j = (await T.json()).data;
      return (m === "my-day" || m === "all") && i((B) => [j, ...B]), C(), j;
    } catch {
      return null;
    }
  }, [t, m, C]), g = P(async (L, T) => {
    try {
      const H = await fetch(`${t}/api/hub/tasks/areas`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: L, color: T })
      });
      if (!H.ok) return null;
      const j = await H.json();
      return d((B) => [...B, j.data]), j.data;
    } catch {
      return null;
    }
  }, [t]), z = P(async (L, T) => {
    try {
      const H = await fetch(`${t}/api/hub/tasks/${L}`, {
        method: "PATCH",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(T)
      });
      if (!H.ok) return null;
      const j = await H.json();
      return i((B) => B.map((U) => U.id === L ? { ...U, ...j.data } : U)), j.data;
    } catch {
      return null;
    }
  }, [t]);
  return {
    tasks: r,
    areas: a,
    count: c,
    loading: u,
    currentView: m,
    changeView: I,
    completeTask: _,
    createTask: A,
    createArea: g,
    updateTask: z,
    refetch: () => {
      w(), f(), C();
    }
  };
}
const fi = [
  { id: "my-day", label: "My Day" },
  { id: "my-week", label: "My Week" },
  { id: "all", label: "All Tasks" },
  { id: "assigned-to-me", label: "Assigned to Me" },
  { id: "priority", label: "By Priority" },
  { id: "product", label: "By Product" },
  { id: "done", label: "Completed" }
];
function bi(t) {
  const n = t.trim().split(/\s+/).filter(Boolean);
  return n.length === 0 ? "?" : n.length === 1 ? n[0].slice(0, 2).toUpperCase() : (n[0][0] + n[n.length - 1][0]).toUpperCase();
}
const Cn = {
  urgent: "#ef4444",
  high: "#f97316",
  normal: "#3b82f6",
  low: "#64748b"
}, Do = {
  psa: "#8b5cf6",
  rmm: "#22c55e",
  crm: "#06b6d4",
  books: "#f59e0b",
  security: "#ef4444",
  voice: "#3b82f6",
  backups: "#10b981",
  hub: "#f97316",
  theo: "#6366f1"
};
function mi(t) {
  if (!t) return null;
  const n = new Date(t), o = /* @__PURE__ */ new Date(), r = n < o, i = /* @__PURE__ */ new Date();
  i.setHours(0, 0, 0, 0);
  const a = new Date(i);
  a.setDate(a.getDate() + 1);
  const d = new Date(n);
  return d.setHours(0, 0, 0, 0), d.getTime() === i.getTime() ? { label: "Today", overdue: n < o } : d.getTime() === a.getTime() ? { label: "Tomorrow", overdue: !1 } : r ? { label: `${Math.floor((o.getTime() - n.getTime()) / 864e5)}d ago`, overdue: !0 } : {
    label: n.toLocaleDateString(void 0, { month: "short", day: "numeric" }),
    overdue: !1
  };
}
function gi(t) {
  var o;
  const n = {};
  for (const r of t) {
    const i = ((o = r.source) == null ? void 0 : o.product) || "personal";
    n[i] || (n[i] = []), n[i].push(r);
  }
  return n;
}
function xi(t) {
  const n = { urgent: [], high: [], normal: [], low: [] };
  for (const o of t)
    n[o.priority].push(o);
  return n;
}
function kn({ task: t, onComplete: n, hubUrl: o, currentUserId: r }) {
  const i = mi(t.due_at), a = t.source ? Do[t.source.product] || "#64748b" : void 0, d = t.status === "done" || t.status === "dismissed", c = !!t.assigned_to_user_id && t.assigned_to_user_id !== r && !!t.assigned_to_user_name;
  return /* @__PURE__ */ s("div", { className: "hb-task-row", role: "listitem", children: [
    /* @__PURE__ */ e(
      "button",
      {
        className: `hb-task-check${d ? " done" : ""}`,
        onClick: () => !d && n(t.id),
        "aria-label": d ? "Completed" : "Mark as done",
        title: d ? "Completed" : "Mark as done",
        children: d ? /* @__PURE__ */ e(So, { size: 15, color: "#22c55e" }) : /* @__PURE__ */ e(ir, { size: 15, color: "#475569" })
      }
    ),
    /* @__PURE__ */ s("div", { className: "hb-task-body", children: [
      t.source ? /* @__PURE__ */ s(
        "a",
        {
          href: t.source.deep_link,
          target: "_blank",
          rel: "noopener noreferrer",
          className: `hb-task-title${d ? " done" : ""}`,
          children: [
            t.title,
            /* @__PURE__ */ e(ar, { size: 11, className: "hb-task-external" })
          ]
        }
      ) : /* @__PURE__ */ e(
        "a",
        {
          href: `${o}/tasks`,
          className: `hb-task-title${d ? " done" : ""}`,
          children: t.title
        }
      ),
      /* @__PURE__ */ s("div", { className: "hb-task-meta", children: [
        t.source && /* @__PURE__ */ e(
          "span",
          {
            className: "hb-task-product-badge",
            style: { background: a ? `${a}22` : void 0, color: a },
            children: t.source.product.toUpperCase()
          }
        ),
        /* @__PURE__ */ e(
          "span",
          {
            className: "hb-task-priority-dot",
            style: { background: Cn[t.priority] },
            title: `${t.priority} priority`
          }
        ),
        i && /* @__PURE__ */ e("span", { className: `hb-task-due${i.overdue ? " overdue" : ""}`, children: i.label }),
        c && /* @__PURE__ */ e(
          "span",
          {
            style: {
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              fontSize: 10,
              color: "#a78bfa"
            },
            title: `Assigned to ${t.assigned_to_user_name}`,
            children: /* @__PURE__ */ e(
              "span",
              {
                style: {
                  width: 14,
                  height: 14,
                  borderRadius: "50%",
                  background: "#8b5cf633",
                  color: "#a78bfa",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 8,
                  fontWeight: 600
                },
                children: bi(t.assigned_to_user_name)
              }
            )
          }
        ),
        typeof t.comment_count == "number" && t.comment_count > 0 && /* @__PURE__ */ s(
          "span",
          {
            style: {
              display: "inline-flex",
              alignItems: "center",
              gap: 2,
              fontSize: 10,
              color: "#94a3b8"
            },
            title: `${t.comment_count} comment${t.comment_count === 1 ? "" : "s"}`,
            children: [
              /* @__PURE__ */ e(Et, { size: 10, color: "#94a3b8" }),
              t.comment_count
            ]
          }
        )
      ] })
    ] })
  ] });
}
function yi({ onAdd: t, areas: n }) {
  const [o, r] = x(""), [i, a] = x(""), d = q(null), c = () => {
    var y;
    const u = o.trim();
    u && (t(u, i || void 0), r(""), a(""), (y = d.current) == null || y.focus());
  };
  return /* @__PURE__ */ s("div", { className: "hb-task-quickadd", children: [
    /* @__PURE__ */ s("div", { className: "hb-task-quickadd-row", children: [
      /* @__PURE__ */ e(Qo, { size: 14, color: "#64748b" }),
      /* @__PURE__ */ e(
        "input",
        {
          ref: d,
          className: "hb-task-quickadd-input",
          placeholder: "Add a task…",
          value: o,
          onChange: (u) => r(u.target.value),
          onKeyDown: (u) => {
            u.key === "Enter" && c();
          },
          maxLength: 255,
          "aria-label": "New task title"
        }
      ),
      o.trim() && /* @__PURE__ */ e("button", { className: "hb-task-quickadd-btn", onClick: c, "aria-label": "Add task", children: "Add" })
    ] }),
    n.length > 0 && o.trim() && /* @__PURE__ */ s(
      "select",
      {
        className: "hb-task-quickadd-area",
        value: i,
        onChange: (u) => a(u.target.value),
        "aria-label": "Task area",
        children: [
          /* @__PURE__ */ e("option", { value: "", children: "No area" }),
          n.map((u) => /* @__PURE__ */ e("option", { value: u.id, children: u.name }, u.id))
        ]
      }
    )
  ] });
}
function vi({ onClose: t, apiBase: n, tenantId: o, userId: r, hubUrl: i }) {
  const { tasks: a, areas: d, count: c, loading: p, currentView: u, changeView: y, completeTask: m, createTask: S } = ui({
    apiBase: n,
    tenantId: o,
    userId: r
  }), [b, w] = x(""), f = q(null);
  V(() => {
    const g = (z) => {
      z.key === "Escape" && t();
    };
    return document.addEventListener("keydown", g), () => document.removeEventListener("keydown", g);
  }, [t]), V(() => {
    const g = (z) => {
      f.current && !f.current.contains(z.target) && t();
    };
    return setTimeout(() => document.addEventListener("mousedown", g), 0), () => document.removeEventListener("mousedown", g);
  }, [t]);
  const C = P(async (g, z) => {
    await S({ title: g, area_id: z, priority: "normal" });
  }, [S]), I = b ? a.filter((g) => g.area_id === b) : a;
  let _;
  if (p)
    _ = /* @__PURE__ */ e("div", { className: "hb-task-empty", children: "Loading…" });
  else if (I.length === 0) {
    const g = {
      "my-day": "Nothing due today — you're on top of it.",
      "my-week": "Clear week ahead.",
      done: "No completed tasks in the last 30 days.",
      default: "No tasks here."
    };
    _ = /* @__PURE__ */ e("div", { className: "hb-task-empty", children: g[u] || g.default });
  } else if (u === "priority") {
    const g = xi(I);
    _ = /* @__PURE__ */ e("div", { role: "list", children: ["urgent", "high", "normal", "low"].map((z) => g[z].length > 0 && /* @__PURE__ */ s("div", { className: "hb-task-group", children: [
      /* @__PURE__ */ s("div", { className: "hb-task-group-label", style: { color: Cn[z] }, children: [
        /* @__PURE__ */ e("span", { className: "hb-task-priority-dot", style: { background: Cn[z] } }),
        z.charAt(0).toUpperCase() + z.slice(1),
        " (",
        g[z].length,
        ")"
      ] }),
      g[z].map((L) => /* @__PURE__ */ e(kn, { task: L, onComplete: m, hubUrl: i, currentUserId: r }, L.id))
    ] }, z)) });
  } else if (u === "product") {
    const g = gi(I);
    _ = /* @__PURE__ */ e("div", { role: "list", children: Object.entries(g).map(([z, L]) => /* @__PURE__ */ s("div", { className: "hb-task-group", children: [
      /* @__PURE__ */ s(
        "div",
        {
          className: "hb-task-group-label",
          style: { color: Do[z] || "#94a3b8" },
          children: [
            z === "personal" ? "Personal" : z.toUpperCase(),
            " (",
            L.length,
            ")"
          ]
        }
      ),
      L.map((T) => /* @__PURE__ */ e(kn, { task: T, onComplete: m, hubUrl: i, currentUserId: r }, T.id))
    ] }, z)) });
  } else
    _ = /* @__PURE__ */ e("div", { role: "list", children: I.map((g) => /* @__PURE__ */ e(kn, { task: g, onComplete: m, hubUrl: i, currentUserId: r }, g.id)) });
  const A = c.overdue + c.due_today;
  return Ut(
    /* @__PURE__ */ s(he, { children: [
      /* @__PURE__ */ e("div", { className: "hb-sp-overlay", onClick: t, "aria-hidden": "true" }),
      /* @__PURE__ */ s(
        "div",
        {
          className: "hb-sp-panel hb-tasks-panel open",
          ref: f,
          role: "dialog",
          "aria-label": "My Tasks",
          children: [
            /* @__PURE__ */ s("div", { className: "hb-sp-header", children: [
              /* @__PURE__ */ s("div", { className: "hb-sp-header-title", children: [
                "My Tasks",
                A > 0 && /* @__PURE__ */ e("span", { className: "hb-task-header-badge", children: A > 99 ? "99+" : A })
              ] }),
              /* @__PURE__ */ s("div", { style: { display: "flex", alignItems: "center", gap: 8 }, children: [
                /* @__PURE__ */ e(
                  "a",
                  {
                    href: `${i}/tasks`,
                    className: "hb-task-full-link",
                    title: "Open full task view",
                    children: "Full view →"
                  }
                ),
                /* @__PURE__ */ e("button", { className: "hb-sp-close", onClick: t, "aria-label": "Close tasks panel", children: /* @__PURE__ */ e(Ke, { size: 16 }) })
              ] })
            ] }),
            /* @__PURE__ */ e(yi, { onAdd: C, areas: d }),
            /* @__PURE__ */ s("div", { className: "hb-tasks-body", children: [
              /* @__PURE__ */ s("div", { className: "hb-tasks-sidebar", children: [
                /* @__PURE__ */ e("div", { className: "hb-tasks-sidebar-section", children: fi.map((g) => /* @__PURE__ */ s(
                  "button",
                  {
                    className: `hb-tasks-view-btn${u === g.id ? " active" : ""}`,
                    onClick: () => {
                      y(g.id), w("");
                    },
                    children: [
                      g.label,
                      g.id === "my-day" && A > 0 && /* @__PURE__ */ e("span", { className: "hb-task-view-count", children: A })
                    ]
                  },
                  g.id
                )) }),
                d.length > 0 && /* @__PURE__ */ s(he, { children: [
                  /* @__PURE__ */ e("div", { className: "hb-tasks-sidebar-divider" }),
                  /* @__PURE__ */ s("div", { className: "hb-tasks-sidebar-section", children: [
                    /* @__PURE__ */ e("div", { className: "hb-tasks-sidebar-label", children: "Areas" }),
                    d.map((g) => /* @__PURE__ */ s(
                      "button",
                      {
                        className: `hb-tasks-view-btn${b === g.id ? " active" : ""}`,
                        onClick: () => w(b === g.id ? "" : g.id),
                        children: [
                          g.color && /* @__PURE__ */ e(
                            "span",
                            {
                              className: "hb-tasks-area-dot",
                              style: { background: g.color }
                            }
                          ),
                          g.name
                        ]
                      },
                      g.id
                    ))
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ e("div", { className: "hb-tasks-list", children: _ })
            ] })
          ]
        }
      )
    ] }),
    document.body
  );
}
function ki({
  apiBase: t,
  tenantId: n,
  userId: o,
  hubUrl: r,
  open: i,
  onToggle: a,
  onClose: d
}) {
  const [c, p] = x(0), u = q(null), y = P(async () => {
    if (!(!n || !o))
      try {
        const m = await fetch(`${t}/api/hub/tasks/count`, { credentials: "include" });
        if (!m.ok) return;
        const S = await m.json();
        p((S.overdue || 0) + (S.due_today || 0));
      } catch {
      }
  }, [t, n, o]);
  return V(() => (y(), u.current = setInterval(y, 6e4), () => {
    u.current && clearInterval(u.current);
  }), [y]), /* @__PURE__ */ s(he, { children: [
    /* @__PURE__ */ s(
      "button",
      {
        className: `hb-tasks-btn${i ? " active" : ""}`,
        onClick: a,
        "aria-label": `Tasks${c > 0 ? ` (${c})` : ""}`,
        title: "My Tasks",
        children: [
          /* @__PURE__ */ e(So, { size: 18 }),
          c > 0 && /* @__PURE__ */ e("span", { className: "hb-tasks-badge", children: c > 99 ? "99+" : c })
        ]
      }
    ),
    i && /* @__PURE__ */ e(
      vi,
      {
        onClose: d,
        apiBase: t,
        tenantId: n,
        userId: o,
        hubUrl: r
      }
    )
  ] });
}
const fo = {
  psa: [
    "Summarize my open P1 and P2 tickets",
    "Write a professional response for this ticket: [paste ticket here]",
    "What's the best way to handle a client who keeps reopening closed tickets?"
  ],
  rmm: [
    "Show me devices with CPU over 80% in the last hour",
    "A server is showing high disk I/O — walk me through diagnosing it",
    "Write a PowerShell script to report all devices with less than 10GB free disk"
  ],
  security: [
    "What security alerts need my attention right now?",
    "Walk me through investigating a potential ransomware indicator",
    "What does MITRE ATT&CK technique T1078 mean and how do I detect it?"
  ],
  cmdb: [
    "Help me write a documentation standard for client network diagrams",
    "What fields should I capture for every server in my CMDB?"
  ],
  voice: [
    "Help me write an IVR greeting script for a medical office client",
    "What's the best on-call schedule structure for a 5-person MSP?"
  ],
  default: [
    "What tools should a new MSP consider for their core stack?",
    "Help me write a professional client communication about a service outage",
    "What should I include in a quarterly business review for a healthcare client?",
    "Write a PowerShell script to audit local admin accounts on Windows workstations",
    "How do I explain the value of MFA to a resistant client?"
  ]
};
function wi(t) {
  const n = [];
  for (const o of t) {
    const r = fo[o];
    r && n.push(r[0]);
  }
  for (const o of fo.default) {
    if (n.length >= 5) break;
    n.includes(o) || n.push(o);
  }
  return n.slice(0, 5);
}
function Si({ activeProducts: t, onComplete: n }) {
  const [o, r] = x(0), i = wi(t);
  return /* @__PURE__ */ s("div", { className: "theo-onboarding", children: [
    /* @__PURE__ */ e("div", { className: "onboarding-step-dots", children: [0, 1, 2].map((a) => /* @__PURE__ */ e("div", { className: `step-dot${o === a ? " active" : ""}` }, a)) }),
    /* @__PURE__ */ s("div", { className: "theo-onboarding-step", children: [
      o === 0 && /* @__PURE__ */ s(he, { children: [
        /* @__PURE__ */ e("div", { style: { fontSize: 32, marginBottom: 12 }, children: "🤖" }),
        /* @__PURE__ */ e("h2", { style: { color: "#f1f5f9", fontSize: 22, fontWeight: 700, margin: "0 0 12px" }, children: "Meet THEO" }),
        /* @__PURE__ */ e("p", { style: { color: "#94a3b8", fontSize: 14, lineHeight: 1.7, margin: "0 0 28px" }, children: "THEO is your MSP AI — trained on helpdesk workflows, security incidents, and MSP business operations. Ask about tickets, scripts, client emails, or anything your team runs into." }),
        /* @__PURE__ */ e(
          "button",
          {
            onClick: () => r(1),
            style: {
              padding: "10px 24px",
              borderRadius: 8,
              background: "#6366f1",
              border: "none",
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "inherit"
            },
            children: "Next →"
          }
        )
      ] }),
      o === 1 && /* @__PURE__ */ s(he, { children: [
        /* @__PURE__ */ e("h2", { style: { color: "#f1f5f9", fontSize: 22, fontWeight: 700, margin: "0 0 8px" }, children: "Try asking THEO..." }),
        /* @__PURE__ */ e("p", { style: { color: "#64748b", fontSize: 12, margin: "0 0 4px" }, children: "Click a prompt to jump straight in" }),
        /* @__PURE__ */ e("div", { className: "onboarding-prompts", children: i.map((a) => /* @__PURE__ */ e(
          "button",
          {
            className: "prompt-chip",
            onClick: () => n(a),
            children: a
          },
          a
        )) }),
        /* @__PURE__ */ e(
          "button",
          {
            onClick: () => r(2),
            style: {
              padding: "10px 24px",
              borderRadius: 8,
              background: "#6366f1",
              border: "none",
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "inherit",
              marginTop: 8
            },
            children: "Next →"
          }
        )
      ] }),
      o === 2 && /* @__PURE__ */ s(he, { children: [
        /* @__PURE__ */ e("div", { style: { fontSize: 32, marginBottom: 12 }, children: "📈" }),
        /* @__PURE__ */ e("h2", { style: { color: "#f1f5f9", fontSize: 22, fontWeight: 700, margin: "0 0 12px" }, children: "THEO gets better over time" }),
        /* @__PURE__ */ e("p", { style: { color: "#94a3b8", fontSize: 14, lineHeight: 1.7, margin: "0 0 10px" }, children: "When you rate THEO's responses with 👍 or 👎, you're helping train the next version. Your feedback directly improves THEO — not just for you, but for every MSP using The One Stack." }),
        /* @__PURE__ */ e("p", { style: { color: "#475569", fontSize: 12, lineHeight: 1.6, margin: "0 0 28px" }, children: "Your conversation data is anonymized before being used for training. You can opt out in account settings." }),
        /* @__PURE__ */ e(
          "button",
          {
            onClick: () => n(),
            style: {
              padding: "10px 24px",
              borderRadius: 8,
              background: "#6366f1",
              border: "none",
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "inherit"
            },
            children: "Start chatting →"
          }
        )
      ] })
    ] })
  ] });
}
const Ti = {
  msp_owner: "MSP Owner",
  technician: "Technician",
  sales: "Sales",
  marketing: "Marketing",
  finance: "Finance",
  customer: "Customer / End User",
  nonprofit: "Nonprofit / Association Staff",
  healthcare: "Healthcare / Medical Staff",
  business: "General Business / Operations"
}, _i = {
  msp_owner: "🏢",
  technician: "🔧",
  sales: "📈",
  marketing: "📣",
  finance: "💼",
  customer: "👤",
  nonprofit: "🤝",
  healthcare: "⚕️",
  business: "🏛️"
}, Mi = {
  msp_owner: "Business strategy, growth, client relationships",
  technician: "Step-by-step fixes, commands, troubleshooting",
  sales: "Proposals, objections, client conversations",
  marketing: "Content, positioning, campaigns",
  finance: "Billing, invoicing, reporting",
  customer: "Plain English help with IT questions",
  nonprofit: "Members, events, dues, and programs",
  healthcare: "Scheduling, billing, compliance, admin",
  business: "Operations, HR, finance, and workflows"
}, Ci = {
  msp_owner: "Let's talk business. What's on your mind?",
  technician: "Ready to troubleshoot. What are you working on?",
  sales: "Let's win some deals. What do you need?",
  marketing: "Let's build something. What are you working on?",
  finance: "Numbers time. What do you need?",
  customer: "Hi! What can I help you with today?",
  nonprofit: "Let's make an impact. What are you working on?",
  healthcare: "Ready to help with your workflow. What do you need?",
  business: "Let's get things running smoothly. What's up?"
}, Wt = "theo_persona_v1", Ni = /* @__PURE__ */ new Set(["msp_owner", "technician", "sales", "marketing", "finance", "customer", "nonprofit", "healthcare", "business"]);
function Lo() {
  try {
    const t = localStorage.getItem(Wt);
    return t && Ni.has(t) ? t : null;
  } catch {
    return null;
  }
}
function bo() {
  try {
    return localStorage.getItem(Wt) !== null;
  } catch {
    return !1;
  }
}
function Ai(t) {
  try {
    localStorage.setItem(Wt, t);
  } catch {
  }
}
function zi() {
  try {
    localStorage.setItem(Wt, "skipped");
  } catch {
  }
}
function Ei() {
  const [t, n] = x(() => Lo()), o = P((i, a) => {
    Ai(i), n(i), fetch(`${a}/api/v1/theo/memory`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        scope: "user",
        memory_type: "preference",
        label: "user_persona",
        content: i
      })
    }).catch(() => {
    });
  }, []), r = P(() => {
    zi(), n(null);
  }, []);
  return { persona: t, setPersona: o, skipPersona: r };
}
const Ri = [
  "msp_owner",
  "technician",
  "sales",
  "marketing",
  "finance",
  "customer",
  "nonprofit",
  "healthcare",
  "business"
];
function Oi({ onSelect: t, onSkip: n }) {
  const [o, r] = x(null);
  function i(a) {
    r(a), setTimeout(() => t(a), 320);
  }
  return /* @__PURE__ */ e(
    "div",
    {
      style: {
        position: "absolute",
        inset: 0,
        zIndex: 20,
        background: "#1e293b",
        borderRadius: 12,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 24px",
        overflowY: "auto"
      },
      children: /* @__PURE__ */ s("div", { style: { maxWidth: 560, width: "100%" }, children: [
        /* @__PURE__ */ s("div", { style: { textAlign: "center", marginBottom: 28 }, children: [
          /* @__PURE__ */ e("div", { style: { fontSize: 28, marginBottom: 10 }, children: "🤖" }),
          /* @__PURE__ */ e("h2", { style: {
            color: "#f1f5f9",
            fontSize: 20,
            fontWeight: 700,
            margin: "0 0 8px",
            lineHeight: 1.3
          }, children: "Before we begin — who are you?" }),
          /* @__PURE__ */ e("p", { style: { color: "#64748b", fontSize: 13, margin: 0 }, children: "THEO will speak your language." })
        ] }),
        /* @__PURE__ */ e(
          "div",
          {
            style: {
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 10,
              marginBottom: 20
            },
            children: Ri.map((a) => {
              const d = o === a;
              return /* @__PURE__ */ s(
                "button",
                {
                  onClick: () => !o && i(a),
                  disabled: !!o,
                  style: {
                    padding: "14px 10px",
                    borderRadius: 10,
                    border: d ? "2px solid #6366f1" : "1px solid #334155",
                    background: d ? "rgba(99,102,241,0.18)" : "rgba(255,255,255,0.03)",
                    cursor: o ? "default" : "pointer",
                    textAlign: "center",
                    transition: "background 0.15s, border-color 0.15s, transform 0.15s",
                    transform: d ? "scale(1.04)" : "scale(1)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 6,
                    fontFamily: "inherit"
                  },
                  onMouseEnter: (c) => {
                    o || (c.currentTarget.style.background = "rgba(255,255,255,0.06)", c.currentTarget.style.borderColor = "#475569");
                  },
                  onMouseLeave: (c) => {
                    !o && !d && (c.currentTarget.style.background = "rgba(255,255,255,0.03)", c.currentTarget.style.borderColor = "#334155");
                  },
                  children: [
                    /* @__PURE__ */ e("span", { style: { fontSize: 22 }, children: _i[a] }),
                    /* @__PURE__ */ e("span", { style: { color: "#f1f5f9", fontSize: 12, fontWeight: 600, lineHeight: 1.3 }, children: Ti[a] }),
                    /* @__PURE__ */ e("span", { style: { color: "#64748b", fontSize: 11, lineHeight: 1.4 }, children: Mi[a] })
                  ]
                },
                a
              );
            })
          }
        ),
        !o && /* @__PURE__ */ e("div", { style: { textAlign: "center" }, children: /* @__PURE__ */ e(
          "button",
          {
            onClick: n,
            style: {
              background: "none",
              border: "none",
              padding: 0,
              color: "#475569",
              fontSize: 12,
              cursor: "pointer",
              fontFamily: "inherit",
              textDecoration: "underline"
            },
            children: "Skip for now"
          }
        ) })
      ] })
    }
  );
}
const jo = "theo_onboarded_v1";
function Ii() {
  try {
    return localStorage.getItem(jo) === "true";
  } catch {
    return !1;
  }
}
function Di() {
  try {
    localStorage.setItem(jo, "true");
  } catch {
  }
}
const Po = "hb_theo_recent", Li = 5, mo = "hb_theo_seen", ji = {
  psa: "PSA",
  rmm: "RMM",
  crm: "CRM",
  books: "Books",
  voice: "Voice",
  security: "Security",
  backups: "Backups",
  cmdb: "CMDB",
  projects: "Projects",
  oncall: "OnCall",
  fleet: "Fleet",
  people: "People",
  legal: "Legal",
  collective: "Collective",
  hub: "Hub",
  "ops-center": "Ops Center",
  portal: "Hub",
  aiplatform: "AI Studio"
}, go = {
  psa: [
    { label: "Create ticket", icon: "🎫", hint: "New support ticket" },
    { label: "My queue", icon: "📋", hint: "Tickets assigned to me" },
    { label: "Time sheet", icon: "🕐", hint: "Log time entries" }
  ],
  rmm: [
    { label: "Device health", icon: "💻", hint: "View all devices" },
    { label: "Run script", icon: "⚡", hint: "Execute on devices" },
    { label: "View alerts", icon: "🚨", hint: "Active alerts" }
  ],
  crm: [
    { label: "New contact", icon: "👤", hint: "Add a contact" },
    { label: "Pipeline", icon: "📊", hint: "Sales pipeline" },
    { label: "Activities", icon: "📅", hint: "Recent activities" }
  ],
  books: [
    { label: "New invoice", icon: "📄", hint: "Create invoice" },
    { label: "Outstanding", icon: "💰", hint: "Unpaid invoices" },
    { label: "Reports", icon: "📈", hint: "Financial reports" }
  ],
  hub: [
    { label: "Billing", icon: "💳", hint: "Manage subscription" },
    { label: "Invite user", icon: "👋", hint: "Add team member" },
    { label: "Add product", icon: "➕", hint: "Activate a product" }
  ]
};
function Nn() {
  try {
    return JSON.parse(localStorage.getItem(Po) ?? "[]");
  } catch {
    return [];
  }
}
function Pi(t) {
  const n = Nn().filter((o) => o !== t);
  n.unshift(t);
  try {
    localStorage.setItem(Po, JSON.stringify(n.slice(0, Li)));
  } catch {
  }
}
function Hi(t) {
  const n = Date.now() - new Date(t).getTime(), o = Math.floor(n / 6e4);
  if (o < 1) return "just now";
  if (o < 60) return `${o}m ago`;
  const r = Math.floor(o / 60);
  if (r < 24) return `${r}h ago`;
  const i = Math.floor(r / 24);
  return i < 7 ? `${i}d ago` : new Date(t).toLocaleDateString(void 0, { month: "short", day: "numeric" });
}
function xo({
  customGpts: t,
  selectedId: n,
  upgradeRequired: o,
  open: r,
  onToggle: i,
  onSelect: a
}) {
  const d = t.find((c) => c.id === n) ?? null;
  return /* @__PURE__ */ s("div", { style: { position: "relative", display: "inline-block" }, children: [
    /* @__PURE__ */ s(
      "button",
      {
        onClick: i,
        title: d ? `Custom GPT: ${d.name}` : "Select Custom GPT",
        style: {
          display: "flex",
          alignItems: "center",
          gap: 4,
          background: d ? "rgba(139,92,246,0.2)" : "none",
          border: d ? "1px solid rgba(139,92,246,0.4)" : "1px solid #334155",
          borderRadius: 6,
          padding: "3px 8px",
          color: d ? "#c4b5fd" : "#64748b",
          fontSize: 11,
          cursor: "pointer",
          fontFamily: "inherit"
        },
        onMouseEnter: (c) => {
          d || (c.currentTarget.style.color = "#94a3b8");
        },
        onMouseLeave: (c) => {
          d || (c.currentTarget.style.color = "#64748b");
        },
        children: [
          /* @__PURE__ */ e("span", { style: { fontSize: 12 }, children: d ? d.icon : "✦" }),
          /* @__PURE__ */ e("span", { style: { maxWidth: 100, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, children: d ? d.name : "THEO" }),
          /* @__PURE__ */ e("span", { style: { fontSize: 9, marginLeft: 1 }, children: "▾" })
        ]
      }
    ),
    r && /* @__PURE__ */ e(
      "div",
      {
        style: {
          position: "absolute",
          bottom: "100%",
          left: 0,
          marginBottom: 4,
          background: "#1e293b",
          border: "1px solid #334155",
          borderRadius: 8,
          boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
          minWidth: 240,
          zIndex: 100,
          overflow: "hidden"
        },
        children: o ? /* @__PURE__ */ s("div", { style: { padding: "14px 16px", textAlign: "center" }, children: [
          /* @__PURE__ */ e("div", { style: { fontSize: 18, marginBottom: 6 }, children: "🔒" }),
          /* @__PURE__ */ e("div", { style: { color: "#e2e8f0", fontSize: 13, fontWeight: 600, marginBottom: 4 }, children: "Custom GPTs" }),
          /* @__PURE__ */ e("div", { style: { color: "#64748b", fontSize: 11, lineHeight: 1.5, marginBottom: 10 }, children: "Create custom THEO personas for your org. Available on THEO Business plan." }),
          /* @__PURE__ */ e(
            "a",
            {
              href: "https://theo.theonestack.com/upgrade",
              target: "_blank",
              rel: "noreferrer",
              style: {
                display: "block",
                padding: "6px 14px",
                background: "rgba(139,92,246,0.25)",
                border: "1px solid rgba(139,92,246,0.4)",
                borderRadius: 6,
                color: "#c4b5fd",
                fontSize: 11,
                fontWeight: 600,
                textDecoration: "none",
                textAlign: "center"
              },
              children: "Upgrade to Business"
            }
          )
        ] }) : /* @__PURE__ */ s(he, { children: [
          /* @__PURE__ */ s(
            "button",
            {
              onClick: () => a(null),
              style: {
                display: "flex",
                alignItems: "center",
                gap: 10,
                width: "100%",
                padding: "9px 14px",
                background: n === null ? "rgba(139,92,246,0.15)" : "transparent",
                border: "none",
                cursor: "pointer",
                textAlign: "left",
                borderBottom: t.length > 0 ? "1px solid #1e293b" : "none"
              },
              children: [
                /* @__PURE__ */ e("span", { style: { fontSize: 15 }, children: "✦" }),
                /* @__PURE__ */ s("div", { style: { flex: 1 }, children: [
                  /* @__PURE__ */ e("div", { style: { color: "#e2e8f0", fontSize: 12, fontWeight: 500 }, children: "THEO" }),
                  /* @__PURE__ */ e("div", { style: { color: "#475569", fontSize: 10 }, children: "Standard persona" })
                ] }),
                n === null && /* @__PURE__ */ e("span", { style: { color: "#8b5cf6", fontSize: 12 }, children: "✓" })
              ]
            }
          ),
          t.length > 0 && /* @__PURE__ */ e("div", { style: { maxHeight: 200, overflowY: "auto" }, children: t.map((c) => /* @__PURE__ */ s(
            "button",
            {
              onClick: () => a(c.id),
              style: {
                display: "flex",
                alignItems: "center",
                gap: 10,
                width: "100%",
                padding: "9px 14px",
                background: n === c.id ? "rgba(139,92,246,0.15)" : "transparent",
                border: "none",
                cursor: "pointer",
                textAlign: "left",
                borderBottom: "1px solid #1e293b"
              },
              children: [
                /* @__PURE__ */ e("span", { style: { fontSize: 15, lineHeight: 1, flexShrink: 0 }, children: c.icon }),
                /* @__PURE__ */ s("div", { style: { flex: 1, minWidth: 0 }, children: [
                  /* @__PURE__ */ e("div", { style: { color: "#e2e8f0", fontSize: 12, fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, children: c.name }),
                  c.description && /* @__PURE__ */ e("div", { style: { color: "#475569", fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, children: c.description })
                ] }),
                n === c.id && /* @__PURE__ */ e("span", { style: { color: "#8b5cf6", fontSize: 12, flexShrink: 0 }, children: "✓" })
              ]
            },
            c.id
          )) }),
          t.length === 0 && /* @__PURE__ */ s("div", { style: { padding: "10px 14px", color: "#475569", fontSize: 11, textAlign: "center" }, children: [
            "No Custom GPTs yet.",
            " ",
            /* @__PURE__ */ e(
              "a",
              {
                href: "https://theo.theonestack.com/settings/custom-gpts",
                target: "_blank",
                rel: "noreferrer",
                style: { color: "#8b5cf6", textDecoration: "none" },
                children: "Create one →"
              }
            )
          ] })
        ] })
      }
    )
  ] });
}
function $i({ open: t, onClose: n, apiBase: o, currentProduct: r, tenantId: i, activeProducts: a = [] }) {
  var se;
  const [d, c] = x(""), [p, u] = x([]), [y, m] = x(!1), [S, b] = x([]), [w, f] = x(-1), [C, I] = x(!1), [_, A] = x(null), [g, z] = x(null), [L, T] = x(!1), [H, j] = x(!1), [B, U] = x(!1), { setPersona: W, skipPersona: J } = Ei(), [R, K] = x(/* @__PURE__ */ new Map()), [re, $] = x(!1), [ne, ee] = x(null), [oe, X] = x(/* @__PURE__ */ new Set()), De = q(null), [ie, dt] = x([]), [te, N] = x(null), [E, G] = x(null), [Re, Te] = x(!1), [fe, xt] = x(!1), [Ae, ot] = x(""), [ze, qe] = x(null), [pt, Be] = x([]), [rt, Oe] = x(!1), [yt, Rt] = x(!1), [Ft, Fe] = x(!1), [be, Je] = x(!1), me = q(null), Xe = q(null), it = q(null), vt = q(null), Ve = q(null), Qe = q(null);
  V(() => {
    Qe.current = te;
  }, [te]), V(() => {
    function h() {
      Je(window.innerWidth < 768);
    }
    return h(), window.addEventListener("resize", h), () => window.removeEventListener("resize", h);
  }, []);
  const Ze = P(() => {
    fetch(`${o}/api/v1/theo/consent/usage`, { credentials: "include" }).then((h) => h.ok ? h.json() : null).then((h) => {
      h && A(h);
    }).catch(() => {
    });
  }, [o]), Le = P(async (h) => {
    Te(!0);
    try {
      const Y = h ? null : E, F = Ae.trim(), le = new URLSearchParams();
      Y && le.set("token", Y), F && le.set("search", F);
      const je = le.toString() ? `?${le}` : "", Ce = await fetch(`${o}/api/v1/theo/conversations${je}`, { credentials: "include" });
      if (!Ce.ok) return;
      const ge = await Ce.json();
      dt((ue) => h ? ge.conversations : [...ue, ...ge.conversations]), G(ge.next_token);
    } catch {
    } finally {
      Te(!1);
    }
  }, [o, E, Ae]), Ie = P(async (h) => {
    xt(!0);
    try {
      const Y = await fetch(`${o}/api/v1/theo/conversations/${h}`, { credentials: "include" });
      if (!Y.ok) return;
      const F = await Y.json();
      u(F.messages.map((le) => ({ role: le.role, content: le.content }))), K(/* @__PURE__ */ new Map()), N(h), be && Fe(!1);
    } catch {
    } finally {
      xt(!1);
    }
  }, [o, be]), et = P(() => {
    fetch(`${o}/api/v1/theo/custom-gpts`, { credentials: "include" }).then((h) => h.ok ? h.json() : null).then((h) => {
      h && (Be(h.custom_gpts ?? []), Rt(h.upgrade_required ?? !1));
    }).catch(() => {
    });
  }, [o]);
  V(() => {
    var h;
    if (t) {
      c(""), u([]), m(!1), f(-1), N(null), Fe(!1), ot(""), b(Nn()), z(null), T(!1), qe(null), Oe(!1), et(), Ii() ? bo() ? setTimeout(() => {
        var F;
        return (F = me.current) == null ? void 0 : F.focus();
      }, 50) : U(!0) : j(!0);
      const Y = `${mo}_${r}`;
      localStorage.getItem(Y) || I(!0), Ze(), Le(!0);
    } else
      (h = Xe.current) == null || h.abort(), I(!1), j(!1), U(!1);
  }, [t]), V(() => {
    it.current && (it.current.scrollTop = it.current.scrollHeight);
  }, [p, y]), V(() => {
    if (t)
      return Ve.current && clearTimeout(Ve.current), Ve.current = setTimeout(() => {
        Le(!0);
      }, 300), () => {
        Ve.current && clearTimeout(Ve.current);
      };
  }, [Ae]);
  function kt() {
    const h = vt.current;
    !h || !E || Re || h.scrollTop + h.clientHeight >= h.scrollHeight - 60 && Le(!1);
  }
  const tt = go[r] ?? go.hub, ht = P(async (h) => {
    var je, Ce;
    if (!h.trim()) return;
    (je = Xe.current) == null || je.abort();
    const Y = new AbortController();
    Xe.current = Y;
    const F = `${mo}_${r}`;
    if (!localStorage.getItem(F))
      try {
        localStorage.setItem(F, "1");
      } catch {
      }
    I(!1);
    const le = { role: "user", content: h.trim() };
    u((ge) => [...ge, le]), c(""), m(!0), Pi(h.trim()), b(Nn());
    try {
      const ge = await fetch(`${o}/api/v1/theo/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          message: h.trim(),
          conversation_id: Qe.current ?? void 0,
          context: { product: r, org_id: i },
          persona: Lo() ?? void 0,
          ...ze ? { customGptId: ze } : {}
        }),
        signal: Y.signal
      });
      if (!ge.ok || !ge.body) {
        u((de) => [...de, { role: "assistant", content: "THEO is unavailable right now. Try again in a moment." }]);
        return;
      }
      const ue = ge.body.getReader(), Z = new TextDecoder();
      let ce = "", Pe = "", st = null, ut = [];
      for (u((de) => [...de, { role: "assistant", content: "" }]); ; ) {
        const { done: de, value: He } = await ue.read();
        if (de) break;
        ce += Z.decode(He, { stream: !0 });
        const $e = ce.split(`
`);
        ce = $e.pop() ?? "";
        for (const wt of $e) {
          if (!wt.startsWith("data: ")) continue;
          const St = wt.slice(6);
          if (St === "[DONE]") break;
          try {
            const Ue = JSON.parse(St);
            Ue.token ? (Pe += Ue.token, u((D) => {
              const l = [...D];
              return l[l.length - 1] = { role: "assistant", content: Pe }, l;
            })) : Ue.done ? (Ue.conversation_id && (st = Ue.conversation_id), (Ce = Ue.knowledgeUsed) != null && Ce.length && (ut = Ue.knowledgeUsed)) : Ue.error && u((D) => {
              const l = [...D];
              return l[l.length - 1] = { role: "assistant", content: "THEO is unavailable right now. Try again in a moment." }, l;
            });
          } catch {
          }
        }
      }
      if (!L && Pe) {
        const de = Pe.match(/💡 Should I remember (.+?)(\?)?$/);
        de && z(de[1].trim());
      }
      ut.length > 0 && u((de) => {
        const He = [...de], $e = He[He.length - 1];
        return ($e == null ? void 0 : $e.role) === "assistant" && (He[He.length - 1] = { ...$e, knowledgeUsed: ut }), He;
      }), st && !Qe.current && (N(st), Le(!0));
    } catch (ge) {
      (ge == null ? void 0 : ge.name) !== "AbortError" && u((ue) => {
        const Z = [...ue], ce = Z[Z.length - 1];
        return (ce == null ? void 0 : ce.role) === "assistant" && ce.content === "" ? Z[Z.length - 1] = { role: "assistant", content: "THEO is unavailable right now. Try again in a moment." } : Z.push({ role: "assistant", content: "THEO is unavailable right now. Try again in a moment." }), Z;
      });
    } finally {
      m(!1), Ze();
    }
  }, [o, r, i, L, Ze, Le]), at = P(async (h, Y, F) => {
    const le = Qe.current;
    if (le) {
      K((je) => {
        const Ce = new Map(je);
        return Ce.set(h, { rating: Y, bad_reason: F, showReasonPicker: !1, submitted: !0 }), Ce;
      }), De.current && clearTimeout(De.current), $(!0), De.current = setTimeout(() => $(!1), 1500);
      try {
        await fetch(`${o}/api/v1/theo/feedback`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ conversation_id: le, message_index: h, rating: Y, bad_reason: F })
        });
      } catch {
      }
    }
  }, [o]);
  function nt() {
    u([]), N(null), c(""), I(!1), z(null), K(/* @__PURE__ */ new Map()), qe(null), Oe(!1), be && Fe(!1), setTimeout(() => {
      var h;
      return (h = me.current) == null ? void 0 : h.focus();
    }, 50);
  }
  function Vt(h) {
    if (h.key === "Escape") {
      n();
      return;
    }
    h.key === "Enter" && !h.shiftKey && (h.preventDefault(), p.length === 0 && w >= 0 && w < tt.length ? ht(tt[w].label) : ht(d)), p.length === 0 && (h.key === "ArrowDown" && (h.preventDefault(), f((Y) => Math.min(Y + 1, tt.length - 1))), h.key === "ArrowUp" && (h.preventDefault(), f((Y) => Math.max(Y - 1, -1))));
  }
  const ye = p.length > 0 || y || fe, Gt = _ !== null && _.limit !== null, Yt = !be || Ft;
  return t ? /* @__PURE__ */ e(
    "div",
    {
      style: {
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        paddingTop: 80
      },
      onMouseDown: (h) => {
        h.target === h.currentTarget && n();
      },
      children: /* @__PURE__ */ s(
        "div",
        {
          style: {
            width: be ? "calc(100vw - 16px)" : 920,
            maxWidth: "calc(100vw - 16px)",
            background: "#1e293b",
            border: "1px solid #334155",
            borderRadius: 12,
            boxShadow: "0 25px 50px rgba(0,0,0,0.5)",
            overflow: "hidden",
            display: "flex",
            flexDirection: "row",
            maxHeight: "calc(100vh - 100px)",
            position: "relative"
          },
          onMouseDown: (h) => h.stopPropagation(),
          children: [
            H && /* @__PURE__ */ e(
              Si,
              {
                activeProducts: a,
                onComplete: (h) => {
                  Di(), j(!1), h && c(h), bo() ? setTimeout(() => {
                    var Y;
                    return (Y = me.current) == null ? void 0 : Y.focus();
                  }, 50) : U(!0);
                }
              }
            ),
            B && /* @__PURE__ */ e(
              Oi,
              {
                onSelect: (h) => {
                  W(h, o), U(!1), u([{ role: "assistant", content: Ci[h] }]), setTimeout(() => {
                    var Y;
                    return (Y = me.current) == null ? void 0 : Y.focus();
                  }, 50);
                },
                onSkip: () => {
                  J(), U(!1), setTimeout(() => {
                    var h;
                    return (h = me.current) == null ? void 0 : h.focus();
                  }, 50);
                }
              }
            ),
            Yt && /* @__PURE__ */ s(
              "div",
              {
                style: {
                  width: be ? "100%" : 260,
                  background: "#16213e",
                  borderRight: be ? "none" : "1px solid #334155",
                  display: "flex",
                  flexDirection: "column",
                  flexShrink: 0,
                  ...be ? {
                    position: "absolute",
                    inset: 0,
                    zIndex: 10,
                    borderRadius: 12
                  } : {}
                },
                children: [
                  /* @__PURE__ */ s("div", { style: { padding: "12px 12px 8px", borderBottom: "1px solid #1e293b", flexShrink: 0 }, children: [
                    /* @__PURE__ */ s("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }, children: [
                      /* @__PURE__ */ e(
                        "button",
                        {
                          onClick: nt,
                          style: {
                            flex: 1,
                            padding: "7px 12px",
                            background: "rgba(139,92,246,0.2)",
                            border: "1px solid rgba(139,92,246,0.4)",
                            borderRadius: 7,
                            color: "#c4b5fd",
                            fontSize: 13,
                            fontWeight: 600,
                            cursor: "pointer",
                            textAlign: "left"
                          },
                          children: "+ New Chat"
                        }
                      ),
                      be && /* @__PURE__ */ e(
                        "button",
                        {
                          onClick: () => Fe(!1),
                          style: { background: "none", border: "none", cursor: "pointer", color: "#64748b", padding: 4 },
                          children: /* @__PURE__ */ e(Ke, { size: 16 })
                        }
                      )
                    ] }),
                    /* @__PURE__ */ s("div", { style: { display: "flex", alignItems: "center", gap: 6, background: "#0f172a", borderRadius: 6, padding: "5px 10px" }, children: [
                      /* @__PURE__ */ e(mt, { size: 12, color: "#475569" }),
                      /* @__PURE__ */ e(
                        "input",
                        {
                          value: Ae,
                          onChange: (h) => ot(h.target.value),
                          placeholder: "Search chats...",
                          style: {
                            flex: 1,
                            background: "transparent",
                            border: "none",
                            outline: "none",
                            color: "#94a3b8",
                            fontSize: 12
                          }
                        }
                      )
                    ] })
                  ] }),
                  /* @__PURE__ */ s(
                    "div",
                    {
                      ref: vt,
                      onScroll: kt,
                      style: { flex: 1, overflowY: "auto", padding: "4px 0" },
                      children: [
                        Re && ie.length === 0 && /* @__PURE__ */ e("div", { style: { padding: "20px 16px", color: "#475569", fontSize: 12, textAlign: "center" }, children: "Loading..." }),
                        !Re && ie.length === 0 && /* @__PURE__ */ e("div", { style: { padding: "20px 16px", color: "#475569", fontSize: 12, textAlign: "center" }, children: Ae ? "No results" : "No conversations yet" }),
                        ie.map((h) => /* @__PURE__ */ s(
                          "button",
                          {
                            onClick: () => Ie(h.id),
                            style: {
                              display: "block",
                              width: "100%",
                              padding: "8px 12px",
                              background: te === h.id ? "rgba(139,92,246,0.15)" : "transparent",
                              border: "none",
                              borderLeft: te === h.id ? "2px solid #8b5cf6" : "2px solid transparent",
                              cursor: "pointer",
                              textAlign: "left",
                              borderBottom: "1px solid rgba(255,255,255,0.03)"
                            },
                            children: [
                              /* @__PURE__ */ e("div", { style: {
                                color: te === h.id ? "#c4b5fd" : "#cbd5e1",
                                fontSize: 12,
                                fontWeight: 500,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                              }, children: h.title }),
                              /* @__PURE__ */ s("div", { style: { display: "flex", alignItems: "center", gap: 6, marginTop: 2 }, children: [
                                /* @__PURE__ */ e("span", { style: { color: "#475569", fontSize: 10 }, children: Hi(h.updated_at) }),
                                /* @__PURE__ */ e("span", { style: { color: "#334155", fontSize: 10 }, children: "·" }),
                                /* @__PURE__ */ s("span", { style: { color: "#475569", fontSize: 10 }, children: [
                                  h.message_count,
                                  " msg"
                                ] })
                              ] })
                            ]
                          },
                          h.id
                        )),
                        Re && ie.length > 0 && /* @__PURE__ */ e("div", { style: { padding: "8px 16px", color: "#475569", fontSize: 11, textAlign: "center" }, children: "Loading more..." })
                      ]
                    }
                  ),
                  Gt && /* @__PURE__ */ e("div", { style: {
                    padding: "10px 12px",
                    borderTop: "1px solid #1e293b",
                    background: "rgba(249,115,22,0.05)",
                    flexShrink: 0
                  }, children: /* @__PURE__ */ s("div", { style: { color: "#94a3b8", fontSize: 11, lineHeight: 1.5 }, children: [
                    "⏱ Your conversations are saved for 7 days.",
                    " ",
                    /* @__PURE__ */ e("a", { href: "https://theo.theonestack.com/upgrade", target: "_blank", rel: "noopener noreferrer", style: { color: "#f97316", textDecoration: "none", fontWeight: 600 }, children: "Upgrade to keep them forever →" })
                  ] }) })
                ]
              }
            ),
            /* @__PURE__ */ s("div", { style: { flex: 1, display: "flex", flexDirection: "column", minWidth: 0, maxHeight: "inherit", overflow: "hidden" }, children: [
              be && /* @__PURE__ */ s("div", { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 14px",
                borderBottom: "1px solid #334155",
                flexShrink: 0
              }, children: [
                /* @__PURE__ */ e(
                  "button",
                  {
                    onClick: () => Fe(!0),
                    style: {
                      background: "none",
                      border: "1px solid #334155",
                      borderRadius: 6,
                      color: "#94a3b8",
                      fontSize: 12,
                      padding: "4px 10px",
                      cursor: "pointer"
                    },
                    children: "History"
                  }
                ),
                /* @__PURE__ */ e(
                  xo,
                  {
                    customGpts: pt,
                    selectedId: ze,
                    upgradeRequired: yt,
                    open: rt,
                    onToggle: () => Oe((h) => !h),
                    onSelect: (h) => {
                      qe(h), Oe(!1), ye && nt();
                    }
                  }
                ),
                /* @__PURE__ */ e("button", { onClick: n, style: { background: "none", border: "1px solid #334155", cursor: "pointer", color: "#64748b", fontSize: 11, padding: "2px 6px", borderRadius: 4 }, children: "Esc" })
              ] }),
              fe && !p.length && /* @__PURE__ */ e("div", { style: { flex: 1, display: "flex", alignItems: "center", justifyContent: "center", color: "#475569", fontSize: 13 }, children: "Loading conversation..." }),
              ye && /* @__PURE__ */ s(
                "div",
                {
                  ref: it,
                  style: { flex: 1, overflowY: "auto", padding: "12px 0", minHeight: 0, maxHeight: 420 },
                  children: [
                    p.map((h, Y) => {
                      var ue;
                      const F = R.get(Y), le = h.role === "assistant", Ce = le && h.content.length > 0 && !!Qe.current, ge = ne === Y;
                      return /* @__PURE__ */ s(
                        "div",
                        {
                          onMouseEnter: () => le && ee(Y),
                          onMouseLeave: () => ee(null),
                          style: {
                            display: "flex",
                            flexDirection: h.role === "user" ? "row-reverse" : "row",
                            gap: 8,
                            padding: "6px 16px",
                            alignItems: "flex-start"
                          },
                          children: [
                            h.role === "assistant" && /* @__PURE__ */ e("div", { style: { width: 22, height: 22, borderRadius: "50%", background: "rgba(139,92,246,0.3)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, flexShrink: 0, marginTop: 1 }, children: "T" }),
                            /* @__PURE__ */ s("div", { style: { display: "flex", flexDirection: "column", maxWidth: "75%", gap: 4 }, children: [
                              /* @__PURE__ */ e(
                                "div",
                                {
                                  style: {
                                    padding: "7px 11px",
                                    borderRadius: h.role === "user" ? "10px 10px 2px 10px" : "10px 10px 10px 2px",
                                    background: h.role === "user" ? "rgba(249,115,22,0.15)" : "rgba(255,255,255,0.06)",
                                    border: h.role === "user" ? "1px solid rgba(249,115,22,0.25)" : "1px solid rgba(255,255,255,0.06)",
                                    color: "#e2e8f0",
                                    fontSize: 13,
                                    lineHeight: 1.6,
                                    whiteSpace: "pre-wrap"
                                  },
                                  children: h.content || (h.role === "assistant" ? /* @__PURE__ */ e("span", { style: { color: "#475569" }, children: "Thinking…" }) : null)
                                }
                              ),
                              le && (((ue = h.knowledgeUsed) == null ? void 0 : ue.length) ?? 0) > 0 && /* @__PURE__ */ s("div", { children: [
                                /* @__PURE__ */ s(
                                  "button",
                                  {
                                    onClick: () => X((Z) => {
                                      const ce = new Set(Z);
                                      return ce.has(Y) ? ce.delete(Y) : ce.add(Y), ce;
                                    }),
                                    style: {
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: 4,
                                      padding: "2px 7px",
                                      background: "rgba(124,58,237,0.12)",
                                      border: "1px solid rgba(124,58,237,0.25)",
                                      borderRadius: 5,
                                      color: "#a78bfa",
                                      fontSize: 10,
                                      cursor: "pointer",
                                      fontFamily: "inherit"
                                    },
                                    children: [
                                      /* @__PURE__ */ e("span", { style: { fontSize: 9 }, children: "📖" }),
                                      " From your KB"
                                    ]
                                  }
                                ),
                                oe.has(Y) && /* @__PURE__ */ s("div", { style: {
                                  marginTop: 4,
                                  padding: "6px 9px",
                                  background: "rgba(124,58,237,0.07)",
                                  border: "1px solid rgba(124,58,237,0.2)",
                                  borderRadius: 6
                                }, children: [
                                  /* @__PURE__ */ e("div", { style: { fontSize: 9, color: "#7c3aed", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 }, children: "Knowledge entries used:" }),
                                  h.knowledgeUsed.map((Z) => /* @__PURE__ */ s("div", { style: { fontSize: 10, color: "#94a3b8", marginBottom: 2 }, children: [
                                    "• ",
                                    Z.title
                                  ] }, Z.id))
                                ] })
                              ] }),
                              Ce && /* @__PURE__ */ e("div", { style: {
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                                opacity: ge || F ? 1 : 0,
                                transition: "opacity 0.15s",
                                minHeight: 22
                              }, children: F != null && F.submitted ? /* @__PURE__ */ e("span", { style: { fontSize: 11, color: "#475569" }, children: F.rating === "good" ? "👍 Thanks!" : "👎 Got it" }) : /* @__PURE__ */ s(he, { children: [
                                /* @__PURE__ */ e(
                                  "button",
                                  {
                                    onClick: () => {
                                      F != null && F.showReasonPicker || at(Y, "good");
                                    },
                                    title: "Good response",
                                    style: {
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      fontSize: 14,
                                      padding: "1px 3px",
                                      borderRadius: 4,
                                      opacity: (F == null ? void 0 : F.rating) === "good" ? 1 : 0.5,
                                      transition: "opacity 0.1s"
                                    },
                                    onMouseEnter: (Z) => Z.currentTarget.style.opacity = "1",
                                    onMouseLeave: (Z) => Z.currentTarget.style.opacity = (F == null ? void 0 : F.rating) === "good" ? "1" : "0.5",
                                    children: "👍"
                                  }
                                ),
                                /* @__PURE__ */ e(
                                  "button",
                                  {
                                    onClick: () => {
                                      if (F != null && F.submitted) return;
                                      const Z = F == null ? void 0 : F.showReasonPicker;
                                      K((ce) => {
                                        const Pe = new Map(ce);
                                        return Pe.set(Y, { rating: "bad", showReasonPicker: !Z, submitted: !1 }), Pe;
                                      });
                                    },
                                    title: "Not helpful",
                                    style: {
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      fontSize: 14,
                                      padding: "1px 3px",
                                      borderRadius: 4,
                                      opacity: (F == null ? void 0 : F.rating) === "bad" ? 1 : 0.5,
                                      transition: "opacity 0.1s"
                                    },
                                    onMouseEnter: (Z) => Z.currentTarget.style.opacity = "1",
                                    onMouseLeave: (Z) => Z.currentTarget.style.opacity = (F == null ? void 0 : F.rating) === "bad" ? "1" : "0.5",
                                    children: "👎"
                                  }
                                ),
                                (F == null ? void 0 : F.showReasonPicker) && /* @__PURE__ */ s("div", { style: {
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 4,
                                  flexWrap: "wrap",
                                  animation: "theo-slide-down 0.15s ease-out"
                                }, children: [
                                  /* @__PURE__ */ e("span", { style: { fontSize: 10, color: "#64748b" }, children: "Why?" }),
                                  [
                                    ["incorrect", "Incorrect"],
                                    ["too_generic", "Too generic"],
                                    ["missed_the_point", "Missed the point"]
                                  ].map(([Z, ce]) => /* @__PURE__ */ e(
                                    "button",
                                    {
                                      onClick: () => void at(Y, "bad", Z),
                                      style: {
                                        background: "rgba(239,68,68,0.12)",
                                        border: "1px solid rgba(239,68,68,0.25)",
                                        borderRadius: 10,
                                        color: "#fca5a5",
                                        fontSize: 10,
                                        padding: "2px 7px",
                                        cursor: "pointer",
                                        fontFamily: "inherit"
                                      },
                                      children: ce
                                    },
                                    Z
                                  ))
                                ] })
                              ] }) })
                            ] })
                          ]
                        },
                        Y
                      );
                    }),
                    y && ((se = p[p.length - 1]) == null ? void 0 : se.role) !== "assistant" && /* @__PURE__ */ s("div", { style: { display: "flex", gap: 8, padding: "6px 16px", alignItems: "flex-start" }, children: [
                      /* @__PURE__ */ e("div", { style: { width: 22, height: 22, borderRadius: "50%", background: "rgba(139,92,246,0.3)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, flexShrink: 0, marginTop: 1 }, children: "T" }),
                      /* @__PURE__ */ e("div", { style: { padding: "7px 11px", borderRadius: "10px 10px 10px 2px", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.06)", color: "#64748b", fontSize: 13 }, children: "Thinking…" })
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ s("div", { style: { display: "flex", alignItems: "center", padding: "12px 16px", borderTop: ye ? "1px solid #334155" : void 0, borderBottom: ye ? void 0 : "1px solid #334155", gap: 8, flexShrink: 0 }, children: [
                /* @__PURE__ */ e(mt, { size: 16, color: "#64748b" }),
                /* @__PURE__ */ e(
                  "input",
                  {
                    ref: me,
                    value: d,
                    onChange: (h) => {
                      c(h.target.value), f(-1);
                    },
                    onKeyDown: Vt,
                    placeholder: ye ? "Continue the conversation…" : "Ask THEO anything…",
                    style: { flex: 1, background: "transparent", border: "none", outline: "none", color: "#f1f5f9", fontSize: 15 }
                  }
                ),
                d && /* @__PURE__ */ e(
                  "button",
                  {
                    onClick: () => {
                      var h, Y;
                      c(""), (h = Xe.current) == null || h.abort(), (Y = me.current) == null || Y.focus();
                    },
                    style: { background: "none", border: "none", cursor: "pointer", color: "#64748b", padding: 4 },
                    children: /* @__PURE__ */ e(Ke, { size: 14 })
                  }
                ),
                !be && /* @__PURE__ */ s(he, { children: [
                  /* @__PURE__ */ e(
                    "a",
                    {
                      href: "https://theo.theonestack.com",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      title: "Open THEO full app",
                      style: { display: "flex", alignItems: "center", gap: 3, color: "#475569", textDecoration: "none", fontSize: 11, padding: "2px 6px", borderRadius: 4, border: "1px solid #334155", whiteSpace: "nowrap" },
                      onMouseEnter: (h) => {
                        h.currentTarget.style.color = "#a78bfa", h.currentTarget.style.borderColor = "#6366f1";
                      },
                      onMouseLeave: (h) => {
                        h.currentTarget.style.color = "#475569", h.currentTarget.style.borderColor = "#334155";
                      },
                      children: "↗ Open full app"
                    }
                  ),
                  /* @__PURE__ */ e("button", { onClick: n, style: { background: "none", border: "1px solid #334155", cursor: "pointer", color: "#64748b", fontSize: 11, padding: "2px 6px", borderRadius: 4 }, children: "Esc" })
                ] })
              ] }),
              C && !ye && /* @__PURE__ */ e("div", { style: { padding: "12px 16px", borderBottom: "1px solid #334155", background: "rgba(139,92,246,0.08)", flexShrink: 0 }, children: /* @__PURE__ */ s("div", { style: { display: "flex", alignItems: "flex-start", gap: 10 }, children: [
                /* @__PURE__ */ e("span", { style: { fontSize: 20, lineHeight: 1 }, children: "✨" }),
                /* @__PURE__ */ s("div", { children: [
                  /* @__PURE__ */ s("div", { style: { color: "#e2e8f0", fontSize: 13, fontWeight: 600, marginBottom: 4 }, children: [
                    "Welcome to ",
                    ji[r] ?? "The One Stack",
                    "! I'm THEO, your AI assistant."
                  ] }),
                  /* @__PURE__ */ e("div", { style: { color: "#94a3b8", fontSize: 12, lineHeight: 1.6 }, children: "Ask me anything — “How do I get started?”, “What should I do first?”, or try one of the quick actions below." })
                ] })
              ] }) }),
              !ye && /* @__PURE__ */ s("div", { style: { padding: "8px 0", overflowY: "auto" }, children: [
                /* @__PURE__ */ e("div", { style: { padding: "4px 16px 6px", fontSize: 11, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }, children: "Quick actions" }),
                tt.map((h, Y) => /* @__PURE__ */ s(
                  "button",
                  {
                    onMouseEnter: () => f(Y),
                    onClick: () => ht(h.label),
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      width: "100%",
                      padding: "7px 16px",
                      background: w === Y ? "rgba(248,113,25,0.1)" : "transparent",
                      border: "none",
                      cursor: "pointer",
                      textAlign: "left",
                      color: w === Y ? "#f97316" : "#cbd5e1",
                      fontSize: 13
                    },
                    children: [
                      /* @__PURE__ */ e("span", { style: { fontSize: 15 }, children: h.icon }),
                      /* @__PURE__ */ e("span", { children: h.label }),
                      h.hint && /* @__PURE__ */ e("span", { style: { marginLeft: "auto", color: "#475569", fontSize: 11 }, children: h.hint })
                    ]
                  },
                  h.label
                )),
                S.length > 0 && /* @__PURE__ */ s(he, { children: [
                  /* @__PURE__ */ e("div", { style: { padding: "8px 16px 4px", fontSize: 11, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", borderTop: "1px solid #1e293b", marginTop: 4 }, children: "Recent" }),
                  S.map((h) => /* @__PURE__ */ s(
                    "button",
                    {
                      onClick: () => {
                        c(h), ht(h);
                      },
                      style: {
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        width: "100%",
                        padding: "7px 16px",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        color: "#94a3b8",
                        fontSize: 13,
                        textAlign: "left"
                      },
                      children: [
                        /* @__PURE__ */ e("span", { style: { fontSize: 12 }, children: "🕐" }),
                        h
                      ]
                    },
                    h
                  ))
                ] })
              ] }),
              (_ == null ? void 0 : _.limit) && _.count >= _.limit && /* @__PURE__ */ s("div", { style: { padding: "10px 16px", borderTop: "1px solid #334155", background: "rgba(239,68,68,0.08)", display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }, children: [
                /* @__PURE__ */ e("span", { style: { fontSize: 14 }, children: "🔒" }),
                /* @__PURE__ */ s("div", { style: { flex: 1 }, children: [
                  /* @__PURE__ */ e("div", { style: { color: "#fca5a5", fontSize: 12, fontWeight: 600 }, children: "Daily limit reached" }),
                  /* @__PURE__ */ e("div", { style: { color: "#94a3b8", fontSize: 11 }, children: "Resets at midnight UTC" })
                ] }),
                /* @__PURE__ */ e(
                  "a",
                  {
                    href: "https://hub.theonestack.com/billing",
                    target: "_blank",
                    rel: "noreferrer",
                    style: { fontSize: 11, color: "#f97316", fontWeight: 600, textDecoration: "none", padding: "4px 10px", border: "1px solid #f97316", borderRadius: 6, whiteSpace: "nowrap" },
                    children: "⚡ Upgrade"
                  }
                )
              ] }),
              (_ == null ? void 0 : _.limit) && _.count >= Math.floor(_.limit * 0.8) && _.count < _.limit && /* @__PURE__ */ s("div", { style: { padding: "8px 16px", borderTop: "1px solid #334155", background: "rgba(249,115,22,0.06)", display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }, children: [
                /* @__PURE__ */ s("span", { style: { fontSize: 12, color: "#fb923c" }, children: [
                  "⚡ ",
                  _.limit - _.count,
                  " free ",
                  _.limit - _.count === 1 ? "query" : "queries",
                  " remaining today"
                ] }),
                /* @__PURE__ */ e(
                  "a",
                  {
                    href: "https://hub.theonestack.com/billing",
                    target: "_blank",
                    rel: "noreferrer",
                    style: { marginLeft: "auto", fontSize: 11, color: "#f97316", fontWeight: 600, textDecoration: "none" },
                    children: "Upgrade →"
                  }
                )
              ] }),
              g && !L && /* @__PURE__ */ s("div", { style: { padding: "10px 16px", borderTop: "1px solid #334155", background: "rgba(139,92,246,0.08)", display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }, children: [
                /* @__PURE__ */ e("span", { style: { fontSize: 14 }, children: "💡" }),
                /* @__PURE__ */ s("div", { style: { flex: 1 }, children: [
                  /* @__PURE__ */ e("div", { style: { color: "#a78bfa", fontSize: 12, fontWeight: 600 }, children: "THEO wants to remember:" }),
                  /* @__PURE__ */ s("div", { style: { color: "#cbd5e1", fontSize: 12, marginTop: 2 }, children: [
                    "“",
                    g,
                    "”"
                  ] })
                ] }),
                /* @__PURE__ */ e(
                  "button",
                  {
                    onClick: async () => {
                      try {
                        await fetch(`${o}/api/v1/theo/memory`, {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                          credentials: "include",
                          body: JSON.stringify({ scope: "org", memory_type: "context", content: g })
                        });
                      } catch {
                      }
                      z(null), T(!0);
                    },
                    style: { padding: "4px 10px", borderRadius: 6, fontSize: 11, cursor: "pointer", background: "rgba(139,92,246,0.3)", border: "1px solid rgba(139,92,246,0.5)", color: "#a78bfa", fontWeight: 600, whiteSpace: "nowrap" },
                    children: "Save this"
                  }
                ),
                /* @__PURE__ */ e(
                  "button",
                  {
                    onClick: () => {
                      z(null), T(!0);
                    },
                    style: { background: "none", border: "none", cursor: "pointer", color: "#475569", fontSize: 12 },
                    children: "No thanks"
                  }
                )
              ] }),
              re && /* @__PURE__ */ e("div", { style: {
                position: "absolute",
                bottom: 52,
                left: "50%",
                transform: "translateX(-50%)",
                background: "#1e293b",
                border: "1px solid #334155",
                borderRadius: 8,
                padding: "6px 14px",
                fontSize: 12,
                color: "#94a3b8",
                boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                animation: "theo-fade-in 0.2s ease-out",
                pointerEvents: "none",
                whiteSpace: "nowrap",
                zIndex: 10
              }, children: "Thanks for the feedback" }),
              /* @__PURE__ */ s("div", { style: { padding: "8px 16px", borderTop: "1px solid #1e293b", display: "flex", alignItems: "center", gap: 8, fontSize: 11, color: "#475569", flexShrink: 0 }, children: [
                !be && /* @__PURE__ */ e("div", { style: { position: "relative" }, children: /* @__PURE__ */ e(
                  xo,
                  {
                    customGpts: pt,
                    selectedId: ze,
                    upgradeRequired: yt,
                    open: rt,
                    onToggle: () => Oe((h) => !h),
                    onSelect: (h) => {
                      qe(h), Oe(!1), ye && nt();
                    }
                  }
                ) }),
                /* @__PURE__ */ e("span", { children: "↑↓ navigate" }),
                /* @__PURE__ */ e("span", { children: "·" }),
                /* @__PURE__ */ e("span", { children: "↵ submit" }),
                /* @__PURE__ */ e("span", { children: "·" }),
                /* @__PURE__ */ e("span", { children: "Esc close" }),
                !ye && /* @__PURE__ */ e(
                  "button",
                  {
                    onClick: () => {
                      j(!0);
                    },
                    title: "Replay THEO intro",
                    style: { marginLeft: "auto", background: "none", border: "1px solid #334155", cursor: "pointer", color: "#475569", fontSize: 10, padding: "2px 7px", borderRadius: 4, fontFamily: "inherit" },
                    onMouseEnter: (h) => h.currentTarget.style.color = "#6366f1",
                    onMouseLeave: (h) => h.currentTarget.style.color = "#475569",
                    children: "? Intro"
                  }
                ),
                !window.__theoDesktop && /* @__PURE__ */ e(
                  "a",
                  {
                    href: "https://theo.theonestack.com/download",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    title: "Get the THEO desktop app",
                    style: { marginLeft: ye ? "auto" : void 0, display: "flex", alignItems: "center", gap: 3, color: "#475569", textDecoration: "none", fontSize: 11 },
                    onMouseEnter: (h) => h.currentTarget.style.color = "#a78bfa",
                    onMouseLeave: (h) => h.currentTarget.style.color = "#475569",
                    children: "💻 Desktop app"
                  }
                ),
                (_ == null ? void 0 : _.limit) && /* @__PURE__ */ s("span", { style: { color: _.count >= _.limit ? "#ef4444" : _.count >= Math.floor(_.limit * 0.8) ? "#fb923c" : "#475569" }, children: [
                  _.count,
                  "/",
                  _.limit,
                  " today"
                ] })
              ] })
            ] })
          ]
        }
      )
    }
  ) : null;
}
const yo = {
  psa: {
    name: "PSA",
    color: "#f97316",
    actions: [
      { label: "New Ticket", path: "/psa/service-desk/tickets/new" },
      { label: "Log Time", path: "/psa/time-tracking/new" },
      { label: "New Invoice", path: "/psa/finance/invoices/new" },
      { label: "New Company", path: "/psa/companies/new" },
      { label: "New Contract", path: "/psa/finance/contracts/new" }
    ]
  },
  rmm: {
    name: "RMM",
    color: "#3b82f6",
    actions: [
      { label: "View Alerts", path: "/rmm/alerts" },
      { label: "Run Script", path: "/rmm/scripts/new" },
      { label: "New Device Group", path: "/rmm/device-groups/new" },
      { label: "View Devices", path: "/rmm/devices" }
    ]
  },
  crm: {
    name: "CRM",
    color: "#8b5cf6",
    actions: [
      { label: "New Lead", path: "/crm/leads/new" },
      { label: "New Deal", path: "/crm/pipeline/new" },
      { label: "New Contact", path: "/crm/contacts/new" },
      { label: "New Company", path: "/crm/companies/new" }
    ]
  },
  books: {
    name: "Books",
    color: "#10b981",
    actions: [
      { label: "New Invoice", path: "/books/invoices/new" },
      { label: "New Estimate", path: "/books/estimates/new" },
      { label: "Record Payment", path: "/books/payments/new" },
      { label: "New Expense", path: "/books/expenses/new" }
    ]
  },
  voice: {
    name: "Voice",
    color: "#06b6d4",
    actions: [
      { label: "New Call", path: "/voice/calls/new" },
      { label: "Send SMS", path: "/voice/sms/new" },
      { label: "View Voicemail", path: "/voice/voicemail" }
    ]
  },
  projects: {
    name: "Projects",
    color: "#f59e0b",
    actions: [
      { label: "New Project", path: "/projects/new" },
      { label: "New Milestone", path: "/projects/milestones/new" },
      { label: "New Task", path: "/projects/tasks/new" }
    ]
  },
  security: {
    name: "Security",
    color: "#ef4444",
    actions: [
      { label: "View Alerts", path: "/security/alerts" },
      { label: "New Scan", path: "/security/scans/new" },
      { label: "View Reports", path: "/security/reports" }
    ]
  }
};
function Ui({
  products: t,
  hubUrl: n = ""
}) {
  const [o, r] = x(!1), i = q(null);
  V(() => {
    if (!o) return;
    function c(p) {
      i.current && !i.current.contains(p.target) && r(!1);
    }
    return document.addEventListener("mousedown", c), () => document.removeEventListener("mousedown", c);
  }, [o]), V(() => {
    if (!o) return;
    function c(p) {
      p.key === "Escape" && r(!1);
    }
    return document.addEventListener("keydown", c), () => document.removeEventListener("keydown", c);
  }, [o]);
  const a = t.filter(
    (c) => (c.active || c.has_beta_access) && (c.launch_status === "ga" || c.launch_status === "beta_invite") && yo[c.id]
  ).slice(0, 7).map((c) => ({ product: c, config: yo[c.id] })), d = a.length > 3 ? 2 : 1;
  return /* @__PURE__ */ s("div", { ref: i, style: { position: "relative", flexShrink: 0 }, children: [
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        onClick: () => r((c) => !c),
        "aria-label": "Quick Create",
        "aria-expanded": o,
        "aria-haspopup": "true",
        style: {
          display: "flex",
          alignItems: "center",
          gap: 5,
          height: 30,
          padding: "0 10px",
          borderRadius: 6,
          background: o ? "rgba(249,115,22,0.15)" : "rgba(255,255,255,0.06)",
          border: `1px solid ${o ? "rgba(249,115,22,0.35)" : "rgba(255,255,255,0.1)"}`,
          color: o ? "#f97316" : "#cbd5e1",
          cursor: "pointer",
          fontSize: 13,
          fontWeight: 500,
          transition: "all 0.15s",
          whiteSpace: "nowrap"
        },
        onMouseEnter: (c) => {
          if (!o) {
            const p = c.currentTarget;
            p.style.background = "rgba(255,255,255,0.09)", p.style.color = "#f1f5f9", p.style.borderColor = "rgba(255,255,255,0.15)";
          }
        },
        onMouseLeave: (c) => {
          if (!o) {
            const p = c.currentTarget;
            p.style.background = "rgba(255,255,255,0.06)", p.style.color = "#cbd5e1", p.style.borderColor = "rgba(255,255,255,0.1)";
          }
        },
        children: [
          /* @__PURE__ */ e("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-hidden": "true", children: /* @__PURE__ */ e("path", { d: "M7 1v12M1 7h12", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round" }) }),
          /* @__PURE__ */ e("span", { children: "Create" })
        ]
      }
    ),
    o && /* @__PURE__ */ s(
      "div",
      {
        role: "menu",
        style: {
          position: "absolute",
          top: "calc(100% + 8px)",
          right: 0,
          width: d === 2 ? 480 : 240,
          maxHeight: "calc(100vh - 80px)",
          overflowY: "auto",
          background: "#18181b",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: 10,
          boxShadow: "0 24px 64px rgba(0,0,0,0.55)",
          zIndex: 10001
        },
        children: [
          a.length === 0 ? /* @__PURE__ */ e("div", { style: { padding: "20px", color: "#64748b", fontSize: 13, textAlign: "center" }, children: "No active products found" }) : /* @__PURE__ */ e(
            "div",
            {
              style: {
                display: "grid",
                gridTemplateColumns: `repeat(${d}, 1fr)`,
                gap: 0
              },
              children: a.map(({ product: c, config: p }, u) => {
                const y = u % d;
                return /* @__PURE__ */ s(
                  "div",
                  {
                    style: {
                      padding: "14px 16px",
                      borderRight: d === 2 && y === 0 ? "1px solid rgba(255,255,255,0.06)" : "none",
                      borderBottom: u < a.length - d ? "1px solid rgba(255,255,255,0.06)" : "none"
                    },
                    children: [
                      /* @__PURE__ */ s("div", { style: { display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }, children: [
                        /* @__PURE__ */ e(
                          "span",
                          {
                            style: {
                              display: "inline-block",
                              width: 7,
                              height: 7,
                              borderRadius: "50%",
                              background: p.color,
                              flexShrink: 0
                            }
                          }
                        ),
                        /* @__PURE__ */ e(
                          "span",
                          {
                            style: {
                              fontSize: 10.5,
                              fontWeight: 700,
                              color: "#64748b",
                              textTransform: "uppercase",
                              letterSpacing: "0.08em"
                            },
                            children: p.name
                          }
                        )
                      ] }),
                      /* @__PURE__ */ e("div", { style: { display: "flex", flexDirection: "column", gap: 1 }, children: p.actions.map((S) => /* @__PURE__ */ e(
                        "a",
                        {
                          href: `${n}${S.path}`,
                          role: "menuitem",
                          onClick: () => r(!1),
                          style: {
                            display: "block",
                            padding: "5px 8px",
                            borderRadius: 5,
                            color: "#cbd5e1",
                            fontSize: 12.5,
                            textDecoration: "none",
                            transition: "background 0.1s, color 0.1s"
                          },
                          onMouseEnter: (b) => {
                            const w = b.currentTarget;
                            w.style.background = "rgba(255,255,255,0.07)", w.style.color = "#f1f5f9";
                          },
                          onMouseLeave: (b) => {
                            const w = b.currentTarget;
                            w.style.background = "transparent", w.style.color = "#cbd5e1";
                          },
                          children: S.label
                        },
                        S.label
                      )) })
                    ]
                  },
                  c.id
                );
              })
            }
          ),
          /* @__PURE__ */ e(
            "div",
            {
              style: {
                borderTop: "1px solid rgba(255,255,255,0.06)",
                padding: "8px 16px",
                fontSize: 11,
                color: "#475569"
              },
              children: "Only showing products you have access to"
            }
          )
        ]
      }
    )
  ] });
}
const Wi = typeof window < "u" && window.__GATHER_URL__ || "https://app.theonestack.com/gather";
function Fi(t, n, o) {
  const [r, i] = x([]), a = q(null);
  return V(() => {
    if (!n || !o) return;
    let d = !1;
    async function c() {
      try {
        const p = await fetch(`${t}/api/v1/gather/presence/all`, {
          credentials: "include"
        });
        if (p.ok && !d) {
          const u = await p.json();
          i(u.active_spaces ?? []);
        }
      } catch {
      }
    }
    return c(), a.current = setInterval(c, 3e4), () => {
      d = !0, a.current && clearInterval(a.current);
    };
  }, [t, n, o]), r;
}
function Vi({ apiBase: t, tenantId: n, userId: o, currentProduct: r }) {
  var m;
  const i = Fi(t, n, o), [a, d] = x(!1), c = i.length > 0, p = r === "gather", u = t.includes("localhost") ? "http://localhost:5180" : Wi, y = c && i[0] ? `${u}/space/${i[0].space_id}` : u;
  return /* @__PURE__ */ s("div", { style: { position: "relative" }, children: [
    /* @__PURE__ */ s(
      "a",
      {
        href: y,
        target: "_blank",
        rel: "noopener noreferrer",
        onMouseEnter: () => d(!0),
        onMouseLeave: () => d(!1),
        title: c ? `In Gather — ${i.map((S) => S.space_name).join(", ")}` : "The One Gather",
        "aria-label": c ? `In Gather — ${(m = i[0]) == null ? void 0 : m.space_name}` : "Open Gather",
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 32,
          height: 32,
          borderRadius: 8,
          textDecoration: "none",
          position: "relative",
          background: p ? "rgba(99,102,241,0.2)" : c ? "rgba(34,197,94,0.12)" : "transparent",
          border: p ? "1px solid rgba(99,102,241,0.4)" : c ? "1px solid rgba(34,197,94,0.25)" : "1px solid transparent",
          transition: "all 0.15s"
        },
        children: [
          /* @__PURE__ */ e(Gi, { active: c, isCurrentProduct: p }),
          c && /* @__PURE__ */ e(
            "span",
            {
              style: {
                position: "absolute",
                top: 4,
                right: 4,
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: "#22c55e",
                border: "1.5px solid #09090b"
              },
              children: /* @__PURE__ */ e(
                "span",
                {
                  style: {
                    position: "absolute",
                    inset: -3,
                    borderRadius: "50%",
                    border: "2px solid rgba(34,197,94,0.4)",
                    animation: "gather-pulse 2s ease-out infinite"
                  }
                }
              )
            }
          )
        ]
      }
    ),
    a && /* @__PURE__ */ e(
      "div",
      {
        style: {
          position: "absolute",
          top: "calc(100% + 8px)",
          right: 0,
          background: "#1e1e30",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: 8,
          padding: "8px 12px",
          fontSize: 12,
          color: "#f1f5f9",
          whiteSpace: "nowrap",
          zIndex: 1e4,
          boxShadow: "0 4px 16px rgba(0,0,0,0.4)",
          minWidth: 140,
          pointerEvents: "none"
        },
        children: c ? /* @__PURE__ */ s(he, { children: [
          /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: 4, color: "#22c55e" }, children: "● In Gather" }),
          i.map((S) => /* @__PURE__ */ e("div", { style: { color: "#94a3b8", fontSize: 11 }, children: S.space_name }, S.space_id)),
          /* @__PURE__ */ e("div", { style: { marginTop: 6, color: "#475569", fontSize: 11, borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: 6 }, children: "Click to return to space" })
        ] }) : /* @__PURE__ */ s(he, { children: [
          /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: 2 }, children: "The One Gather" }),
          /* @__PURE__ */ e("div", { style: { color: "#64748b", fontSize: 11 }, children: "Virtual spaces for your team" })
        ] })
      }
    ),
    /* @__PURE__ */ e("style", { children: `
        @keyframes gather-pulse {
          0% { transform: scale(0.8); opacity: 1; }
          100% { transform: scale(2.2); opacity: 0; }
        }
      ` })
  ] });
}
function Gi({ active: t, isCurrentProduct: n }) {
  const o = n ? "#a5b4fc" : t ? "#4ade80" : "#64748b";
  return /* @__PURE__ */ s("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", children: [
    /* @__PURE__ */ e("circle", { cx: "8", cy: "8", r: "2.5", fill: o }),
    /* @__PURE__ */ e("circle", { cx: "8", cy: "2.5", r: "1.5", fill: o, opacity: "0.85" }),
    /* @__PURE__ */ e("circle", { cx: "13.1", cy: "11", r: "1.5", fill: o, opacity: "0.7" }),
    /* @__PURE__ */ e("circle", { cx: "2.9", cy: "11", r: "1.5", fill: o, opacity: "0.55" }),
    /* @__PURE__ */ e("line", { x1: "8", y1: "4", x2: "8", y2: "5.5", stroke: o, strokeWidth: "1", opacity: "0.5" }),
    /* @__PURE__ */ e("line", { x1: "11.8", y1: "10", x2: "10.1", y2: "9.1", stroke: o, strokeWidth: "1", opacity: "0.4" }),
    /* @__PURE__ */ e("line", { x1: "4.2", y1: "10", x2: "5.9", y2: "9.1", stroke: o, strokeWidth: "1", opacity: "0.4" })
  ] });
}
function wn() {
  return Math.random().toString(36).slice(2);
}
function Yi({ open: t, onClose: n, apiBase: o, tenantId: r, session: i }) {
  const [a, d] = x([
    {
      id: "welcome",
      role: "assistant",
      content: `Hi${i.firstName ? ` ${i.firstName}` : ""}! I'm THEO, your support assistant. I can help you with tickets, check device status, review invoices, or answer questions about your services. What can I help you with today?`,
      ts: (/* @__PURE__ */ new Date()).toISOString()
    }
  ]), [c, p] = x(""), [u, y] = x(!1), m = q(null);
  V(() => {
    var b;
    (b = m.current) == null || b.scrollIntoView({ behavior: "smooth" });
  }, [a]);
  async function S() {
    const b = c.trim();
    if (!b || u) return;
    const w = { id: wn(), role: "user", content: b, ts: (/* @__PURE__ */ new Date()).toISOString() };
    d((f) => [...f, w]), p(""), y(!0);
    try {
      const I = (await (await fetch(`${o}/api/portal/theo/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          message: b,
          history: a.slice(-6).map((_) => ({ role: _.role, content: _.content })),
          tenant_id: r,
          user_id: i.userId
        })
      })).json().catch(() => ({}))).reply || "I'm having trouble processing that right now. Please try again or contact support directly.";
      d((_) => [..._, {
        id: wn(),
        role: "assistant",
        content: I,
        ts: (/* @__PURE__ */ new Date()).toISOString()
      }]);
    } catch {
      d((f) => [...f, {
        id: wn(),
        role: "assistant",
        content: "Something went wrong. Please try again in a moment.",
        ts: (/* @__PURE__ */ new Date()).toISOString()
      }]);
    } finally {
      y(!1);
    }
  }
  return t ? /* @__PURE__ */ s(
    "div",
    {
      className: "hb-mini-theo",
      role: "dialog",
      "aria-label": "THEO Support Chat",
      style: {
        position: "fixed",
        bottom: "56px",
        right: "16px",
        width: "360px",
        maxHeight: "520px",
        background: "#1e293b",
        border: "1px solid #334155",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        zIndex: 9999,
        boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
        overflow: "hidden"
      },
      children: [
        /* @__PURE__ */ s("div", { style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 16px",
          borderBottom: "1px solid #334155",
          background: "#0f172a"
        }, children: [
          /* @__PURE__ */ s("div", { style: { display: "flex", alignItems: "center", gap: "8px" }, children: [
            /* @__PURE__ */ e("div", { style: {
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "13px",
              fontWeight: "700",
              color: "#fff"
            }, children: "T" }),
            /* @__PURE__ */ s("div", { children: [
              /* @__PURE__ */ e("div", { style: { fontSize: "13px", fontWeight: "600", color: "#f1f5f9" }, children: "THEO" }),
              /* @__PURE__ */ e("div", { style: { fontSize: "11px", color: "#94a3b8" }, children: "Support Assistant" })
            ] })
          ] }),
          /* @__PURE__ */ e(
            "button",
            {
              onClick: n,
              style: {
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#64748b",
                padding: "4px",
                borderRadius: "4px",
                fontSize: "18px",
                lineHeight: 1
              },
              "aria-label": "Close THEO chat",
              children: "×"
            }
          )
        ] }),
        /* @__PURE__ */ s("div", { style: {
          flex: 1,
          overflowY: "auto",
          padding: "12px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          minHeight: 0
        }, children: [
          a.map((b) => /* @__PURE__ */ e(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: b.role === "user" ? "flex-end" : "flex-start"
              },
              children: /* @__PURE__ */ e("div", { style: {
                maxWidth: "85%",
                padding: "8px 12px",
                borderRadius: b.role === "user" ? "12px 12px 4px 12px" : "12px 12px 12px 4px",
                background: b.role === "user" ? "#6d28d9" : "#334155",
                color: "#f1f5f9",
                fontSize: "13px",
                lineHeight: "1.5",
                wordBreak: "break-word"
              }, children: b.content })
            },
            b.id
          )),
          u && /* @__PURE__ */ e("div", { style: { display: "flex", justifyContent: "flex-start" }, children: /* @__PURE__ */ e("div", { style: {
            padding: "8px 12px",
            borderRadius: "12px 12px 12px 4px",
            background: "#334155",
            color: "#94a3b8",
            fontSize: "13px"
          }, children: /* @__PURE__ */ e("span", { style: { animation: "pulse 1.5s infinite" }, children: "●●●" }) }) }),
          /* @__PURE__ */ e("div", { ref: m })
        ] }),
        /* @__PURE__ */ s("div", { style: {
          padding: "10px 12px",
          borderTop: "1px solid #334155",
          display: "flex",
          gap: "8px",
          background: "#0f172a"
        }, children: [
          /* @__PURE__ */ e(
            "input",
            {
              type: "text",
              value: c,
              onChange: (b) => p(b.target.value),
              onKeyDown: (b) => {
                b.key === "Enter" && !b.shiftKey && (b.preventDefault(), S());
              },
              placeholder: "Ask THEO...",
              disabled: u,
              style: {
                flex: 1,
                background: "#1e293b",
                border: "1px solid #334155",
                borderRadius: "8px",
                padding: "8px 12px",
                color: "#f1f5f9",
                fontSize: "13px",
                outline: "none"
              }
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              onClick: () => void S(),
              disabled: u || !c.trim(),
              style: {
                background: "#6d28d9",
                border: "none",
                borderRadius: "8px",
                padding: "8px 12px",
                color: "#fff",
                cursor: u || !c.trim() ? "not-allowed" : "pointer",
                opacity: u || !c.trim() ? 0.5 : 1,
                fontSize: "13px",
                fontWeight: "600"
              },
              children: "Send"
            }
          )
        ] })
      ]
    }
  ) : null;
}
function Ki({ open: t, onToggle: n }) {
  return /* @__PURE__ */ s(
    "button",
    {
      className: "hb-btn hb-btn--icon",
      onClick: n,
      "aria-label": "Open THEO support chat",
      "aria-expanded": t,
      style: {
        background: t ? "#6d28d9" : void 0,
        borderRadius: "6px"
      },
      children: [
        /* @__PURE__ */ s("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
          /* @__PURE__ */ e("circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5" }),
          /* @__PURE__ */ e("path", { d: "M8 12h8M8 8h8M8 16h5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })
        ] }),
        /* @__PURE__ */ e("span", { className: "hb-label", children: "Support" })
      ]
    }
  );
}
async function Me(t, n = {}) {
  const o = await fetch(t, {
    credentials: "include",
    ...n,
    headers: {
      Accept: "application/json",
      ...n.body ? { "Content-Type": "application/json" } : {},
      ...n.headers || {}
    }
  });
  if (!o.ok) {
    let r = `HTTP ${o.status}`;
    try {
      const i = await o.json();
      i.error && (r = i.error);
    } catch {
    }
    throw new Error(r);
  }
  return o.json();
}
function qi(t, n) {
  const o = /* @__PURE__ */ new Map();
  for (const r of t) {
    const i = n.has(r.from) ? r.to : r.from, a = o.get(i);
    a ? new Date(r.created_at).getTime() > new Date(a.lastMessageAt).getTime() && (a.lastMessageAt = r.created_at, a.lastMessagePreview = r.body.slice(0, 80)) : o.set(i, {
      peer: i,
      lastMessageAt: r.created_at,
      lastMessagePreview: r.body.slice(0, 80),
      unreadCount: r.direction === "inbound" && r.status !== "read" ? 1 : 0
    });
  }
  return Array.from(o.values()).sort(
    (r, i) => new Date(i.lastMessageAt).getTime() - new Date(r.lastMessageAt).getTime()
  );
}
function Bi({ apiBase: t, orgId: n }) {
  const [o, r] = x("idle"), [i, a] = x(null), [d, c] = x(!1), [p, u] = x(!1), [y, m] = x(!1), [S, b] = x(0), [w, f] = x([]), [C, I] = x([]), [_, A] = x(!1), [g, z] = x(!1), [L, T] = x(null), H = q(null);
  V(() => {
    H.current = i;
  }, [i]);
  const j = q("idle");
  V(() => {
    j.current = o;
  }, [o]), V(() => {
    if (o !== "active" || !i) {
      b(0);
      return;
    }
    const N = i.startTime, E = setInterval(() => {
      b(Math.max(0, Math.floor((Date.now() - N) / 1e3)));
    }, 1e3);
    return () => clearInterval(E);
  }, [o, i]);
  const B = P(async () => {
    A(!0);
    try {
      const N = await Me(
        `${t}/api/v1/voice/calls?limit=10`
      );
      f(
        N.calls.map((E) => ({
          id: E.id,
          direction: E.direction ?? "outbound",
          status: E.status ?? "unknown",
          fromNumber: E.from_number ?? "",
          toNumber: E.to_number ?? "",
          startedAt: E.started_at ?? "",
          durationSecs: E.duration_secs ?? null,
          missed: !!E.missed_at || E.status === "missed"
        }))
      );
    } catch (N) {
      console.warn("[phone] refreshRecents failed:", N instanceof Error ? N.message : String(N));
    } finally {
      A(!1);
    }
  }, [t]), U = P(async () => {
    z(!0);
    try {
      const N = await Me(
        `${t}/api/v1/voice/sms?limit=200`
      ), E = /* @__PURE__ */ new Set();
      for (const G of N.messages)
        G.direction === "outbound" && G.from && E.add(G.from);
      I(qi(N.messages, E));
    } catch (N) {
      console.warn("[phone] refreshThreads failed:", N instanceof Error ? N.message : String(N));
    } finally {
      z(!1);
    }
  }, [t]), W = P(async (N) => {
    try {
      return (await Me(
        `${t}/api/v1/voice/sms?limit=100&phone=${encodeURIComponent(N)}`
      )).messages.map((G) => ({
        id: G.id,
        direction: G.direction,
        from: G.from,
        to: G.to,
        body: G.body,
        status: G.status,
        createdAt: G.created_at
      }));
    } catch (E) {
      return T(E instanceof Error ? E.message : "Failed to load messages"), [];
    }
  }, [t]);
  V(() => {
    if (!n) return;
    let N = !1, E = null;
    try {
      E = new EventSource(
        `${t}/api/v1/voice/livekit/incoming-stream`,
        { withCredentials: !0 }
      );
    } catch {
      return;
    }
    const G = (Re) => {
      if (!N)
        try {
          const Te = JSON.parse(Re.data);
          if (H.current && j.current === "active") return;
          a({
            id: Te.call_id,
            roomName: Te.room_name,
            direction: "inbound",
            from: Te.caller_org_id || "Unknown caller",
            to: n ?? "",
            callerName: Te.greeting,
            startTime: Date.now()
          }), r("ringing");
        } catch {
        }
    };
    return E.addEventListener("inapp_call", G), E.addEventListener("incoming_call", G), E.onerror = () => {
    }, () => {
      N = !0, E == null || E.close();
    };
  }, [t, n]), V(() => {
    if (!n) return;
    let N = !1, E = /* @__PURE__ */ new Set();
    const G = async () => {
      if (!N)
        try {
          const Te = await Me(
            `${t}/api/v1/voice/calls?limit=5&direction=inbound`
          );
          for (const fe of Te.calls)
            fe.status === "ringing" && !E.has(fe.id) && (H.current || (a({
              id: fe.id,
              roomName: fe.room_name ?? void 0,
              callControlId: fe.call_control_id ?? void 0,
              direction: "inbound",
              from: fe.from_number ?? "Unknown",
              to: fe.to_number ?? "",
              callerName: fe.caller_display ?? void 0,
              startTime: fe.started_at ? new Date(fe.started_at).getTime() : Date.now()
            }), r("ringing")));
          E = new Set(Te.calls.map((fe) => fe.id));
        } catch {
        }
    };
    G();
    const Re = setInterval(G, 5e3);
    return () => {
      N = !0, clearInterval(Re);
    };
  }, [t, n]), V(() => {
    n && (B(), U());
  }, [n, B, U]);
  const J = P(async (N) => {
    if (!N.trim()) {
      T("Enter a number to call");
      return;
    }
    T(null);
    try {
      const E = await Me(
        `${t}/api/v1/voice/calls`,
        { method: "POST", body: JSON.stringify({ to: N.trim() }) }
      ), G = E.call_id ?? E.call_session_id ?? E.call_control_id ?? `out_${Date.now()}`;
      a({
        id: G,
        roomName: E.room_name,
        callControlId: E.call_control_id,
        direction: "outbound",
        from: "",
        to: N.trim(),
        startTime: Date.now()
      }), r("active"), c(!1), u(!1), m(!1);
    } catch (E) {
      T(E instanceof Error ? E.message : "Call failed"), r("idle"), a(null);
    }
  }, [t]), R = P(async () => {
    i && (r("active"), a({ ...i, startTime: Date.now() }));
  }, [i]), K = P(async () => {
    const N = i;
    if (N) {
      r("idle"), a(null);
      try {
        await Me(`${t}/api/v1/voice/calls/${encodeURIComponent(N.id)}`, {
          method: "DELETE"
        });
      } catch {
      }
      B();
    }
  }, [t, i, B]), re = P(async () => {
    const N = i;
    if (N) {
      r("idle"), a(null), c(!1), u(!1), m(!1);
      try {
        await Me(`${t}/api/v1/voice/calls/${encodeURIComponent(N.id)}`, {
          method: "DELETE"
        });
      } catch {
      }
      B();
    }
  }, [t, i, B]), $ = P(async () => {
    const N = i;
    if (!(N != null && N.roomName)) {
      u(!0), r("held");
      return;
    }
    try {
      await Me(
        `${t}/api/v1/voice/livekit/call/${encodeURIComponent(N.roomName)}/hold`,
        { method: "POST", body: JSON.stringify({ hold: !0 }) }
      ), u(!0), r("held");
    } catch (E) {
      T(E instanceof Error ? E.message : "Hold failed");
    }
  }, [t, i]), ne = P(async () => {
    const N = i;
    if (!(N != null && N.roomName)) {
      u(!1), r("active");
      return;
    }
    try {
      await Me(
        `${t}/api/v1/voice/livekit/call/${encodeURIComponent(N.roomName)}/hold`,
        { method: "POST", body: JSON.stringify({ hold: !1 }) }
      ), u(!1), r("active");
    } catch (E) {
      T(E instanceof Error ? E.message : "Resume failed");
    }
  }, [t, i]), ee = P((N) => {
    c(N);
  }, []), oe = P(async (N) => {
    const E = i;
    if (!(E != null && E.roomName)) {
      T("Transfer unavailable — no active room");
      return;
    }
    if (!N.trim()) {
      T("Enter a transfer destination");
      return;
    }
    try {
      const G = /^\d{3,6}$/.test(N.trim()) ? "extension" : "phone_number";
      await Me(
        `${t}/api/v1/voice/call-controls/calls/${encodeURIComponent(E.roomName)}/transfer`,
        {
          method: "POST",
          body: JSON.stringify({
            transfer_type: "blind",
            destination: N.trim(),
            destination_type: G
          })
        }
      ), r("transferred"), a(null), B();
    } catch (G) {
      T(G instanceof Error ? G.message : "Transfer failed");
    }
  }, [t, i, B]), X = P(async () => {
    const N = i;
    if (!(N != null && N.roomName)) {
      m(!0), r("held");
      return;
    }
    try {
      await Me(
        `${t}/api/v1/voice/livekit/call/${encodeURIComponent(N.roomName)}/hold`,
        { method: "POST", body: JSON.stringify({ hold: !0 }) }
      ), await Me(
        `${t}/api/v1/voice/call-controls/calls/${encodeURIComponent(N.roomName)}/moh`,
        { method: "POST", body: JSON.stringify({ enabled: !0 }) }
      ).catch(() => {
      }), m(!0), u(!0), r("held");
    } catch (E) {
      T(E instanceof Error ? E.message : "Park failed");
    }
  }, [t, i]), De = q(null), ie = P(async () => {
    var N;
    if (De.current) return De.current;
    try {
      const G = ((N = (await Me(
        `${t}/api/v1/voice/sms?direction=outbound&limit=1`
      )).messages[0]) == null ? void 0 : N.from) ?? null;
      return De.current = G, G;
    } catch {
      return null;
    }
  }, [t]), dt = P(async (N, E) => {
    if (!N.trim() || !E.trim()) {
      T("To and message are required");
      return;
    }
    T(null);
    try {
      const G = await ie();
      if (!G) {
        T("No outbound number configured. Send an SMS from the Voice app first.");
        return;
      }
      await Me(`${t}/api/v1/voice/sms`, {
        method: "POST",
        body: JSON.stringify({ from: G, to: N.trim(), text: E.trim() })
      }), U();
    } catch (G) {
      T(G instanceof Error ? G.message : "Send failed");
    }
  }, [t, U, ie]), te = P(() => T(null), []);
  return {
    status: o,
    currentCall: i,
    isMuted: d,
    isHeld: p,
    isParked: y,
    duration: S,
    recentCalls: w,
    smsThreads: C,
    loadingRecents: _,
    loadingThreads: g,
    error: L,
    makeCall: J,
    acceptCall: R,
    declineCall: K,
    holdCall: $,
    resumeCall: ne,
    muteCall: ee,
    transferCall: oe,
    parkCall: X,
    hangUp: re,
    sendSms: dt,
    listThreadMessages: W,
    refreshRecents: B,
    refreshThreads: U,
    clearError: te
  };
}
function Ji(t) {
  return t.isPlatformOwner === !0 ? !0 : Array.isArray(t.entitlements) && t.entitlements.includes("voice");
}
function Ho(t) {
  const n = Math.floor(t / 60), o = t % 60;
  return `${n}:${o.toString().padStart(2, "0")}`;
}
function An(t) {
  if (!t) return "";
  const n = new Date(t), r = ((/* @__PURE__ */ new Date()).getTime() - n.getTime()) / 1e3;
  return r < 60 ? "just now" : r < 3600 ? `${Math.floor(r / 60)}m` : r < 86400 ? `${Math.floor(r / 3600)}h` : r < 604800 ? `${Math.floor(r / 86400)}d` : n.toLocaleDateString(void 0, { month: "short", day: "numeric" });
}
const Xi = [
  { digit: "1" },
  { digit: "2", letters: "ABC" },
  { digit: "3", letters: "DEF" },
  { digit: "4", letters: "GHI" },
  { digit: "5", letters: "JKL" },
  { digit: "6", letters: "MNO" },
  { digit: "7", letters: "PQRS" },
  { digit: "8", letters: "TUV" },
  { digit: "9", letters: "WXYZ" },
  { digit: "*" },
  { digit: "0", letters: "+" },
  { digit: "#" }
], k = {
  bg: "#0f172a",
  surface: "#1e293b",
  surfaceHi: "#334155",
  border: "#334155",
  text: "#f1f5f9",
  muted: "#94a3b8",
  green: "#22c55e",
  red: "#ef4444",
  blue: "#3b82f6"
};
function Qi({
  value: t,
  onChange: n,
  onCall: o,
  onSms: r
}) {
  const i = (d) => n(t + d), a = () => n(t.slice(0, -1));
  return /* @__PURE__ */ s("div", { style: { display: "flex", flexDirection: "column", flex: 1, padding: 12, gap: 12 }, children: [
    /* @__PURE__ */ s("div", { style: { display: "flex", gap: 6 }, children: [
      /* @__PURE__ */ e(
        "input",
        {
          style: {
            flex: 1,
            background: k.surface,
            border: `1px solid ${k.border}`,
            borderRadius: 8,
            padding: "10px 12px",
            color: k.text,
            fontSize: 18,
            fontFamily: "ui-monospace, SFMono-Regular, monospace",
            outline: "none"
          },
          value: t,
          onChange: (d) => n(d.target.value),
          placeholder: "Enter number or name",
          "aria-label": "Phone number or name"
        }
      ),
      /* @__PURE__ */ e(
        "button",
        {
          onClick: a,
          disabled: !t,
          style: {
            background: k.surface,
            border: `1px solid ${k.border}`,
            color: k.text,
            borderRadius: 8,
            padding: "0 12px",
            cursor: t ? "pointer" : "not-allowed",
            opacity: t ? 1 : 0.4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          "aria-label": "Backspace",
          title: "Backspace",
          children: /* @__PURE__ */ e(br, { size: 16 })
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { style: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 8,
      flex: 1
    }, children: Xi.map((d) => /* @__PURE__ */ s(
      "button",
      {
        onClick: () => i(d.digit),
        style: {
          background: k.surface,
          border: `1px solid ${k.border}`,
          borderRadius: 10,
          color: k.text,
          cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 8,
          transition: "background 0.12s",
          minHeight: 48
        },
        onMouseEnter: (c) => {
          c.currentTarget.style.background = k.surfaceHi;
        },
        onMouseLeave: (c) => {
          c.currentTarget.style.background = k.surface;
        },
        "aria-label": `Dial ${d.digit}`,
        children: [
          /* @__PURE__ */ e("span", { style: { fontSize: 20, fontWeight: 600 }, children: d.digit }),
          d.letters && /* @__PURE__ */ e("span", { style: { fontSize: 9, color: k.muted, letterSpacing: 1 }, children: d.letters })
        ]
      },
      d.digit
    )) }),
    /* @__PURE__ */ s("div", { style: { display: "flex", gap: 8 }, children: [
      /* @__PURE__ */ s(
        "button",
        {
          onClick: () => o(t),
          disabled: !t.trim(),
          style: {
            flex: 1,
            background: k.green,
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "12px 0",
            cursor: t.trim() ? "pointer" : "not-allowed",
            opacity: t.trim() ? 1 : 0.4,
            fontSize: 14,
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 6
          },
          children: [
            /* @__PURE__ */ e(ct, { size: 16 }),
            " Call"
          ]
        }
      ),
      /* @__PURE__ */ s(
        "button",
        {
          onClick: () => r(t),
          disabled: !t.trim(),
          style: {
            flex: 1,
            background: k.blue,
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "12px 0",
            cursor: t.trim() ? "pointer" : "not-allowed",
            opacity: t.trim() ? 1 : 0.4,
            fontSize: 14,
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 6
          },
          children: [
            /* @__PURE__ */ e(Et, { size: 16 }),
            " SMS"
          ]
        }
      )
    ] })
  ] });
}
function Zi({
  phone: t
}) {
  const {
    currentCall: n,
    status: o,
    duration: r,
    isMuted: i,
    isHeld: a,
    muteCall: d,
    holdCall: c,
    resumeCall: p,
    transferCall: u,
    parkCall: y,
    hangUp: m
  } = t, [S, b] = x(!1), [w, f] = x("");
  if (!n) return null;
  const C = n.direction === "inbound" ? n.callerName || n.from : n.to, I = n.direction === "inbound" ? /* @__PURE__ */ e(zn, { size: 14 }) : /* @__PURE__ */ e(To, { size: 14 });
  return /* @__PURE__ */ s("div", { style: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: 20,
    gap: 16,
    alignItems: "center"
  }, children: [
    /* @__PURE__ */ s("div", { style: { textAlign: "center" }, children: [
      /* @__PURE__ */ s("div", { style: {
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontSize: 12,
        color: k.muted,
        textTransform: "uppercase",
        letterSpacing: 1
      }, children: [
        I,
        n.direction === "inbound" ? "Inbound" : "Outbound",
        o === "held" && " · On Hold"
      ] }),
      /* @__PURE__ */ e("div", { style: {
        fontSize: 22,
        fontWeight: 600,
        color: k.text,
        marginTop: 6,
        fontFamily: "ui-monospace, SFMono-Regular, monospace"
      }, children: C || "Unknown" }),
      /* @__PURE__ */ e("div", { style: {
        fontSize: 28,
        color: k.muted,
        marginTop: 4,
        fontFamily: "ui-monospace, SFMono-Regular, monospace"
      }, children: Ho(r) })
    ] }),
    S ? /* @__PURE__ */ s("div", { style: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      width: "100%",
      background: k.surface,
      border: `1px solid ${k.border}`,
      borderRadius: 10,
      padding: 12
    }, children: [
      /* @__PURE__ */ s("div", { style: { display: "flex", alignItems: "center", gap: 6 }, children: [
        /* @__PURE__ */ e(
          "button",
          {
            onClick: () => b(!1),
            style: {
              background: "transparent",
              border: "none",
              color: k.muted,
              cursor: "pointer",
              padding: 4,
              display: "flex",
              alignItems: "center"
            },
            "aria-label": "Back",
            children: /* @__PURE__ */ e(Mo, { size: 14 })
          }
        ),
        /* @__PURE__ */ e("span", { style: { fontSize: 12, color: k.muted }, children: "Blind transfer to…" })
      ] }),
      /* @__PURE__ */ e(
        "input",
        {
          style: {
            background: k.bg,
            border: `1px solid ${k.border}`,
            borderRadius: 8,
            padding: "8px 10px",
            color: k.text,
            outline: "none",
            fontSize: 14,
            fontFamily: "ui-monospace, SFMono-Regular, monospace"
          },
          value: w,
          onChange: (_) => f(_.target.value),
          placeholder: "Ext or phone number",
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ e(
        "button",
        {
          onClick: () => {
            u(w), b(!1), f("");
          },
          disabled: !w.trim(),
          style: {
            background: k.blue,
            color: "#fff",
            border: "none",
            borderRadius: 8,
            padding: "8px 0",
            cursor: w.trim() ? "pointer" : "not-allowed",
            opacity: w.trim() ? 1 : 0.4,
            fontWeight: 600,
            fontSize: 13
          },
          children: "Transfer"
        }
      )
    ] }) : /* @__PURE__ */ s("div", { style: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 8,
      width: "100%"
    }, children: [
      /* @__PURE__ */ e(
        bt,
        {
          label: i ? "Unmute" : "Mute",
          icon: i ? /* @__PURE__ */ e(sr, { size: 16 }) : /* @__PURE__ */ e(Ht, { size: 16 }),
          onClick: () => d(!i),
          active: i
        }
      ),
      /* @__PURE__ */ e(
        bt,
        {
          label: a ? "Resume" : "Hold",
          icon: a ? /* @__PURE__ */ e(pr, { size: 16 }) : /* @__PURE__ */ e(dr, { size: 16 }),
          onClick: () => {
            a ? p() : c();
          },
          active: a
        }
      ),
      /* @__PURE__ */ e(
        bt,
        {
          label: "Transfer",
          icon: /* @__PURE__ */ e(cr, { size: 16 }),
          onClick: () => b(!0)
        }
      ),
      /* @__PURE__ */ e(
        bt,
        {
          label: "Park",
          icon: /* @__PURE__ */ e(ur, { size: 16 }),
          onClick: () => {
            y();
          }
        }
      ),
      /* @__PURE__ */ e(
        bt,
        {
          label: "Keypad",
          icon: /* @__PURE__ */ e(hr, { size: 16 }),
          onClick: () => {
          }
        }
      ),
      /* @__PURE__ */ e(
        bt,
        {
          label: "End",
          icon: /* @__PURE__ */ e(_o, { size: 16 }),
          onClick: () => {
            m();
          },
          tone: "danger"
        }
      )
    ] })
  ] });
}
function bt({
  label: t,
  icon: n,
  onClick: o,
  active: r,
  tone: i
}) {
  const a = i === "danger" ? k.red : r ? k.surfaceHi : k.surface, d = i === "danger" ? "#fff" : k.text;
  return /* @__PURE__ */ s(
    "button",
    {
      onClick: o,
      style: {
        background: a,
        color: d,
        border: `1px solid ${k.border}`,
        borderRadius: 10,
        padding: "10px 0",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
        fontSize: 11
      },
      children: [
        n,
        /* @__PURE__ */ e("span", { children: t })
      ]
    }
  );
}
function ea({
  phone: t,
  onCall: n
}) {
  const { recentCalls: o, loadingRecents: r, refreshRecents: i } = t;
  return /* @__PURE__ */ s("div", { style: { flex: 1, overflowY: "auto", padding: 8 }, children: [
    /* @__PURE__ */ s("div", { style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "4px 8px 8px"
    }, children: [
      /* @__PURE__ */ e("span", { style: { fontSize: 11, color: k.muted, textTransform: "uppercase", letterSpacing: 1 }, children: "Recent" }),
      /* @__PURE__ */ e(
        "button",
        {
          onClick: () => {
            i();
          },
          style: {
            background: "transparent",
            border: "none",
            color: k.muted,
            cursor: "pointer",
            fontSize: 11,
            padding: 2
          },
          children: "Refresh"
        }
      )
    ] }),
    r && o.length === 0 ? /* @__PURE__ */ e("div", { style: { textAlign: "center", color: k.muted, padding: 20, fontSize: 12 }, children: "Loading…" }) : o.length === 0 ? /* @__PURE__ */ e("div", { style: { textAlign: "center", color: k.muted, padding: 20, fontSize: 12 }, children: "No recent calls" }) : /* @__PURE__ */ e("div", { style: { display: "flex", flexDirection: "column" }, children: o.map((a) => {
      const d = a.direction.startsWith("inbound"), c = d ? a.fromNumber : a.toNumber, p = a.missed ? lr : d ? zn : To, u = a.missed ? k.red : d ? k.green : k.blue;
      return /* @__PURE__ */ s(
        "button",
        {
          onClick: () => c && n(c),
          style: {
            display: "flex",
            alignItems: "center",
            gap: 10,
            background: "transparent",
            border: "none",
            borderBottom: `1px solid ${k.border}`,
            padding: "10px 8px",
            cursor: "pointer",
            color: k.text,
            textAlign: "left"
          },
          onMouseEnter: (y) => {
            y.currentTarget.style.background = k.surface;
          },
          onMouseLeave: (y) => {
            y.currentTarget.style.background = "transparent";
          },
          children: [
            /* @__PURE__ */ e("span", { style: { color: u, display: "flex" }, children: /* @__PURE__ */ e(p, { size: 14 }) }),
            /* @__PURE__ */ s("div", { style: { flex: 1, minWidth: 0 }, children: [
              /* @__PURE__ */ e("div", { style: {
                fontSize: 13,
                color: k.text,
                fontWeight: 500,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }, children: c || "Unknown" }),
              /* @__PURE__ */ s("div", { style: { fontSize: 11, color: k.muted }, children: [
                An(a.startedAt),
                a.durationSecs != null && a.durationSecs > 0 && ` · ${Ho(a.durationSecs)}`
              ] })
            ] })
          ]
        },
        a.id
      );
    }) })
  ] });
}
function ta({
  phone: t,
  initialPeer: n
}) {
  const { smsThreads: o, loadingThreads: r, refreshThreads: i, listThreadMessages: a, sendSms: d } = t, [c, p] = x(n ?? null), [u, y] = x([]), [m, S] = x(""), [b, w] = x(!1);
  return V(() => {
    c && (w(!0), a(c).then((f) => {
      y(f.reverse()), w(!1);
    }));
  }, [c, a]), c ? /* @__PURE__ */ s("div", { style: { display: "flex", flexDirection: "column", flex: 1 }, children: [
    /* @__PURE__ */ s("div", { style: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      padding: "8px 12px",
      borderBottom: `1px solid ${k.border}`
    }, children: [
      /* @__PURE__ */ e(
        "button",
        {
          onClick: () => p(null),
          style: {
            background: "transparent",
            border: "none",
            color: k.muted,
            cursor: "pointer",
            padding: 4,
            display: "flex",
            alignItems: "center"
          },
          "aria-label": "Back",
          children: /* @__PURE__ */ e(Mo, { size: 14 })
        }
      ),
      /* @__PURE__ */ e("span", { style: {
        fontSize: 13,
        color: k.text,
        fontWeight: 500,
        fontFamily: "ui-monospace, SFMono-Regular, monospace"
      }, children: c })
    ] }),
    /* @__PURE__ */ e("div", { style: {
      flex: 1,
      overflowY: "auto",
      padding: 12,
      display: "flex",
      flexDirection: "column",
      gap: 6
    }, children: b ? /* @__PURE__ */ e("div", { style: { textAlign: "center", color: k.muted, fontSize: 12 }, children: "Loading…" }) : u.length === 0 ? /* @__PURE__ */ e("div", { style: { textAlign: "center", color: k.muted, fontSize: 12 }, children: "No messages" }) : u.map((f) => {
      const C = f.direction === "outbound";
      return /* @__PURE__ */ s("div", { style: {
        alignSelf: C ? "flex-end" : "flex-start",
        maxWidth: "80%",
        background: C ? k.blue : k.surface,
        color: C ? "#fff" : k.text,
        padding: "6px 10px",
        borderRadius: 12,
        fontSize: 13,
        border: C ? "none" : `1px solid ${k.border}`
      }, children: [
        f.body,
        /* @__PURE__ */ e("div", { style: {
          fontSize: 10,
          opacity: 0.7,
          marginTop: 3
        }, children: An(f.createdAt) })
      ] }, f.id);
    }) }),
    /* @__PURE__ */ s("div", { style: {
      display: "flex",
      gap: 6,
      padding: 8,
      borderTop: `1px solid ${k.border}`
    }, children: [
      /* @__PURE__ */ e(
        "input",
        {
          style: {
            flex: 1,
            background: k.surface,
            border: `1px solid ${k.border}`,
            borderRadius: 8,
            padding: "8px 10px",
            color: k.text,
            outline: "none",
            fontSize: 13
          },
          value: m,
          onChange: (f) => S(f.target.value),
          onKeyDown: (f) => {
            f.key === "Enter" && m.trim() && (d(c, m.trim()).then(() => a(c).then((C) => {
              y(C.reverse());
            })), S(""));
          },
          placeholder: "Type a message…",
          maxLength: 1600
        }
      ),
      /* @__PURE__ */ e(
        "button",
        {
          onClick: () => {
            m.trim() && (d(c, m.trim()).then(() => a(c).then((f) => {
              y(f.reverse());
            })), S(""));
          },
          disabled: !m.trim(),
          style: {
            background: k.blue,
            color: "#fff",
            border: "none",
            borderRadius: 8,
            padding: "0 12px",
            cursor: m.trim() ? "pointer" : "not-allowed",
            opacity: m.trim() ? 1 : 0.4,
            display: "flex",
            alignItems: "center"
          },
          "aria-label": "Send",
          children: /* @__PURE__ */ e(fr, { size: 14 })
        }
      )
    ] })
  ] }) : /* @__PURE__ */ s("div", { style: { flex: 1, overflowY: "auto", padding: 8 }, children: [
    /* @__PURE__ */ s("div", { style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "4px 8px 8px"
    }, children: [
      /* @__PURE__ */ e("span", { style: { fontSize: 11, color: k.muted, textTransform: "uppercase", letterSpacing: 1 }, children: "Threads" }),
      /* @__PURE__ */ e(
        "button",
        {
          onClick: () => {
            i();
          },
          style: {
            background: "transparent",
            border: "none",
            color: k.muted,
            cursor: "pointer",
            fontSize: 11,
            padding: 2
          },
          children: "Refresh"
        }
      )
    ] }),
    r && o.length === 0 ? /* @__PURE__ */ e("div", { style: { textAlign: "center", color: k.muted, padding: 20, fontSize: 12 }, children: "Loading…" }) : o.length === 0 ? /* @__PURE__ */ e("div", { style: { textAlign: "center", color: k.muted, padding: 20, fontSize: 12 }, children: "No SMS threads" }) : o.map((f) => /* @__PURE__ */ s(
      "button",
      {
        onClick: () => p(f.peer),
        style: {
          display: "flex",
          alignItems: "center",
          gap: 10,
          background: "transparent",
          border: "none",
          borderBottom: `1px solid ${k.border}`,
          padding: "10px 8px",
          cursor: "pointer",
          color: k.text,
          textAlign: "left",
          width: "100%"
        },
        onMouseEnter: (C) => {
          C.currentTarget.style.background = k.surface;
        },
        onMouseLeave: (C) => {
          C.currentTarget.style.background = "transparent";
        },
        children: [
          /* @__PURE__ */ e("span", { style: { color: k.blue, display: "flex" }, children: /* @__PURE__ */ e(Et, { size: 14 }) }),
          /* @__PURE__ */ s("div", { style: { flex: 1, minWidth: 0 }, children: [
            /* @__PURE__ */ e("div", { style: {
              fontSize: 13,
              color: k.text,
              fontWeight: 500,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }, children: f.peer }),
            /* @__PURE__ */ e("div", { style: {
              fontSize: 11,
              color: k.muted,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }, children: f.lastMessagePreview })
          ] }),
          /* @__PURE__ */ e("span", { style: { fontSize: 10, color: k.muted }, children: An(f.lastMessageAt) })
        ]
      },
      f.peer
    ))
  ] });
}
function na({
  phone: t
}) {
  const { currentCall: n, status: o, acceptCall: r, declineCall: i } = t;
  return o !== "ringing" || !n ? null : Ut(
    /* @__PURE__ */ s(
      "div",
      {
        style: {
          position: "fixed",
          top: 70,
          left: "50%",
          transform: "translateX(-50%)",
          background: k.bg,
          border: `1px solid ${k.border}`,
          borderRadius: 12,
          boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
          padding: 14,
          minWidth: 320,
          color: k.text,
          zIndex: 1e5,
          display: "flex",
          flexDirection: "column",
          gap: 10,
          animation: "hb-phone-ring 1s ease-in-out infinite"
        },
        role: "dialog",
        "aria-label": "Incoming call",
        children: [
          /* @__PURE__ */ e("style", { children: `
        @keyframes hb-phone-ring {
          0%, 100% { box-shadow: 0 10px 30px rgba(0,0,0,0.5), 0 0 0 0 rgba(34,197,94,0.4); }
          50% { box-shadow: 0 10px 30px rgba(0,0,0,0.5), 0 0 0 8px rgba(34,197,94,0); }
        }
      ` }),
          /* @__PURE__ */ s("div", { style: { display: "flex", alignItems: "center", gap: 10 }, children: [
            /* @__PURE__ */ e("div", { style: {
              width: 36,
              height: 36,
              borderRadius: "50%",
              background: k.green,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }, children: /* @__PURE__ */ e(zn, { size: 18, color: "#fff" }) }),
            /* @__PURE__ */ s("div", { style: { flex: 1, minWidth: 0 }, children: [
              /* @__PURE__ */ e("div", { style: { fontSize: 11, color: k.muted, textTransform: "uppercase", letterSpacing: 1 }, children: "Incoming call" }),
              /* @__PURE__ */ e("div", { style: {
                fontSize: 15,
                fontWeight: 600,
                color: k.text,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }, children: n.callerName || n.from || "Unknown" })
            ] })
          ] }),
          /* @__PURE__ */ s("div", { style: { display: "flex", gap: 8 }, children: [
            /* @__PURE__ */ s(
              "button",
              {
                onClick: () => {
                  i();
                },
                style: {
                  flex: 1,
                  background: k.red,
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 0",
                  cursor: "pointer",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6
                },
                children: [
                  /* @__PURE__ */ e(_o, { size: 14 }),
                  " Decline"
                ]
              }
            ),
            /* @__PURE__ */ s(
              "button",
              {
                onClick: () => {
                  r();
                },
                style: {
                  flex: 1,
                  background: k.green,
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 0",
                  cursor: "pointer",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6
                },
                children: [
                  /* @__PURE__ */ e(ct, { size: 14 }),
                  " Accept"
                ]
              }
            )
          ] })
        ]
      }
    ),
    document.body
  );
}
function oa({
  phone: t,
  onClose: n
}) {
  const [o, r] = x("dialpad"), [i, a] = x(""), [d, c] = x(void 0), p = q(null);
  V(() => {
    const S = (w) => {
      p.current && !p.current.contains(w.target) && n();
    }, b = setTimeout(() => document.addEventListener("mousedown", S), 0);
    return () => {
      clearTimeout(b), document.removeEventListener("mousedown", S);
    };
  }, [n]), V(() => {
    const S = (b) => {
      b.key === "Escape" && n();
    };
    return document.addEventListener("keydown", S), () => document.removeEventListener("keydown", S);
  }, [n]);
  const u = (S) => {
    t.makeCall(S);
  }, y = (S) => {
    c(S), r("sms");
  }, m = t.status === "active" || t.status === "held" || t.status === "transferred";
  return Ut(
    /* @__PURE__ */ s(
      "div",
      {
        ref: p,
        style: {
          position: "fixed",
          top: 60,
          right: 12,
          width: 320,
          height: 480,
          background: k.bg,
          border: `1px solid ${k.border}`,
          borderRadius: 12,
          boxShadow: "0 20px 50px rgba(0,0,0,0.6)",
          color: k.text,
          zIndex: 99999,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        },
        role: "dialog",
        "aria-label": "Softphone",
        children: [
          /* @__PURE__ */ s("div", { style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 12px",
            borderBottom: `1px solid ${k.border}`
          }, children: [
            /* @__PURE__ */ s("div", { style: { display: "flex", alignItems: "center", gap: 8 }, children: [
              /* @__PURE__ */ e(ct, { size: 14 }),
              /* @__PURE__ */ e("span", { style: { fontSize: 13, fontWeight: 600 }, children: "Phone" })
            ] }),
            /* @__PURE__ */ e(
              "button",
              {
                onClick: n,
                style: {
                  background: "transparent",
                  border: "none",
                  color: k.muted,
                  cursor: "pointer",
                  padding: 4,
                  display: "flex"
                },
                "aria-label": "Close",
                children: /* @__PURE__ */ e(Ke, { size: 14 })
              }
            )
          ] }),
          t.error && /* @__PURE__ */ s("div", { style: {
            background: "rgba(239,68,68,0.1)",
            borderBottom: `1px solid ${k.red}`,
            padding: "6px 12px",
            fontSize: 12,
            color: "#fca5a5",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 6
          }, children: [
            /* @__PURE__ */ e("span", { style: { flex: 1 }, children: t.error }),
            /* @__PURE__ */ e(
              "button",
              {
                onClick: t.clearError,
                style: {
                  background: "transparent",
                  border: "none",
                  color: "#fca5a5",
                  cursor: "pointer",
                  padding: 2,
                  display: "flex"
                },
                "aria-label": "Dismiss error",
                children: /* @__PURE__ */ e(Ke, { size: 12 })
              }
            )
          ] }),
          !m && /* @__PURE__ */ e("div", { style: {
            display: "flex",
            borderBottom: `1px solid ${k.border}`
          }, children: ["dialpad", "recent", "sms"].map((S) => /* @__PURE__ */ e(
            "button",
            {
              onClick: () => r(S),
              style: {
                flex: 1,
                background: "transparent",
                border: "none",
                color: o === S ? k.text : k.muted,
                borderBottom: `2px solid ${o === S ? k.blue : "transparent"}`,
                padding: "8px 0",
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                textTransform: "capitalize"
              },
              children: S
            },
            S
          )) }),
          m ? /* @__PURE__ */ e(Zi, { phone: t }) : o === "dialpad" ? /* @__PURE__ */ e(Qi, { value: i, onChange: a, onCall: u, onSms: y }) : o === "recent" ? /* @__PURE__ */ e(ea, { phone: t, onCall: (S) => {
            a(S), r("dialpad"), t.makeCall(S);
          } }) : /* @__PURE__ */ e(ta, { phone: t, initialPeer: d })
        ]
      }
    ),
    document.body
  );
}
function ra({ session: t, apiBase: n }) {
  const o = Sn(() => Ji(t), [t]), [r, i] = x(!1), a = Bi({
    apiBase: n,
    orgId: o && t.tenantId || null
  });
  if (V(() => {
    a.status === "active" && i(!0);
  }, [a.status]), !o) return null;
  const d = a.status === "active" || a.status === "held", c = a.status === "ringing";
  return /* @__PURE__ */ s(he, { children: [
    /* @__PURE__ */ e("div", { style: { position: "relative", flexShrink: 0 }, children: /* @__PURE__ */ s(
      "button",
      {
        onClick: () => i((p) => !p),
        "aria-label": "Softphone",
        "aria-expanded": r,
        title: "Softphone",
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 36,
          height: 36,
          background: "transparent",
          border: "none",
          borderRadius: 8,
          cursor: "pointer",
          color: c ? k.red : d ? k.green : "#94a3b8",
          transition: "background 0.15s, color 0.15s",
          position: "relative"
        },
        onMouseEnter: (p) => {
          p.currentTarget.style.background = "rgba(255,255,255,0.04)";
        },
        onMouseLeave: (p) => {
          p.currentTarget.style.background = "transparent";
        },
        children: [
          /* @__PURE__ */ e(ct, { size: 18 }),
          c && /* @__PURE__ */ s(he, { children: [
            /* @__PURE__ */ e("style", { children: `
                @keyframes hb-phone-badge-pulse {
                  0%, 100% { transform: scale(1); opacity: 1; }
                  50% { transform: scale(1.2); opacity: 0.75; }
                }
              ` }),
            /* @__PURE__ */ e(
              "span",
              {
                "aria-hidden": "true",
                style: {
                  position: "absolute",
                  top: 6,
                  right: 6,
                  width: 8,
                  height: 8,
                  background: k.red,
                  borderRadius: "50%",
                  animation: "hb-phone-badge-pulse 1s ease-in-out infinite"
                }
              }
            )
          ] }),
          !c && d && /* @__PURE__ */ e(
            "span",
            {
              "aria-hidden": "true",
              style: {
                position: "absolute",
                top: 6,
                right: 6,
                width: 8,
                height: 8,
                background: k.green,
                borderRadius: "50%"
              }
            }
          )
        ]
      }
    ) }),
    r && /* @__PURE__ */ e(oa, { phone: a, onClose: () => i(!1) }),
    /* @__PURE__ */ e(na, { phone: a })
  ] });
}
function ia() {
  return /* @__PURE__ */ e(
    "svg",
    {
      className: "hb-logo-bird",
      width: "22",
      height: "22",
      viewBox: "0 0 1200 1200",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true",
      children: /* @__PURE__ */ e("g", { transform: "scale(13.5) translate(-5.5555488798353405, -5.55552503797743)", children: /* @__PURE__ */ e("g", { fill: "#f97316", children: /* @__PURE__ */ e("g", { transform: "translate(0,-952.36218)", children: /* @__PURE__ */ e("path", { d: "m 60.7828,964.36215 27.1809,0.8834 -27.1809,25.9958 z m -1.9745,1.4513 0,26.7845 -25.2681,0 c 8.6166,-8.7334 16.8796,-17.8103 25.2681,-26.7845 z m 27.7053,3.628 3.4864,1.1989 -12.5877,7.4768 z m -68.1835,2.9656 5.5226,0 12.8654,14.0705 -5.9854,6.1204 -12.4026,0 c 9e-4,-6.7347 0,-13.4597 0,-20.1909 z m -1.9746,1.2304 0,5.8364 -6.3555,0 z m 3.363,20.9796 38.627,0 -10.7675,29.43465 z m 39.0898,4.54286 0,41.20229 -12.5878,-6.8775 c 4.1972,-11.443 8.3886,-22.879 12.5878,-34.32479 z" }) }) }) })
    }
  );
}
function pa({
  currentProduct: t,
  apiBase: n,
  signalrEndpoint: o,
  session: r,
  onLogout: i,
  hubUrl: a = gt,
  chatSlot: d,
  supportConfig: c,
  orgBranding: p
}) {
  const u = Ko(r, n), y = q(!1);
  return V(() => {
    if (y.current || (y.current = !0, document.getElementById("hb-styles"))) return;
    const m = document.createElement("style");
    m.id = "hb-styles", m.textContent = Fo, document.head.appendChild(m);
  }, []), V(() => {
    const m = document.body.style.paddingTop;
    return document.body.style.paddingTop = `${Wo}px`, () => {
      document.body.style.paddingTop = m;
    };
  }, []), u ? $o(u) ? /* @__PURE__ */ e(
    aa,
    {
      currentProduct: t,
      apiBase: n,
      session: u,
      onLogout: i,
      hubUrl: a,
      orgBranding: p
    }
  ) : /* @__PURE__ */ e(
    sa,
    {
      currentProduct: t,
      apiBase: n,
      signalrEndpoint: o,
      session: u,
      onLogout: i,
      hubUrl: a,
      chatSlot: d,
      supportConfig: c,
      orgBranding: p
    }
  ) : /* @__PURE__ */ e("div", { className: "hb-root", role: "banner", children: /* @__PURE__ */ e("div", { className: "hb-bar hb-bar--guest", "aria-hidden": "true" }) });
}
function aa({
  currentProduct: t,
  apiBase: n,
  session: o,
  onLogout: r,
  hubUrl: i = gt,
  orgBranding: a
}) {
  var w;
  const { products: d } = ko(n, o.tenantId ?? null, o.isPlatformOwner), [c, p] = x(!1), [u, y] = x(!1), [m, S] = x(!1), b = d.filter(
    (f) => {
      var C;
      return ((C = o.entitlements) == null ? void 0 : C.includes(f.id)) || f.active;
    }
  );
  return /* @__PURE__ */ s("div", { className: "hb-root", role: "banner", children: [
    /* @__PURE__ */ e(
      Yi,
      {
        open: u,
        onClose: () => y(!1),
        apiBase: n,
        tenantId: o.tenantId ?? null,
        session: { userId: o.userId, email: o.email, firstName: o.firstName }
      }
    ),
    /* @__PURE__ */ s(
      "div",
      {
        className: "hb-bar hb-bar--portal",
        style: (w = a == null ? void 0 : a.colors) != null && w.header_bg ? {
          background: a.colors.header_bg,
          color: a.colors.header_text || "#f1f5f9"
        } : void 0,
        children: [
          b.length > 0 && /* @__PURE__ */ e(
            No,
            {
              currentProduct: t,
              products: b,
              open: c,
              onToggle: () => {
                S(!1), p((f) => !f);
              },
              onClose: () => p(!1),
              hubUrl: i,
              apiBase: n
            }
          ),
          /* @__PURE__ */ e(
            "a",
            {
              href: `${i}/portal`,
              className: "hb-logo",
              "aria-label": (a == null ? void 0 : a.company_name) ?? "Customer Portal",
              children: a != null && a.logo_icon_url || a != null && a.logo_url ? /* @__PURE__ */ e(
                "img",
                {
                  src: a.logo_icon_url || a.logo_url,
                  alt: a.company_name || "Logo",
                  style: { height: "22px", maxWidth: "120px", objectFit: "contain" }
                }
              ) : /* @__PURE__ */ e("span", { style: { fontSize: "13px", fontWeight: "600", color: "#f1f5f9" }, children: (a == null ? void 0 : a.company_name) ?? o.tenantName })
            }
          ),
          /* @__PURE__ */ e("div", { className: "hb-spacer" }),
          /* @__PURE__ */ e(Ki, { open: u, onToggle: () => y((f) => !f) }),
          /* @__PURE__ */ e(
            Ao,
            {
              session: o,
              open: m,
              onToggle: () => {
                p(!1), S((f) => !f);
              },
              onClose: () => S(!1),
              onLogout: r,
              hubUrl: i
            }
          )
        ]
      }
    )
  ] });
}
function sa({
  currentProduct: t,
  apiBase: n,
  signalrEndpoint: o,
  session: r,
  onLogout: i,
  hubUrl: a = gt,
  chatSlot: d,
  supportConfig: c,
  orgBranding: p
}) {
  var re;
  const { products: u } = ko(n, r.tenantId ?? null, r.isPlatformOwner), { notifications: y, unreadCount: m, markAllRead: S, markRead: b, dismiss: w, muted: f, muteUntil: C, unmute: I, toastQueue: _, dismissToast: A } = qo(
    n,
    o,
    r.tenantId ?? null,
    r.userId ?? null
  ), { orgs: g, switchOrg: z } = Bo(n, r.userId ?? null), [L, T] = x(!1), [H, j] = x(!1), [B, U] = x(!1), [W, J] = x(!1), [R, K] = x(!1);
  return V(() => {
    function $(ne) {
      (ne.metaKey || ne.ctrlKey) && ne.key === "k" && (ne.preventDefault(), K((ee) => !ee)), ne.key === "Escape" && K(!1);
    }
    return window.addEventListener("keydown", $), () => window.removeEventListener("keydown", $);
  }, []), /* @__PURE__ */ s("div", { className: "hb-root", role: "banner", children: [
    /* @__PURE__ */ e(
      $i,
      {
        open: R,
        onClose: () => K(!1),
        apiBase: n,
        currentProduct: t,
        tenantId: r.tenantId ?? null,
        activeProducts: u.filter(($) => ($.launch_status === "ga" || $.launch_status === "beta_invite") && ($.active || $.has_beta_access)).map(($) => $.id)
      }
    ),
    /* @__PURE__ */ e(Tr, { toasts: _, onDismiss: A }),
    /* @__PURE__ */ s(
      "div",
      {
        className: "hb-bar",
        style: (re = p == null ? void 0 : p.colors) != null && re.header_bg ? {
          background: p.colors.header_bg,
          color: p.colors.header_text || "#f1f5f9"
        } : void 0,
        children: [
          /* @__PURE__ */ e(
            No,
            {
              currentProduct: t,
              products: u,
              open: L,
              onToggle: () => {
                j(!1), J(!1), T(($) => !$);
              },
              onClose: () => T(!1),
              hubUrl: a,
              apiBase: n
            }
          ),
          /* @__PURE__ */ s("a", { href: a, className: "hb-logo", "aria-label": p != null && p.company_name ? `${p.company_name} — Home` : "The One Stack — Home", children: [
            p != null && p.logo_icon_url || p != null && p.logo_url ? /* @__PURE__ */ e(
              "img",
              {
                src: p.logo_icon_url || p.logo_url,
                alt: p.company_name || "Logo",
                style: { height: 22, width: "auto", objectFit: "contain" }
              }
            ) : /* @__PURE__ */ e(ia, {}),
            /* @__PURE__ */ e("span", { className: "hb-logo-name", children: (p == null ? void 0 : p.company_name) || "The One" })
          ] }),
          /* @__PURE__ */ e("div", { className: "hb-divider", "aria-hidden": "true" }),
          (() => {
            const $ = u.find((ne) => ne.id === t);
            return $ ? /* @__PURE__ */ e("span", { style: { fontSize: 14, fontWeight: 500, color: "#f1f5f9", whiteSpace: "nowrap" }, children: $.name }) : null;
          })(),
          /* @__PURE__ */ e("div", { style: { flex: 1 } }),
          /* @__PURE__ */ e(vr, { apiBase: n, tenantId: (r == null ? void 0 : r.tenantId) ?? null }),
          /* @__PURE__ */ e("div", { style: { flex: 1 } }),
          /* @__PURE__ */ e(Ui, { products: u, hubUrl: a }),
          c ? /* @__PURE__ */ e(
            _r,
            {
              config: c,
              currentProduct: t,
              hubUrl: a,
              user: {
                email: (r == null ? void 0 : r.email) ?? "",
                name: r ? `${r.firstName ?? ""} ${r.lastName ?? ""}`.trim() || r.email : ""
              }
            }
          ) : d ?? null,
          /* @__PURE__ */ e(
            Vi,
            {
              apiBase: n,
              tenantId: r.tenantId ?? null,
              userId: r.userId ?? null,
              currentProduct: t
            }
          ),
          /* @__PURE__ */ e(
            hi,
            {
              apiBase: n,
              tenantId: r.tenantId ?? null,
              userId: r.userId ?? null,
              currentProduct: t,
              entitlements: r.entitlements
            }
          ),
          /* @__PURE__ */ e(
            ki,
            {
              apiBase: n,
              tenantId: r.tenantId ?? null,
              userId: r.userId ?? null,
              hubUrl: a,
              open: B,
              onToggle: () => {
                T(!1), j(!1), J(!1), U(($) => !$);
              },
              onClose: () => U(!1)
            }
          ),
          /* @__PURE__ */ e(ra, { session: r, apiBase: n }),
          /* @__PURE__ */ e(
            Sr,
            {
              notifications: y,
              unreadCount: m,
              open: H,
              onToggle: () => {
                T(!1), J(!1), j(($) => !$);
              },
              onClose: () => j(!1),
              onMarkAllRead: S,
              onMarkRead: b,
              onDismiss: w,
              muted: f,
              onMute: C,
              onUnmute: I,
              hubUrl: a
            }
          ),
          r.tenantName && /* @__PURE__ */ e(
            "button",
            {
              className: "hb-org-chip",
              onClick: () => {
                T(!1), j(!1), J(($) => !$);
              },
              title: `Current org: ${r.tenantName}`,
              children: r.tenantName
            }
          ),
          /* @__PURE__ */ e(
            Ao,
            {
              session: r,
              open: W,
              onToggle: () => {
                T(!1), j(!1), J(($) => !$);
              },
              onClose: () => J(!1),
              onLogout: i,
              hubUrl: a,
              orgs: g,
              onSwitchOrg: z
            }
          )
        ]
      }
    )
  ] });
}
export {
  Uo as ALL_PRODUCTS,
  Vi as GatherButton,
  Wo as HUB_BAR_HEIGHT,
  gt as HUB_URL,
  pa as HubBar,
  hi as JarvisButton,
  Ki as MiniTheoButton,
  Yi as MiniTheoPanel,
  Sr as NotificationBell,
  Tr as NotificationToast,
  ra as PhoneModule,
  No as ProductSwitcher,
  Tn as SEVERITY_COLORS,
  _r as SupportButton,
  vr as UnifiedSearch,
  Ao as UserMenu,
  $o as isClientPortalUser,
  Vo as readHubIdentityCookie,
  Ko as useHubSession,
  ni as useJarvis,
  qo as useNotifications,
  Bi as usePhoneModule,
  ko as useProducts,
  yr as useSearch
};
